(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["Give"] = factory(require("jQuery"));
	else
		root["Give"] = factory(root["jQuery"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 25);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["accounting"] = __webpack_require__(3);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
;(function (factory) { 
if (true) { 
 // AMD. Register as an anonymous module. 
 !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); 
 } else if (typeof exports === 'object') { 
 // Node/CommonJS 
 factory(require('jquery')); 
 } else { 
 // Browser globals 
 factory(window.jQuery || window.Zepto); 
 } 
 }(function($) { 

/*>>core*/
/**
 * 
 * Magnific Popup Core JS file
 * 
 */


/**
 * Private static constants
 */
var CLOSE_EVENT = 'Close',
	BEFORE_CLOSE_EVENT = 'BeforeClose',
	AFTER_CLOSE_EVENT = 'AfterClose',
	BEFORE_APPEND_EVENT = 'BeforeAppend',
	MARKUP_PARSE_EVENT = 'MarkupParse',
	OPEN_EVENT = 'Open',
	CHANGE_EVENT = 'Change',
	NS = 'mfp',
	EVENT_NS = '.' + NS,
	READY_CLASS = 'mfp-ready',
	REMOVING_CLASS = 'mfp-removing',
	PREVENT_CLOSE_CLASS = 'mfp-prevent-close';


/**
 * Private vars 
 */
/*jshint -W079 */
var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
	MagnificPopup = function(){},
	_isJQ = !!(window.jQuery),
	_prevStatus,
	_window = $(window),
	_document,
	_prevContentType,
	_wrapClasses,
	_currPopupType;


/**
 * Private functions
 */
var _mfpOn = function(name, f) {
		mfp.ev.on(NS + name + EVENT_NS, f);
	},
	_getEl = function(className, appendTo, html, raw) {
		var el = document.createElement('div');
		el.className = 'mfp-'+className;
		if(html) {
			el.innerHTML = html;
		}
		if(!raw) {
			el = $(el);
			if(appendTo) {
				el.appendTo(appendTo);
			}
		} else if(appendTo) {
			appendTo.appendChild(el);
		}
		return el;
	},
	_mfpTrigger = function(e, data) {
		mfp.ev.triggerHandler(NS + e, data);

		if(mfp.st.callbacks) {
			// converts "mfpEventName" to "eventName" callback and triggers it if it's present
			e = e.charAt(0).toLowerCase() + e.slice(1);
			if(mfp.st.callbacks[e]) {
				mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
			}
		}
	},
	_getCloseBtn = function(type) {
		if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
			mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
			_currPopupType = type;
		}
		return mfp.currTemplate.closeBtn;
	},
	// Initialize Magnific Popup only when called at least once
	_checkInstance = function() {
		if(!$.magnificPopup.instance) {
			/*jshint -W020 */
			mfp = new MagnificPopup();
			mfp.init();
			$.magnificPopup.instance = mfp;
		}
	},
	// CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
	supportsTransitions = function() {
		var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
			v = ['ms','O','Moz','Webkit']; // 'v' for vendor

		if( s['transition'] !== undefined ) {
			return true; 
		}
			
		while( v.length ) {
			if( v.pop() + 'Transition' in s ) {
				return true;
			}
		}
				
		return false;
	};



/**
 * Public functions
 */
MagnificPopup.prototype = {

	constructor: MagnificPopup,

	/**
	 * Initializes Magnific Popup plugin. 
	 * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
	 */
	init: function() {
		var appVersion = navigator.appVersion;
		mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
		mfp.isAndroid = (/android/gi).test(appVersion);
		mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
		mfp.supportsTransition = supportsTransitions();

		// We disable fixed positioned lightbox on devices that don't handle it nicely.
		// If you know a better way of detecting this - let me know.
		mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
		_document = $(document);

		mfp.popupsCache = {};
	},

	/**
	 * Opens popup
	 * @param  data [description]
	 */
	open: function(data) {

		var i;

		if(data.isObj === false) { 
			// convert jQuery collection to array to avoid conflicts later
			mfp.items = data.items.toArray();

			mfp.index = 0;
			var items = data.items,
				item;
			for(i = 0; i < items.length; i++) {
				item = items[i];
				if(item.parsed) {
					item = item.el[0];
				}
				if(item === data.el[0]) {
					mfp.index = i;
					break;
				}
			}
		} else {
			mfp.items = $.isArray(data.items) ? data.items : [data.items];
			mfp.index = data.index || 0;
		}

		// if popup is already opened - we just update the content
		if(mfp.isOpen) {
			mfp.updateItemHTML();
			return;
		}
		
		mfp.types = []; 
		_wrapClasses = '';
		if(data.mainEl && data.mainEl.length) {
			mfp.ev = data.mainEl.eq(0);
		} else {
			mfp.ev = _document;
		}

		if(data.key) {
			if(!mfp.popupsCache[data.key]) {
				mfp.popupsCache[data.key] = {};
			}
			mfp.currTemplate = mfp.popupsCache[data.key];
		} else {
			mfp.currTemplate = {};
		}



		mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data ); 
		mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;

		if(mfp.st.modal) {
			mfp.st.closeOnContentClick = false;
			mfp.st.closeOnBgClick = false;
			mfp.st.showCloseBtn = false;
			mfp.st.enableEscapeKey = false;
		}
		

		// Building markup
		// main containers are created only once
		if(!mfp.bgOverlay) {

			// Dark overlay
			mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
				mfp.close();
			});

			mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
				if(mfp._checkIfClose(e.target)) {
					mfp.close();
				}
			});

			mfp.container = _getEl('container', mfp.wrap);
		}

		mfp.contentContainer = _getEl('content');
		if(mfp.st.preloader) {
			mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
		}


		// Initializing modules
		var modules = $.magnificPopup.modules;
		for(i = 0; i < modules.length; i++) {
			var n = modules[i];
			n = n.charAt(0).toUpperCase() + n.slice(1);
			mfp['init'+n].call(mfp);
		}
		_mfpTrigger('BeforeOpen');


		if(mfp.st.showCloseBtn) {
			// Close button
			if(!mfp.st.closeBtnInside) {
				mfp.wrap.append( _getCloseBtn() );
			} else {
				_mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
					values.close_replaceWith = _getCloseBtn(item.type);
				});
				_wrapClasses += ' mfp-close-btn-in';
			}
		}

		if(mfp.st.alignTop) {
			_wrapClasses += ' mfp-align-top';
		}

	

		if(mfp.fixedContentPos) {
			mfp.wrap.css({
				overflow: mfp.st.overflowY,
				overflowX: 'hidden',
				overflowY: mfp.st.overflowY
			});
		} else {
			mfp.wrap.css({ 
				top: _window.scrollTop(),
				position: 'absolute'
			});
		}
		if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
			mfp.bgOverlay.css({
				height: _document.height(),
				position: 'absolute'
			});
		}

		

		if(mfp.st.enableEscapeKey) {
			// Close on ESC key
			_document.on('keyup' + EVENT_NS, function(e) {
				if(e.keyCode === 27) {
					mfp.close();
				}
			});
		}

		_window.on('resize' + EVENT_NS, function() {
			mfp.updateSize();
		});


		if(!mfp.st.closeOnContentClick) {
			_wrapClasses += ' mfp-auto-cursor';
		}
		
		if(_wrapClasses)
			mfp.wrap.addClass(_wrapClasses);


		// this triggers recalculation of layout, so we get it once to not to trigger twice
		var windowHeight = mfp.wH = _window.height();

		
		var windowStyles = {};

		if( mfp.fixedContentPos ) {
            if(mfp._hasScrollBar(windowHeight)){
                var s = mfp._getScrollbarSize();
                if(s) {
                    windowStyles.marginRight = s;
                }
            }
        }

		if(mfp.fixedContentPos) {
			if(!mfp.isIE7) {
				windowStyles.overflow = 'hidden';
			} else {
				// ie7 double-scroll bug
				$('body, html').css('overflow', 'hidden');
			}
		}

		
		
		var classesToadd = mfp.st.mainClass;
		if(mfp.isIE7) {
			classesToadd += ' mfp-ie7';
		}
		if(classesToadd) {
			mfp._addClassToMFP( classesToadd );
		}

		// add content
		mfp.updateItemHTML();

		_mfpTrigger('BuildControls');

		// remove scrollbar, add margin e.t.c
		$('html').css(windowStyles);
		
		// add everything to DOM
		mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || $(document.body) );

		// Save last focused element
		mfp._lastFocusedEl = document.activeElement;
		
		// Wait for next cycle to allow CSS transition
		setTimeout(function() {
			
			if(mfp.content) {
				mfp._addClassToMFP(READY_CLASS);
				mfp._setFocus();
			} else {
				// if content is not defined (not loaded e.t.c) we add class only for BG
				mfp.bgOverlay.addClass(READY_CLASS);
			}
			
			// Trap the focus in popup
			_document.on('focusin' + EVENT_NS, mfp._onFocusIn);

		}, 16);

		mfp.isOpen = true;
		mfp.updateSize(windowHeight);
		_mfpTrigger(OPEN_EVENT);

		return data;
	},

	/**
	 * Closes the popup
	 */
	close: function() {
		if(!mfp.isOpen) return;
		_mfpTrigger(BEFORE_CLOSE_EVENT);

		mfp.isOpen = false;
		// for CSS3 animation
		if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
			mfp._addClassToMFP(REMOVING_CLASS);
			setTimeout(function() {
				mfp._close();
			}, mfp.st.removalDelay);
		} else {
			mfp._close();
		}
	},

	/**
	 * Helper for close() function
	 */
	_close: function() {
		_mfpTrigger(CLOSE_EVENT);

		var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';

		mfp.bgOverlay.detach();
		mfp.wrap.detach();
		mfp.container.empty();

		if(mfp.st.mainClass) {
			classesToRemove += mfp.st.mainClass + ' ';
		}

		mfp._removeClassFromMFP(classesToRemove);

		if(mfp.fixedContentPos) {
			var windowStyles = {marginRight: ''};
			if(mfp.isIE7) {
				$('body, html').css('overflow', '');
			} else {
				windowStyles.overflow = '';
			}
			$('html').css(windowStyles);
		}
		
		_document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
		mfp.ev.off(EVENT_NS);

		// clean up DOM elements that aren't removed
		mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
		mfp.bgOverlay.attr('class', 'mfp-bg');
		mfp.container.attr('class', 'mfp-container');

		// remove close button from target element
		if(mfp.st.showCloseBtn &&
		(!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
			if(mfp.currTemplate.closeBtn)
				mfp.currTemplate.closeBtn.detach();
		}


		if(mfp.st.autoFocusLast && mfp._lastFocusedEl) {
			$(mfp._lastFocusedEl).focus(); // put tab focus back
		}
		mfp.currItem = null;	
		mfp.content = null;
		mfp.currTemplate = null;
		mfp.prevHeight = 0;

		_mfpTrigger(AFTER_CLOSE_EVENT);
	},
	
	updateSize: function(winHeight) {

		if(mfp.isIOS) {
			// fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
			var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
			var height = window.innerHeight * zoomLevel;
			mfp.wrap.css('height', height);
			mfp.wH = height;
		} else {
			mfp.wH = winHeight || _window.height();
		}
		// Fixes #84: popup incorrectly positioned with position:relative on body
		if(!mfp.fixedContentPos) {
			mfp.wrap.css('height', mfp.wH);
		}

		_mfpTrigger('Resize');

	},

	/**
	 * Set content of popup based on current index
	 */
	updateItemHTML: function() {
		var item = mfp.items[mfp.index];

		// Detach and perform modifications
		mfp.contentContainer.detach();

		if(mfp.content)
			mfp.content.detach();

		if(!item.parsed) {
			item = mfp.parseEl( mfp.index );
		}

		var type = item.type;

		_mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
		// BeforeChange event works like so:
		// _mfpOn('BeforeChange', function(e, prevType, newType) { });

		mfp.currItem = item;

		if(!mfp.currTemplate[type]) {
			var markup = mfp.st[type] ? mfp.st[type].markup : false;

			// allows to modify markup
			_mfpTrigger('FirstMarkupParse', markup);

			if(markup) {
				mfp.currTemplate[type] = $(markup);
			} else {
				// if there is no markup found we just define that template is parsed
				mfp.currTemplate[type] = true;
			}
		}

		if(_prevContentType && _prevContentType !== item.type) {
			mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
		}

		var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
		mfp.appendContent(newContent, type);

		item.preloaded = true;

		_mfpTrigger(CHANGE_EVENT, item);
		_prevContentType = item.type;

		// Append container back after its content changed
		mfp.container.prepend(mfp.contentContainer);

		_mfpTrigger('AfterChange');
	},


	/**
	 * Set HTML content of popup
	 */
	appendContent: function(newContent, type) {
		mfp.content = newContent;

		if(newContent) {
			if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
				mfp.currTemplate[type] === true) {
				// if there is no markup, we just append close button element inside
				if(!mfp.content.find('.mfp-close').length) {
					mfp.content.append(_getCloseBtn());
				}
			} else {
				mfp.content = newContent;
			}
		} else {
			mfp.content = '';
		}

		_mfpTrigger(BEFORE_APPEND_EVENT);
		mfp.container.addClass('mfp-'+type+'-holder');

		mfp.contentContainer.append(mfp.content);
	},


	/**
	 * Creates Magnific Popup data object based on given data
	 * @param  {int} index Index of item to parse
	 */
	parseEl: function(index) {
		var item = mfp.items[index],
			type;

		if(item.tagName) {
			item = { el: $(item) };
		} else {
			type = item.type;
			item = { data: item, src: item.src };
		}

		if(item.el) {
			var types = mfp.types;

			// check for 'mfp-TYPE' class
			for(var i = 0; i < types.length; i++) {
				if( item.el.hasClass('mfp-'+types[i]) ) {
					type = types[i];
					break;
				}
			}

			item.src = item.el.attr('data-mfp-src');
			if(!item.src) {
				item.src = item.el.attr('href');
			}
		}

		item.type = type || mfp.st.type || 'inline';
		item.index = index;
		item.parsed = true;
		mfp.items[index] = item;
		_mfpTrigger('ElementParse', item);

		return mfp.items[index];
	},


	/**
	 * Initializes single popup or a group of popups
	 */
	addGroup: function(el, options) {
		var eHandler = function(e) {
			e.mfpEl = this;
			mfp._openClick(e, el, options);
		};

		if(!options) {
			options = {};
		}

		var eName = 'click.magnificPopup';
		options.mainEl = el;

		if(options.items) {
			options.isObj = true;
			el.off(eName).on(eName, eHandler);
		} else {
			options.isObj = false;
			if(options.delegate) {
				el.off(eName).on(eName, options.delegate , eHandler);
			} else {
				options.items = el;
				el.off(eName).on(eName, eHandler);
			}
		}
	},
	_openClick: function(e, el, options) {
		var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;


		if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey ) ) {
			return;
		}

		var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

		if(disableOn) {
			if($.isFunction(disableOn)) {
				if( !disableOn.call(mfp) ) {
					return true;
				}
			} else { // else it's number
				if( _window.width() < disableOn ) {
					return true;
				}
			}
		}

		if(e.type) {
			e.preventDefault();

			// This will prevent popup from closing if element is inside and popup is already opened
			if(mfp.isOpen) {
				e.stopPropagation();
			}
		}

		options.el = $(e.mfpEl);
		if(options.delegate) {
			options.items = el.find(options.delegate);
		}
		mfp.open(options);
	},


	/**
	 * Updates text on preloader
	 */
	updateStatus: function(status, text) {

		if(mfp.preloader) {
			if(_prevStatus !== status) {
				mfp.container.removeClass('mfp-s-'+_prevStatus);
			}

			if(!text && status === 'loading') {
				text = mfp.st.tLoading;
			}

			var data = {
				status: status,
				text: text
			};
			// allows to modify status
			_mfpTrigger('UpdateStatus', data);

			status = data.status;
			text = data.text;

			mfp.preloader.html(text);

			mfp.preloader.find('a').on('click', function(e) {
				e.stopImmediatePropagation();
			});

			mfp.container.addClass('mfp-s-'+status);
			_prevStatus = status;
		}
	},


	/*
		"Private" helpers that aren't private at all
	 */
	// Check to close popup or not
	// "target" is an element that was clicked
	_checkIfClose: function(target) {

		if($(target).hasClass(PREVENT_CLOSE_CLASS)) {
			return;
		}

		var closeOnContent = mfp.st.closeOnContentClick;
		var closeOnBg = mfp.st.closeOnBgClick;

		if(closeOnContent && closeOnBg) {
			return true;
		} else {

			// We close the popup if click is on close button or on preloader. Or if there is no content.
			if(!mfp.content || $(target).hasClass('mfp-close') || (mfp.preloader && target === mfp.preloader[0]) ) {
				return true;
			}

			// if click is outside the content
			if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
				if(closeOnBg) {
					// last check, if the clicked element is in DOM, (in case it's removed onclick)
					if( $.contains(document, target) ) {
						return true;
					}
				}
			} else if(closeOnContent) {
				return true;
			}

		}
		return false;
	},
	_addClassToMFP: function(cName) {
		mfp.bgOverlay.addClass(cName);
		mfp.wrap.addClass(cName);
	},
	_removeClassFromMFP: function(cName) {
		this.bgOverlay.removeClass(cName);
		mfp.wrap.removeClass(cName);
	},
	_hasScrollBar: function(winHeight) {
		return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
	},
	_setFocus: function() {
		(mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
	},
	_onFocusIn: function(e) {
		if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
			mfp._setFocus();
			return false;
		}
	},
	_parseMarkup: function(template, values, item) {
		var arr;
		if(item.data) {
			values = $.extend(item.data, values);
		}
		_mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );

		$.each(values, function(key, value) {
			if(value === undefined || value === false) {
				return true;
			}
			arr = key.split('_');
			if(arr.length > 1) {
				var el = template.find(EVENT_NS + '-'+arr[0]);

				if(el.length > 0) {
					var attr = arr[1];
					if(attr === 'replaceWith') {
						if(el[0] !== value[0]) {
							el.replaceWith(value);
						}
					} else if(attr === 'img') {
						if(el.is('img')) {
							el.attr('src', value);
						} else {
							el.replaceWith( $('<img>').attr('src', value).attr('class', el.attr('class')) );
						}
					} else {
						el.attr(arr[1], value);
					}
				}

			} else {
				template.find(EVENT_NS + '-'+key).html(value);
			}
		});
	},

	_getScrollbarSize: function() {
		// thx David
		if(mfp.scrollbarSize === undefined) {
			var scrollDiv = document.createElement("div");
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return mfp.scrollbarSize;
	}

}; /* MagnificPopup core prototype end */




/**
 * Public static functions
 */
$.magnificPopup = {
	instance: null,
	proto: MagnificPopup.prototype,
	modules: [],

	open: function(options, index) {
		_checkInstance();

		if(!options) {
			options = {};
		} else {
			options = $.extend(true, {}, options);
		}

		options.isObj = true;
		options.index = index || 0;
		return this.instance.open(options);
	},

	close: function() {
		return $.magnificPopup.instance && $.magnificPopup.instance.close();
	},

	registerModule: function(name, module) {
		if(module.options) {
			$.magnificPopup.defaults[name] = module.options;
		}
		$.extend(this.proto, module.proto);
		this.modules.push(name);
	},

	defaults: {

		// Info about options is in docs:
		// http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

		disableOn: 0,

		key: null,

		midClick: false,

		mainClass: '',

		preloader: true,

		focus: '', // CSS selector of input to focus after popup is opened

		closeOnContentClick: false,

		closeOnBgClick: true,

		closeBtnInside: true,

		showCloseBtn: true,

		enableEscapeKey: true,

		modal: false,

		alignTop: false,

		removalDelay: 0,

		prependTo: null,

		fixedContentPos: 'auto',

		fixedBgPos: 'auto',

		overflowY: 'auto',

		closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',

		tClose: 'Close (Esc)',

		tLoading: 'Loading...',

		autoFocusLast: true

	}
};



$.fn.magnificPopup = function(options) {
	_checkInstance();

	var jqEl = $(this);

	// We call some API method of first param is a string
	if (typeof options === "string" ) {

		if(options === 'open') {
			var items,
				itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
				index = parseInt(arguments[1], 10) || 0;

			if(itemOpts.items) {
				items = itemOpts.items[index];
			} else {
				items = jqEl;
				if(itemOpts.delegate) {
					items = items.find(itemOpts.delegate);
				}
				items = items.eq( index );
			}
			mfp._openClick({mfpEl:items}, jqEl, itemOpts);
		} else {
			if(mfp.isOpen)
				mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
		}

	} else {
		// clone options obj
		options = $.extend(true, {}, options);

		/*
		 * As Zepto doesn't support .data() method for objects
		 * and it works only in normal browsers
		 * we assign "options" object directly to the DOM element. FTW!
		 */
		if(_isJQ) {
			jqEl.data('magnificPopup', options);
		} else {
			jqEl[0].magnificPopup = options;
		}

		mfp.addGroup(jqEl, options);

	}
	return jqEl;
};

/*>>core*/

/*>>inline*/

var INLINE_NS = 'inline',
	_hiddenClass,
	_inlinePlaceholder,
	_lastInlineElement,
	_putInlineElementsBack = function() {
		if(_lastInlineElement) {
			_inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
			_lastInlineElement = null;
		}
	};

$.magnificPopup.registerModule(INLINE_NS, {
	options: {
		hiddenClass: 'hide', // will be appended with `mfp-` prefix
		markup: '',
		tNotFound: 'Content not found'
	},
	proto: {

		initInline: function() {
			mfp.types.push(INLINE_NS);

			_mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
				_putInlineElementsBack();
			});
		},

		getInline: function(item, template) {

			_putInlineElementsBack();

			if(item.src) {
				var inlineSt = mfp.st.inline,
					el = $(item.src);

				if(el.length) {

					// If target element has parent - we replace it with placeholder and put it back after popup is closed
					var parent = el[0].parentNode;
					if(parent && parent.tagName) {
						if(!_inlinePlaceholder) {
							_hiddenClass = inlineSt.hiddenClass;
							_inlinePlaceholder = _getEl(_hiddenClass);
							_hiddenClass = 'mfp-'+_hiddenClass;
						}
						// replace target inline element with placeholder
						_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
					}

					mfp.updateStatus('ready');
				} else {
					mfp.updateStatus('error', inlineSt.tNotFound);
					el = $('<div>');
				}

				item.inlineElement = el;
				return el;
			}

			mfp.updateStatus('ready');
			mfp._parseMarkup(template, {}, item);
			return template;
		}
	}
});

/*>>inline*/

/*>>ajax*/
var AJAX_NS = 'ajax',
	_ajaxCur,
	_removeAjaxCursor = function() {
		if(_ajaxCur) {
			$(document.body).removeClass(_ajaxCur);
		}
	},
	_destroyAjaxRequest = function() {
		_removeAjaxCursor();
		if(mfp.req) {
			mfp.req.abort();
		}
	};

$.magnificPopup.registerModule(AJAX_NS, {

	options: {
		settings: null,
		cursor: 'mfp-ajax-cur',
		tError: '<a href="%url%">The content</a> could not be loaded.'
	},

	proto: {
		initAjax: function() {
			mfp.types.push(AJAX_NS);
			_ajaxCur = mfp.st.ajax.cursor;

			_mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
			_mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
		},
		getAjax: function(item) {

			if(_ajaxCur) {
				$(document.body).addClass(_ajaxCur);
			}

			mfp.updateStatus('loading');

			var opts = $.extend({
				url: item.src,
				success: function(data, textStatus, jqXHR) {
					var temp = {
						data:data,
						xhr:jqXHR
					};

					_mfpTrigger('ParseAjax', temp);

					mfp.appendContent( $(temp.data), AJAX_NS );

					item.finished = true;

					_removeAjaxCursor();

					mfp._setFocus();

					setTimeout(function() {
						mfp.wrap.addClass(READY_CLASS);
					}, 16);

					mfp.updateStatus('ready');

					_mfpTrigger('AjaxContentAdded');
				},
				error: function() {
					_removeAjaxCursor();
					item.finished = item.loadError = true;
					mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
				}
			}, mfp.st.ajax.settings);

			mfp.req = $.ajax(opts);

			return '';
		}
	}
});

/*>>ajax*/

/*>>image*/
var _imgInterval,
	_getTitle = function(item) {
		if(item.data && item.data.title !== undefined)
			return item.data.title;

		var src = mfp.st.image.titleSrc;

		if(src) {
			if($.isFunction(src)) {
				return src.call(mfp, item);
			} else if(item.el) {
				return item.el.attr(src) || '';
			}
		}
		return '';
	};

$.magnificPopup.registerModule('image', {

	options: {
		markup: '<div class="mfp-figure">'+
					'<div class="mfp-close"></div>'+
					'<figure>'+
						'<div class="mfp-img"></div>'+
						'<figcaption>'+
							'<div class="mfp-bottom-bar">'+
								'<div class="mfp-title"></div>'+
								'<div class="mfp-counter"></div>'+
							'</div>'+
						'</figcaption>'+
					'</figure>'+
				'</div>',
		cursor: 'mfp-zoom-out-cur',
		titleSrc: 'title',
		verticalFit: true,
		tError: '<a href="%url%">The image</a> could not be loaded.'
	},

	proto: {
		initImage: function() {
			var imgSt = mfp.st.image,
				ns = '.image';

			mfp.types.push('image');

			_mfpOn(OPEN_EVENT+ns, function() {
				if(mfp.currItem.type === 'image' && imgSt.cursor) {
					$(document.body).addClass(imgSt.cursor);
				}
			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(imgSt.cursor) {
					$(document.body).removeClass(imgSt.cursor);
				}
				_window.off('resize' + EVENT_NS);
			});

			_mfpOn('Resize'+ns, mfp.resizeImage);
			if(mfp.isLowIE) {
				_mfpOn('AfterChange', mfp.resizeImage);
			}
		},
		resizeImage: function() {
			var item = mfp.currItem;
			if(!item || !item.img) return;

			if(mfp.st.image.verticalFit) {
				var decr = 0;
				// fix box-sizing in ie7/8
				if(mfp.isLowIE) {
					decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
				}
				item.img.css('max-height', mfp.wH-decr);
			}
		},
		_onImageHasSize: function(item) {
			if(item.img) {

				item.hasSize = true;

				if(_imgInterval) {
					clearInterval(_imgInterval);
				}

				item.isCheckingImgSize = false;

				_mfpTrigger('ImageHasSize', item);

				if(item.imgHidden) {
					if(mfp.content)
						mfp.content.removeClass('mfp-loading');

					item.imgHidden = false;
				}

			}
		},

		/**
		 * Function that loops until the image has size to display elements that rely on it asap
		 */
		findImageSize: function(item) {

			var counter = 0,
				img = item.img[0],
				mfpSetInterval = function(delay) {

					if(_imgInterval) {
						clearInterval(_imgInterval);
					}
					// decelerating interval that checks for size of an image
					_imgInterval = setInterval(function() {
						if(img.naturalWidth > 0) {
							mfp._onImageHasSize(item);
							return;
						}

						if(counter > 200) {
							clearInterval(_imgInterval);
						}

						counter++;
						if(counter === 3) {
							mfpSetInterval(10);
						} else if(counter === 40) {
							mfpSetInterval(50);
						} else if(counter === 100) {
							mfpSetInterval(500);
						}
					}, delay);
				};

			mfpSetInterval(1);
		},

		getImage: function(item, template) {

			var guard = 0,

				// image load complete handler
				onLoadComplete = function() {
					if(item) {
						if (item.img[0].complete) {
							item.img.off('.mfploader');

							if(item === mfp.currItem){
								mfp._onImageHasSize(item);

								mfp.updateStatus('ready');
							}

							item.hasSize = true;
							item.loaded = true;

							_mfpTrigger('ImageLoadComplete');

						}
						else {
							// if image complete check fails 200 times (20 sec), we assume that there was an error.
							guard++;
							if(guard < 200) {
								setTimeout(onLoadComplete,100);
							} else {
								onLoadError();
							}
						}
					}
				},

				// image error handler
				onLoadError = function() {
					if(item) {
						item.img.off('.mfploader');
						if(item === mfp.currItem){
							mfp._onImageHasSize(item);
							mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
						}

						item.hasSize = true;
						item.loaded = true;
						item.loadError = true;
					}
				},
				imgSt = mfp.st.image;


			var el = template.find('.mfp-img');
			if(el.length) {
				var img = document.createElement('img');
				img.className = 'mfp-img';
				if(item.el && item.el.find('img').length) {
					img.alt = item.el.find('img').attr('alt');
				}
				item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
				img.src = item.src;

				// without clone() "error" event is not firing when IMG is replaced by new IMG
				// TODO: find a way to avoid such cloning
				if(el.is('img')) {
					item.img = item.img.clone();
				}

				img = item.img[0];
				if(img.naturalWidth > 0) {
					item.hasSize = true;
				} else if(!img.width) {
					item.hasSize = false;
				}
			}

			mfp._parseMarkup(template, {
				title: _getTitle(item),
				img_replaceWith: item.img
			}, item);

			mfp.resizeImage();

			if(item.hasSize) {
				if(_imgInterval) clearInterval(_imgInterval);

				if(item.loadError) {
					template.addClass('mfp-loading');
					mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
				} else {
					template.removeClass('mfp-loading');
					mfp.updateStatus('ready');
				}
				return template;
			}

			mfp.updateStatus('loading');
			item.loading = true;

			if(!item.hasSize) {
				item.imgHidden = true;
				template.addClass('mfp-loading');
				mfp.findImageSize(item);
			}

			return template;
		}
	}
});

/*>>image*/

/*>>zoom*/
var hasMozTransform,
	getHasMozTransform = function() {
		if(hasMozTransform === undefined) {
			hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
		}
		return hasMozTransform;
	};

$.magnificPopup.registerModule('zoom', {

	options: {
		enabled: false,
		easing: 'ease-in-out',
		duration: 300,
		opener: function(element) {
			return element.is('img') ? element : element.find('img');
		}
	},

	proto: {

		initZoom: function() {
			var zoomSt = mfp.st.zoom,
				ns = '.zoom',
				image;

			if(!zoomSt.enabled || !mfp.supportsTransition) {
				return;
			}

			var duration = zoomSt.duration,
				getElToAnimate = function(image) {
					var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
						transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
						cssObj = {
							position: 'fixed',
							zIndex: 9999,
							left: 0,
							top: 0,
							'-webkit-backface-visibility': 'hidden'
						},
						t = 'transition';

					cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;

					newImg.css(cssObj);
					return newImg;
				},
				showMainContent = function() {
					mfp.content.css('visibility', 'visible');
				},
				openTimeout,
				animatedImg;

			_mfpOn('BuildControls'+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);
					mfp.content.css('visibility', 'hidden');

					// Basically, all code below does is clones existing image, puts in on top of the current one and animated it

					image = mfp._getItemToZoom();

					if(!image) {
						showMainContent();
						return;
					}

					animatedImg = getElToAnimate(image);

					animatedImg.css( mfp._getOffset() );

					mfp.wrap.append(animatedImg);

					openTimeout = setTimeout(function() {
						animatedImg.css( mfp._getOffset( true ) );
						openTimeout = setTimeout(function() {

							showMainContent();

							setTimeout(function() {
								animatedImg.remove();
								image = animatedImg = null;
								_mfpTrigger('ZoomAnimationEnded');
							}, 16); // avoid blink when switching images

						}, duration); // this timeout equals animation duration

					}, 16); // by adding this timeout we avoid short glitch at the beginning of animation


					// Lots of timeouts...
				}
			});
			_mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);

					mfp.st.removalDelay = duration;

					if(!image) {
						image = mfp._getItemToZoom();
						if(!image) {
							return;
						}
						animatedImg = getElToAnimate(image);
					}

					animatedImg.css( mfp._getOffset(true) );
					mfp.wrap.append(animatedImg);
					mfp.content.css('visibility', 'hidden');

					setTimeout(function() {
						animatedImg.css( mfp._getOffset() );
					}, 16);
				}

			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {
					showMainContent();
					if(animatedImg) {
						animatedImg.remove();
					}
					image = null;
				}
			});
		},

		_allowZoom: function() {
			return mfp.currItem.type === 'image';
		},

		_getItemToZoom: function() {
			if(mfp.currItem.hasSize) {
				return mfp.currItem.img;
			} else {
				return false;
			}
		},

		// Get element postion relative to viewport
		_getOffset: function(isLarge) {
			var el;
			if(isLarge) {
				el = mfp.currItem.img;
			} else {
				el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
			}

			var offset = el.offset();
			var paddingTop = parseInt(el.css('padding-top'),10);
			var paddingBottom = parseInt(el.css('padding-bottom'),10);
			offset.top -= ( $(window).scrollTop() - paddingTop );


			/*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
			var obj = {
				width: el.width(),
				// fix Zepto height+padding issue
				height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
			};

			// I hate to do this, but there is no another option
			if( getHasMozTransform() ) {
				obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
			} else {
				obj.left = offset.left;
				obj.top = offset.top;
			}
			return obj;
		}

	}
});



/*>>zoom*/

/*>>iframe*/

var IFRAME_NS = 'iframe',
	_emptyPage = '//about:blank',

	_fixIframeBugs = function(isShowing) {
		if(mfp.currTemplate[IFRAME_NS]) {
			var el = mfp.currTemplate[IFRAME_NS].find('iframe');
			if(el.length) {
				// reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
				if(!isShowing) {
					el[0].src = _emptyPage;
				}

				// IE8 black screen bug fix
				if(mfp.isIE8) {
					el.css('display', isShowing ? 'block' : 'none');
				}
			}
		}
	};

$.magnificPopup.registerModule(IFRAME_NS, {

	options: {
		markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
				'</div>',

		srcAction: 'iframe_src',

		// we don't care and support only one default type of URL by default
		patterns: {
			youtube: {
				index: 'youtube.com',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			},
			gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			}
		}
	},

	proto: {
		initIframe: function() {
			mfp.types.push(IFRAME_NS);

			_mfpOn('BeforeChange', function(e, prevType, newType) {
				if(prevType !== newType) {
					if(prevType === IFRAME_NS) {
						_fixIframeBugs(); // iframe if removed
					} else if(newType === IFRAME_NS) {
						_fixIframeBugs(true); // iframe is showing
					}
				}// else {
					// iframe source is switched, don't do anything
				//}
			});

			_mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
				_fixIframeBugs();
			});
		},

		getIframe: function(item, template) {
			var embedSrc = item.src;
			var iframeSt = mfp.st.iframe;

			$.each(iframeSt.patterns, function() {
				if(embedSrc.indexOf( this.index ) > -1) {
					if(this.id) {
						if(typeof this.id === 'string') {
							embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
						} else {
							embedSrc = this.id.call( this, embedSrc );
						}
					}
					embedSrc = this.src.replace('%id%', embedSrc );
					return false; // break;
				}
			});

			var dataObj = {};
			if(iframeSt.srcAction) {
				dataObj[iframeSt.srcAction] = embedSrc;
			}
			mfp._parseMarkup(template, dataObj, item);

			mfp.updateStatus('ready');

			return template;
		}
	}
});



/*>>iframe*/

/*>>gallery*/
/**
 * Get looped index depending on number of slides
 */
var _getLoopedId = function(index) {
		var numSlides = mfp.items.length;
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},
	_replaceCurrTotal = function(text, curr, total) {
		return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
	};

$.magnificPopup.registerModule('gallery', {

	options: {
		enabled: false,
		arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
		preload: [0,2],
		navigateByImgClick: true,
		arrows: true,

		tPrev: 'Previous (Left arrow key)',
		tNext: 'Next (Right arrow key)',
		tCounter: '%curr% of %total%'
	},

	proto: {
		initGallery: function() {

			var gSt = mfp.st.gallery,
				ns = '.mfp-gallery';

			mfp.direction = true; // true - next, false - prev

			if(!gSt || !gSt.enabled ) return false;

			_wrapClasses += ' mfp-gallery';

			_mfpOn(OPEN_EVENT+ns, function() {

				if(gSt.navigateByImgClick) {
					mfp.wrap.on('click'+ns, '.mfp-img', function() {
						if(mfp.items.length > 1) {
							mfp.next();
							return false;
						}
					});
				}

				_document.on('keydown'+ns, function(e) {
					if (e.keyCode === 37) {
						mfp.prev();
					} else if (e.keyCode === 39) {
						mfp.next();
					}
				});
			});

			_mfpOn('UpdateStatus'+ns, function(e, data) {
				if(data.text) {
					data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
				}
			});

			_mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
				var l = mfp.items.length;
				values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
			});

			_mfpOn('BuildControls' + ns, function() {
				if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
					var markup = gSt.arrowMarkup,
						arrowLeft = mfp.arrowLeft = $( markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
						arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);

					arrowLeft.click(function() {
						mfp.prev();
					});
					arrowRight.click(function() {
						mfp.next();
					});

					mfp.container.append(arrowLeft.add(arrowRight));
				}
			});

			_mfpOn(CHANGE_EVENT+ns, function() {
				if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

				mfp._preloadTimeout = setTimeout(function() {
					mfp.preloadNearbyImages();
					mfp._preloadTimeout = null;
				}, 16);
			});


			_mfpOn(CLOSE_EVENT+ns, function() {
				_document.off(ns);
				mfp.wrap.off('click'+ns);
				mfp.arrowRight = mfp.arrowLeft = null;
			});

		},
		next: function() {
			mfp.direction = true;
			mfp.index = _getLoopedId(mfp.index + 1);
			mfp.updateItemHTML();
		},
		prev: function() {
			mfp.direction = false;
			mfp.index = _getLoopedId(mfp.index - 1);
			mfp.updateItemHTML();
		},
		goTo: function(newIndex) {
			mfp.direction = (newIndex >= mfp.index);
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		preloadNearbyImages: function() {
			var p = mfp.st.gallery.preload,
				preloadBefore = Math.min(p[0], mfp.items.length),
				preloadAfter = Math.min(p[1], mfp.items.length),
				i;

			for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
				mfp._preloadItem(mfp.index+i);
			}
			for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
				mfp._preloadItem(mfp.index-i);
			}
		},
		_preloadItem: function(index) {
			index = _getLoopedId(index);

			if(mfp.items[index].preloaded) {
				return;
			}

			var item = mfp.items[index];
			if(!item.parsed) {
				item = mfp.parseEl( index );
			}

			_mfpTrigger('LazyLoad', item);

			if(item.type === 'image') {
				item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
					item.hasSize = true;
				}).on('error.mfploader', function() {
					item.hasSize = true;
					item.loadError = true;
					_mfpTrigger('LazyLoadError', item);
				}).attr('src', item.src);
			}


			item.preloaded = true;
		}
	}
});

/*>>gallery*/

/*>>retina*/

var RETINA_NS = 'retina';

$.magnificPopup.registerModule(RETINA_NS, {
	options: {
		replaceSrc: function(item) {
			return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
		},
		ratio: 1 // Function or number.  Set to 1 to disable.
	},
	proto: {
		initRetina: function() {
			if(window.devicePixelRatio > 1) {

				var st = mfp.st.retina,
					ratio = st.ratio;

				ratio = !isNaN(ratio) ? ratio : ratio();

				if(ratio > 1) {
					_mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
						item.img.css({
							'max-width': item.img[0].naturalWidth / ratio,
							'width': '100%'
						});
					});
					_mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
						item.src = st.replaceSrc(item, ratio);
					});
				}
			}

		}
	}
});

/*>>retina*/
 _checkInstance(); }));

/***/ }),
/* 5 */
/***/ (function(module, exports) {

jQuery.fn.giveHintCss = function (action, settings) {
	return this.each(function () {
		var $this = jQuery(this);
		settings = jQuery.extend({
			label: ''
		}, settings);

		var $tooltip = $this.next('span.give-hint-tooltip-js');
		if (!$tooltip.length) {
			var label = !settings.label.length ? $this.data('hint-aria-label') : settings.label;

			// bailout.
			if (!label.length) {
				return;
			}

			$this.after('<span class="give-hint-tooltip-js hint--top hint--medium" aria-label="' + label + '"></span>');
			$tooltip = $this.next();

			$tooltip.css({
				top: -$this.outerHeight(),
				left: -($this.outerWidth() / 2)
			});
		}

		if (action === 'show') {
			$tooltip.addClass('hint--always');
		} else if (action === 'hide') {
			$tooltip.removeClass('hint--always');
		}
	});
};

// Qtip2 backward compatibility.
jQuery(document).ready(function ($) {
	var qtip_tooltips = $('[data-tooltip]');

	// Add hintcss tooltip to existing qtip.
	if (qtip_tooltips.length) {
		qtip_tooltips.each(function (index, tooltip) {
			tooltip = tooltip instanceof jQuery ? tooltip : $(tooltip);
			reset_qtip(tooltip);
		});
	}

	// Add hintcss tooltip to dynamically created qtip.
	$('body').on('hover', '[data-tooltip]', function () {
		reset_qtip($(this));
	});

	/**
  * Reset qtip to hintcss
  * @param tooltip
  */
	function reset_qtip(tooltip) {
		if (!tooltip.is('[class*="hint"]')) {
			var classes = tooltip.attr('class'),
			    icon_classes = [],
			    label_length = tooltip.data('tooltip').split(' ').length;

			if (classes) {
				classes = classes.split(' ');
				icon_classes = $.grep(classes, function (item) {
					return -1 !== item.indexOf('give-icon');
				});

				if (icon_classes.length) {
					// Set icon classes string.
					icon_classes = icon_classes.join(' ');

					// Remove icon class.
					tooltip.removeClass(icon_classes);

					// Add icon.
					tooltip.append('<i class="' + icon_classes + '"></i>');
				}
			}

			// Add hint.css related classes.
			tooltip.addClass('hint--top');

			if (15 < label_length) {
				tooltip.addClass('hint--large');
			} else if (7 < label_length) {
				tooltip.addClass('hint--medium');
			}

			tooltip.attr('aria-label', tooltip.data('tooltip'));
		}
	}
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notice__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(8);
/* global accounting, give_global_vars, jQuery */



/**
 *  This API is under development.
 *
 *  Currently used only for internal purpose.
 */
var Give = {
	init: function init() {
		var subHelperObjs = ['form'],
		    counter = 0;
		jQuery(document).trigger('give:preInit');

		// Initialize all init methods of sub helper objects.
		while (counter < subHelperObjs.length) {
			if (!!Give[subHelperObjs[counter]].init) {
				Give[subHelperObjs[counter]].init();
			}
			counter++;
		}

		jQuery(document).trigger('give:postInit');
	},

	fn: {
		/**
   * Format Currency
   *
   * Formats the currency with accounting.js
   *
   * @param {string} price
   * @param {object}  args
   * @param {object} $form
   * @returns {*|string}
   */
		formatCurrency: function formatCurrency(price, args, $form) {
			// Global currency setting.
			var format_args = {
				symbol: '',
				decimal: this.getGlobalVar('decimal_separator'),
				thousand: this.getGlobalVar('thousands_separator'),
				precision: parseInt(this.getGlobalVar('number_decimals')),
				currency: this.getGlobalVar('currency')
			};

			price = price.toString().trim();
			$form = 'undefined' === typeof $form ? {} : $form;

			// Form specific currency setting.
			if ($form.length) {
				//Set the custom amount input value format properly
				format_args = {
					symbol: '',
					decimal: Give.form.fn.getInfo('decimal_separator', $form),
					thousand: Give.form.fn.getInfo('thousands_separator', $form),
					precision: Give.form.fn.getInfo('number_decimals', $form),
					currency: Give.form.fn.getInfo('currency_code', $form)
				};
			}

			args = jQuery.extend(format_args, args);

			// Make sure precision is integer type
			args.precision = parseInt(args.precision);

			if ('INR' === args.currency) {
				var actual_price = accounting.unformat(price, '.').toString(),
				    decimal_amount = '',
				    result = void 0,
				    amount = void 0,
				    decimal_index = actual_price.indexOf('.');

				if (-1 !== decimal_index) {
					if (args.precision) {
						decimal_amount = Number(actual_price.substr(parseInt(decimal_index))).toFixed(args.precision).toString().substr(1);
						decimal_amount = decimal_amount.length ? decimal_amount : '.0000000000'.substr(0, parseInt(decimal_index) + 1);

						if (args.precision + 1 > decimal_amount.length) {
							decimal_amount = (decimal_amount + '000000000').substr(0, args.precision + 1);
						}
					}

					actual_price = actual_price.substr(0, parseInt(decimal_index));
				}

				// Extract last 3 from amount
				result = actual_price.substr(-3);
				amount = actual_price.substr(0, parseInt(actual_price.length) - 3);

				// Apply digits 2 by 2
				while (amount.length > 0) {
					result = amount.substr(-2) + args.thousand + result;
					amount = amount.substr(0, parseInt(amount.length) - 2);
				}

				if (decimal_amount.length) {
					result = result + decimal_amount;
				}

				price = result;

				if (undefined !== args.symbol && args.symbol.length) {
					if ('after' === args.position) {
						price = price + args.symbol;
					} else {
						price = args.symbol + price;
					}
				}
			} else {
				//Properly position symbol after if selected
				if ('after' === args.position) {
					args.format = '%v%s';
				}

				price = accounting.formatMoney(price, args);
			}

			return price;
		},

		/**
   * Unformat Currency
   *
   * @param price
   * @param {string} decimal_separator
   * @returns {number}
   */
		unFormatCurrency: function unFormatCurrency(price, decimal_separator) {
			if ('string' === typeof price) {
				var regex = ',' === decimal_separator.trim() ? /[^0-9\,-]+/g : /[^0-9\.-]+/g;

				price = price.replace(regex, '');

				if (0 === price.indexOf(decimal_separator)) {
					price = price.substr(1);
				} else if (price.length - 1 === price.indexOf(decimal_separator)) {
					price = price.slice(0, -1);
				}
			}

			return Math.abs(parseFloat(accounting.unformat(price, decimal_separator)));
		},

		/**
   * Get Parameter by Name
   *
   * @see: http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
   * @param name
   * @param url
   * @since 1.4.2
   * @returns {*}
   */
		getParameterByName: function getParameterByName(name, url) {
			if (!url) {
				url = window.location.href;
			}

			name = name.replace(/[\[\]]/g, '\\$&');

			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			    results = regex.exec(url);

			if (!results) {
				return null;
			}

			if (!results[2]) {
				return '';
			}

			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},

		/**
   * Get information from global var
   *
   * @since 1.8.17
   * @param {string} str Variable in global param.
   *
   * @return {string}
   */
		getGlobalVar: function getGlobalVar(str) {
			var giveGlobals = this.getGlobal();

			return 'undefined' === typeof giveGlobals[str] ? '' : giveGlobals[str];
		},

		/**
   * Get global param
   *
   * @since 2.2.4
   *
   * @return {object} WordPress localized global param.
   */
		getGlobal: function getGlobal() {
			return 'undefined' === typeof give_global_vars ? give_vars : give_global_vars;
		},

		/**
   * set cache
   *
   * @since 1.8.17
   *
   * @param {string} key
   * @param {string} value
   * @param {object} $form
   */
		setCache: function setCache(key, value, $form) {
			if ($form.length) {
				Give.cache['form_' + Give.form.fn.getInfo('form-id', $form)][key] = value;
			} else {
				Give.cache[key] = value;
			}
		},

		/**
   * Get cache
   *
   * @since 1.8.17
   * @param key
   * @param $form
   * @return {string|*}
   */
		getCache: function getCache(key, $form) {
			var cache = void 0,
			    formObj = Give.cache['form_' + Give.form.fn.getInfo('form-id', $form)];

			if ($form.length) {
				cache = 'undefined' !== typeof formObj ? formObj[key] : '';
			} else {
				cache = Give.cache[key];
			}

			cache = 'undefined' === typeof cache ? '' : cache;

			return cache;
		},

		/**
   * Get cookie
   * Note: only for internal use
   *
   * @since 2.2.20
   * @private
   *
   * @param {string} name Cookie name
   * @return {string}
   */
		__getCookie: function __getCookie(name) {
			var value = '; ' + document.cookie,
			    parts = value.split('; ' + name + '=');

			var cookie = '';

			if (2 === parts.length) {
				cookie = parts.pop().split(';').shift();
			}

			return cookie;
		}
	},

	/**
  * This object key will be use to cache predicted data or donor activity.
  *
  * @since 1.8.17
  */
	cache: {}
};

Give.notice = __WEBPACK_IMPORTED_MODULE_0__notice__["a" /* default */];
Give.form = __WEBPACK_IMPORTED_MODULE_1__form__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Give);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* globals Give, jQuery */
/* harmony default export */ __webpack_exports__["a"] = ({
	fn: {
		/**
   * Render notice
   * @since 1.8.17
   *
   * @param {string} notice_code
   * @param {object} $container
   *
   * @return {string}
   */
		renderNotice: function renderNotice(notice_code, $container) {
			var notice_html = '',
			    $notice = void 0;
			$container = 'undefined' !== typeof $container ? $container : {};

			switch (notice_code) {
				case 'bad_minimum':
					$notice = jQuery('<div class="give_error give-invalid-minimum give-hidden">' + this.getNotice(notice_code, $container) + '</div>');
					break;
				case 'bad_maximum':
					$notice = jQuery('<div class="give_error give-invalid-maximum give-hidden">' + this.getNotice(notice_code, $container) + '</div>');
					break;
			}

			// Return html if container did not find.
			if (!$container.length) {
				return notice_html;
			}

			$notice.insertBefore($container.find('.give-total-wrap')).show();
		},

		/**
   * Get error notice
   *
   * @since 1.8.17
   * @param {string} error_code
   * @param {object} $form
   *
   * @return {*}
   */
		getNotice: function getNotice(error_code, $form) {
			// Bailout.
			if (!error_code.length) {
				return null;
			}

			var notice, notice_msg, formatted_amount;
			notice = notice_msg = formatted_amount = '';

			if ($form.length) {
				switch (error_code) {
					case 'bad_minimum':
						notice_msg = Give.fn.getGlobalVar(error_code);
						formatted_amount = Give.form.fn.getMinimumAmount($form);
						break;
					case 'bad_maximum':
						notice_msg = Give.fn.getGlobalVar(error_code);
						formatted_amount = Give.form.fn.getMaximumAmount($form);
						break;
				}
			}

			if ($form.length && '' !== notice_msg) {
				notice = notice_msg + ' ' + Give.fn.formatCurrency(formatted_amount, {
					symbol: Give.form.fn.getInfo('currency_symbol', $form),
					position: Give.form.fn.getInfo('currency_position', $form)
				}, $form);
			}

			return notice;
		}
	}
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* globals Give, jQuery */
/* harmony default export */ __webpack_exports__["a"] = ({
	init: function init() {
		this.fn.field.formatCreditCard(jQuery('form.give-form'));
		this.fn.__initialize_cache();

		window.onload = function () {
			Give.form.fn.__sendBackToForm();
		};
	},

	fn: {

		/**
   * Check if donation form exist on page or not
   *
   * @since 2.2.2
   *
   * @return {boolean}
   */
		isFormExist: function isFormExist() {
			return !!document.getElementsByName('give-form-hash').length;
		},

		/**
   * Disable donation form.
   *
   * @param {object} $form
   * @param {boolean} is_disable
   *
   * @return {*}
   */
		disable: function disable($form, is_disable) {
			if (!$form.length) {
				return false;
			}

			$form.find('.give-submit').prop('disabled', is_disable);
		},

		/**
   * Get formatted amount
   *
   * @param {string/number} amount
   * @param {object} $form
   * @param {object} args
   */
		formatAmount: function formatAmount(amount, $form, args) {
			// Do not format amount if form did not exist.
			if (!$form.length) {
				return amount;
			}

			return Give.fn.formatCurrency(amount, args, $form);
		},

		/**
   * Get form information
   *
   * @since 1.8.17
   * @param {string} str
   * @param {object} $form
   *
   * @return {string}
   */
		getInfo: function getInfo(str, $form) {
			var data = '';
			$form = 'undefined' !== typeof $form ? $form : {};

			// Bailout.
			if (!str.length || !$form.length) {
				return data;
			}

			switch (str) {
				case 'gateways':
					data = [];
					jQuery.each($form.find('input[name="payment-mode"]'), function (index, gateway) {
						gateway = !(gateway instanceof jQuery) ? jQuery(gateway) : gateway;
						data.push(gateway.val().trim());
					});
					break;

				case 'form-type':
					if ($form.hasClass('give-form-type-set')) {
						data = 'set';
					} else if ($form.hasClass('give-form-type-multi')) {
						data = 'multi';
					}
					break;

				case 'form-id':
					data = $form.find('input[name="give-form-id"]').val();
					break;

				default:
					if ($form.get(0).hasAttribute('data-' + str)) {
						data = $form.attr('data-' + str);
					} else {
						data = $form.attr(str);
					}

					'undefined' !== typeof data ? data.trim() : data;
			}

			return data;
		},

		/**
   * Set form information
   *
   * @since 1.8.17
   * @param {string} str
   * @param {string} val
   * @param {object} $form
   * @param {string} type
   *
   * @return {string|boolean}
   */
		setInfo: function setInfo(type, val, $form, str) {
			// Bailout.
			if (!$form.length) {
				return false;
			}

			type = 'undefined' === typeof type ? 'data' : type;

			switch (type) {
				case 'nonce':
					$form.find('input[name="give-form-hash"]').val(val);
					break;
			}

			// Bailout.
			if ('undefined' !== typeof str && !str.length) {
				return false;
			}

			switch (type) {
				case 'attr':
					$form.attr(str, val);
					break;

				default:
					$form.data(str, val);
					break;
			}

			return true;
		},

		/**
   * Get formatted amount
   *
   * @since 1.8.17
   * @param {object} $form
   */
		getGateway: function getGateway($form) {
			var gateway = '';

			if (!$form.length) {
				return gateway;
			}

			gateway = $form.find('input[name="payment-mode"]:checked').val().trim();

			return 'undefined' !== typeof gateway ? gateway : '';
		},

		/**
   * Get Price ID and levels for multi donation form
   *
   * @param   {Object} $form Form jQuery object
   *
   * @returns {Object}
   */
		getVariablePrices: function getVariablePrices($form) {
			var variable_prices = [],
			    formLevels;

			// check if correct form type is multi or not.
			if (!$form.length || !$form.hasClass('give-form-type-multi') || !(formLevels = $form.find('.give-donation-levels-wrap [data-price-id] '))) {
				return variable_prices;
			}

			jQuery.each(formLevels, function (index, item) {
				// Get Jquery instance for item.
				item = !(item instanceof jQuery) ? jQuery(item) : item;

				var decimal_separator = Give.form.fn.getInfo('decimal_separator', $form);

				// Add price id and amount to collector.
				variable_prices.push({
					price_id: item.data('price-id'),
					amount: Give.fn.unFormatCurrency(item.val(), decimal_separator)
				});
			});

			return variable_prices;
		},

		/**
   * Get form price ID
   *
   * @since 1.8.17
   * @param {object} $form
   * @param {boolean} is_amount
   *
   * @return {string}
   */
		getPriceID: function getPriceID($form, is_amount) {

			var variable_prices = this.getVariablePrices($form),
			    current_amount = Give.fn.unFormatCurrency($form.find('input[name="give-amount"]').val(), this.getInfo('decimal_separator', $form)),


			/**
    * Flag Multi-levels for min. donation conditional.
    *
    * Note: Value of this variable will be:
    *  a. -1      if no any level found.
    *  b. [0-*]   Any number from zero if donation level found.
    *  c  custom  if donation level not found and donation amount is greater than the custom minimum amount.
    *
    * @type {number/string} Donation level ID.
    */
			price_id = !!Give.fn.getCache('amount_' + current_amount, $form) ? Give.fn.getCache('amount_' + current_amount, $form) : -1;

			// Flag to decide on which param we want to find price_id
			is_amount = 'undefined' === typeof is_amount ? true : is_amount;

			// Find price id with amount in variable prices.
			if (variable_prices.length) {

				// Get recent selected price id for same amount.
				if (-1 === price_id) {
					if (is_amount) {
						// Find amount in donation levels.
						jQuery.each(variable_prices, function (index, variable_price) {
							if (variable_price.amount === current_amount) {
								price_id = variable_price.price_id;

								return false;
							}
						});

						// Set level to custom.
						if (-1 === price_id && this.getMinimumAmount($form) <= current_amount && this.getMaximumAmount($form) >= current_amount && this.getMinimumAmount($form) <= current_amount) {
							price_id = 'custom';
						}
					} else {
						price_id = jQuery('input[name="give-price-id"]', $form).val();
					}
				}
			}

			return price_id;
		},

		/**
   * Get form minimum amount
   *
   * @since 1.8.17
   * @param {object} $form
   *
   * @return {string}
   */
		getMinimumAmount: function getMinimumAmount($form) {
			return $form.find('input[name="give-form-minimum"]').val();
		},

		/**
   * Get form maximum amount
   *
   * @since 2.1
   * @param {object} $form
   *
   * @return {string}
   */
		getMaximumAmount: function getMaximumAmount($form) {
			return $form.find('input[name="give-form-maximum"]').val();
		},

		/**
   * Get form amount
   *
   * @since 1.8.17
   * @param $form
   * @return {*}
   */
		getAmount: function getAmount($form) {
			// Bailout
			if (!$form.length) {
				return null;
			}

			var amount = $form.find('input[name="give-amount"]').val();

			if ('undefined' === typeof amount || !amount) {
				amount = 0;
			}

			return Give.fn.unFormatCurrency(amount, this.getInfo('decimal_separator', $form));
		},

		/**
   * Get form security nonce
   *
   * @since 1.8.17
   * @param {object} $form
   * @return {string}
   */
		getNonce: function getNonce($form) {
			// Bailout
			if (!$form.length) {
				return '';
			}

			var nonce = $form.find('input[name="give-form-hash"]').val();

			if ('undefined' === typeof nonce || !nonce) {
				nonce = '';
			}

			return nonce;
		},

		/**
   * Reset form nonce.
   *
   * @since 2.0
   *
   * @param {object} $form Donation form object.
   * @returns {boolean}
   */
		resetNonce: function resetNonce($form) {
			// Return false, if form is missing.
			if (!$form.length || !jQuery('input[name="give-form-hash"]', $form).length) {
				return false;
			}

			Give.form.fn.disable($form, true);

			//Post via AJAX to Give
			jQuery.post(Give.fn.getGlobalVar('ajaxurl'), {
				action: 'give_donation_form_nonce',
				give_form_id: Give.form.fn.getInfo('form-id', $form)
			}, function (response) {
				// Update nonce field.
				Give.form.fn.setInfo('nonce', response.data, $form, '');

				Give.form.fn.disable($form, false);
			});
		},

		/**
   * Reset form all nonce.
   *
   * @since 2.2.0
   *
   * @param {object} $form Donation form object.
   * @returns {boolean}
   */
		resetAllNonce: function resetAllNonce($form) {
			// Return false, if form is missing.
			if (!$form.length) {
				return false;
			}

			Give.form.fn.disable($form, true);

			//Post via AJAX to Give
			jQuery.post(Give.fn.getGlobalVar('ajaxurl'), {
				action: 'give_donation_form_reset_all_nonce',
				give_form_id: Give.form.fn.getInfo('form-id', $form)
			}, function (response) {
				// Process only if get response successfully.
				if (!response.success) {
					return;
				}

				var createUserNonceField = $form.find('input[name="give-form-user-register-hash"]');

				// Update nonce field.
				Give.form.fn.setInfo('nonce', response.data.give_form_hash, $form, '');

				// Update create user nonce field.
				if (createUserNonceField.length) {
					createUserNonceField.val(response.data.give_form_user_register_hash);
				}

				Give.form.fn.disable($form, false);

				/**
     * Fire custom event handler when update all nonce of donation form
     *
     * @since  2.2.0
     * @access access
     */
				jQuery(document).trigger('give_reset_all_nonce', [response.data]);
			}).done(function () {
				Give.form.fn.disable($form, false);
			});
		},

		/**
   * Auto select donation level
   *
   * @since 1.8.17
   * @param {object} $form
   * @param {string} price_id
   *
   * @return {boolean}
   */
		autoSelectDonationLevel: function autoSelectDonationLevel($form, price_id) {

			if (!$form.length || 'multi' !== this.getInfo('form-type', $form)) {
				return false;
			}

			price_id = 'undefined' === typeof price_id ? this.getPriceID($form, false) : price_id;

			switch (true) {

				// Auto select radio button.
				case !!$form.find('.give-radio-input').length:
					$form.find('.give-radio-input').prop('checked', false);
					$form.find('.give-radio-input[data-price-id="' + price_id + '"]').prop('checked', true).addClass('give-default-level');
					break;

				// Set focus to price id button.
				case !!$form.find('button.give-donation-level-btn').length:
					$form.find('button.give-donation-level-btn').blur();
					$form.find('button.give-donation-level-btn[data-price-id="' + price_id + '"]').focus().addClass('give-default-level');
					break;

				// Auto select option.
				case !!$form.find('select.give-select-level').length:
					$form.find('select.give-select-level option').prop('selected', false);
					$form.find('select.give-select-level option[data-price-id="' + price_id + '"]').prop('selected', true).addClass('give-default-level');
					break;

			}
		},

		/**
   * Update level values
   *
   * Helper function: Sets the multi-select amount values
   *
   * @since 1.8.17
   * @param {object} $level
   * @returns {boolean}
   */
		autoSetMultiLevel: function autoSetMultiLevel($level) {

			var $form = $level.parents('form'),
			    level_amount = $level.val(),
			    level_price_id = $level.data('price-id');

			// Check if price ID blank because of dropdown type
			if ('undefined' === typeof level_price_id) {
				level_price_id = $level.find('option:selected').data('price-id');
			}

			// Is this a custom amount selection?
			if ('custom' === level_price_id) {
				// It is, so focus on the custom amount input.
				$form.find('.give-amount-top').val('').focus();
				return false; // Bounce out
			}

			// Update custom amount field
			$form.find('.give-amount-top').val(level_amount);
			$form.find('span.give-amount-top').text(level_amount);

			var decimal_separator = Give.form.fn.getInfo('decimal_separator', $form);

			// Cache previous amount and set data amount.
			jQuery('.give-donation-amount .give-text-input', $form).attr('data-amount', Give.fn.unFormatCurrency($form.find('.give-final-total-amount').attr('data-total'), decimal_separator));

			// Manually trigger blur event with two params:
			// (a) form jquery object
			// (b) price id
			// (c) donation amount
			$form.find('.give-donation-amount .give-text-input').trigger('blur', [$form, level_amount, level_price_id]);
		},

		/**
   * Donor sent back to the form
   *
   * @since 1.8.17
   * @access private
   */
		__sendBackToForm: function __sendBackToForm() {

			var form_id = Give.fn.getParameterByName('form-id'),
			    payment_mode = Give.fn.getParameterByName('payment-mode');

			// Sanity check - only proceed if query strings in place.
			if (!form_id || !payment_mode) {
				return false;
			}

			var $form_wrapper = jQuery('body').find('#give-form-' + form_id + '-wrap'),
			    $form = $form_wrapper.find('form.give-form'),
			    display_modal = $form_wrapper.hasClass('give-display-modal'),
			    display_button = $form_wrapper.hasClass('give-display-button'),
			    display_reveal = $form_wrapper.hasClass('give-display-reveal');

			// Update payment mode radio so it's correctly checked.
			$form.find('#give-gateway-radio-list label').removeClass('give-gateway-option-selected');
			$form.find('input[name=payment-mode][value=' + payment_mode + ']').prop('checked', true).parent().addClass('give-gateway-option-selected');

			// Select the proper level for Multi-level forms.
			// It can either be a dropdown, buttons, or radio list. Default is buttons field type.
			var level_id = Give.fn.getParameterByName('level-id'),
			    level_field = $form.find('*[data-price-id="' + level_id + '"]');

			if (level_field.length > 0) {
				this.autoSetMultiLevel(level_field);
			}

			var give_form_wrap = jQuery('.give-form-wrap'),
			    is_form_grid = give_form_wrap.hasClass('give-form-grid-wrap');

			if (is_form_grid && 1 === jQuery('#give-modal-form-' + form_id).length) {
				jQuery.magnificPopup.open({
					items: {
						type: 'inline',
						src: '#give-modal-form-' + form_id
					},
					fixedContentPos: true,
					fixedBgPos: true,
					closeBtnInside: true,
					midClick: true,
					removalDelay: 300,
					mainClass: 'modal-fade-slide'
				});

				return;
			}

			// This form is modal display so show the modal.
			if (display_modal || display_button) {
				give_open_form_modal($form_wrapper, $form);
			} else if (display_reveal) {
				// This is a reveal form, show it.
				$form.find('.give-btn-reveal').hide();
				$form.find('#give-payment-mode-select, #give_purchase_form_wrap').slideDown();
			}
		},

		/**
   * Check if donation amount valid or not
   * @since 1.8.17
   *
   * @param {object} $form
   *
   * @return {boolean}
   */
		isValidDonationAmount: function isValidDonationAmount($form) {

			// Return true, if custom amount is not enabled.
			if ($form.find('input[name="give-form-minimum"]').length <= 0) {
				return true;
			}

			var min_amount = this.getMinimumAmount($form),
			    max_amount = this.getMaximumAmount($form),
			    amount = this.getAmount($form),
			    price_id = this.getPriceID($form, true);

			// Don't allow zero donation amounts.
			// https://github.com/WordImpress/Give/issues/3181
			if (0 === amount) {
				return false;
			}

			return -1 < amount && amount >= min_amount && amount <= max_amount || -1 !== price_id;
		},

		/**
   * Initialize cache.
   *
   * @since 1.8.17
   * @private
   */
		__initialize_cache: function __initialize_cache() {
			jQuery.each(jQuery('.give-form'), function (index, $item) {
				$item = $item instanceof jQuery ? $item : jQuery($item);

				Give.cache['form_' + Give.form.fn.getInfo('form-id', $item)] = [];
			});
		},

		field: {

			/**
    * Format CC Fields
    *
    * Set variables and format cc fields.
    *
    * @since 1.2
    *
    * @param {object} $forms
    */
			formatCreditCard: function formatCreditCard($forms) {
				//Loop through forms on page and set CC validation
				$forms.each(function (index, form) {
					form = jQuery(form);
					var card_number = form.find('.card-number'),
					    card_cvc = form.find('.card-cvc'),
					    card_expiry = form.find('.card-expiry');

					//Only validate if there is a card field
					if (card_number.length) {
						card_number.payment('formatCardNumber');
						card_cvc.payment('formatCardCVC');
						card_expiry.payment('formatCardExpiry');
					}
				});
			}
		}
	}
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

(function (globalSope) {
    'use strict';

    /**
     * Including this file adds the `addDynamicListener` to the ELement prototype.
     * 
     * The dynamic listener gets an extra `selector` parameter that only calls the callback
     * if the target element matches the selector.
     * 
     * The listener has to be added to the container/root element and the selector should match
     * the elements that should trigger the event.
     * 
     * Browser support: IE9+
     */

    // Polyfil Element.matches
    // https://developer.mozilla.org/en/docs/Web/API/Element/matches#Polyfill

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        };
    }

    /**
     * Returns a modified callback function that calls the
     * initial callback function only if the target element matches the given selector
     * 
     * @param {string} selector 
     * @param {function} callback 
     */
    function getConditionalCallback(selector, callback) {
        return function (e) {
            if (!e.target) return;
            if (!e.target.matches(selector)) return;
            callback.apply(this, arguments);
        };
    }

    /**
     * 
     * 
     * @param {Element} rootElement The root element to add the linster too.
     * @param {string} eventType The event type to listen for.
     * @param {string} selector The selector that should match the dynamic elements.
     * @param {function} callback The function to call when an event occurs on the given selector.
     * @param {boolean|object} options Passed as the regular `options` parameter to the addEventListener function
     *                                 Set to `true` to use capture.
     *                                 Usually used as an object to add the listener as `passive`
     */
    globalSope.addDynamicEventListener = function (rootElement, eventType, selector, callback, options) {
        rootElement.addEventListener(eventType, getConditionalCallback(selector, callback), options);
    };
})(window);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveModal", function() { return GiveModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveErrorAlert", function() { return GiveErrorAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveWarningAlert", function() { return GiveWarningAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveNoticeAlert", function() { return GiveNoticeAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveSuccessAlert", function() { return GiveSuccessAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveConfirmModal", function() { return GiveConfirmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GiveFormModal", function() { return GiveFormModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_magnific_popup__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_magnific_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_magnific_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamicListener_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamicListener_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dynamicListener_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This API is under development, so do not use this in production.
 * We will open this API for use after some testing (coming releases).
 */
/* globals Give, jQuery */



/**
 * This abstract class is base for modal
 *
 * @since 2.1.0
 */

var GiveModal = function () {
	function GiveModal(obj) {
		_classCallCheck(this, GiveModal);

		if (GiveModal === this.constructor) {
			throw new Error('Abstract classes can\'t be instantiated.');
		}

		this.config = Object.assign({
			type: '',
			triggerSelector: '',
			externalPlugin: 'magnificPopup',
			classes: { modalWrapper: '' },
			modalContent: {}
		}, obj);

		// Set main class.
		this.config.mainClass = ((this.config.mainClass ? this.config.mainClass : '') + ' modal-fade-slide').trim();
	}

	/**
  * Bootstrap
  */


	_createClass(GiveModal, [{
		key: 'init',
		value: function init() {
			this.setupTemplate();
			this.popupConfig();
			this.__setupClickEvent();
		}

		/**
   * Get template
   *
   * @since 2.1.0
   *
   * @return {string} Template HTML.
   */

	}, {
		key: 'getTemplate',
		value: function getTemplate() {
			var template = '<div class="give-hidden"></div>';

			if (this.config.type.length) {
				template = '<div class="give-modal give-modal--zoom ' + (this.config.classes.modalWrapper ? ('' + this.config.classes.modalWrapper).trim() : '') + '">\n\n\t\t\t\t<div class="give-modal__body">\n\t\t\t\t\t' + (this.config.modalContent.title ? '<h2 class="give-modal__title">' + this.config.modalContent.title + '</h2>' : '') + '\n\t\t\t\t\t' + (this.config.modalContent.desc ? '<p class="give-modal__description">' + this.config.modalContent.desc + '</p>' : '') + '\n\t\t\t\t</div>\n\t\n\t\t\t\t<div class="give-modal__controls">\n\n\t\t\t\t\t' + ('form' === this.config.type ? '<div class="spinner"></div>' : '') + '\n\t\t\t\t\t' + ('form' === this.config.type ? '<a class="give-modal--additional-link" href="' + this.config.modalContent.link + '">' + this.config.modalContent.link_text + '</a>' : '') + '\n\n\t\t\t\t\t<button class="give-button give-button--secondary give-popup-close-button">\n\t\t\t\t\t\t' + (this.config.modalContent.cancelBtnTitle ? this.config.modalContent.cancelBtnTitle : 'confirm' === this.config.type ? Give.fn.getGlobalVar('cancel') : Give.fn.getGlobalVar('close')) + '\n\t\t\t\t\t</button>\n\n\t\t\t\t\t' + ('confirm' !== this.config.type && 'form' !== this.config.type ? '' : '<button class="give-button give-button--primary give-popup-' + this.config.type + '-button">\n\n\t\t\t\t\t\t' + (this.config.modalContent.confirmBtnTitle ? this.config.modalContent.confirmBtnTitle : Give.fn.getGlobalVar('confirm')) + '\n\t\t\t\t\t</button>') + '\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t</div>';
			}

			return template;
		}

		/**
   * Setup template
   *
   * @since 2.1.0
   */

	}, {
		key: 'setupTemplate',
		value: function setupTemplate() {
			this.config.template = this.getTemplate();
		}

		/**
   * Handle click event if triggerSelector is set.
   *
   * @since 2.1.0
   * @private
   */

	}, {
		key: '__setupClickEvent',
		value: function __setupClickEvent() {
			// Bailout.
			if (!this.config.triggerSelector.length) {
				return;
			}

			jQuery(this.config.triggerSelector).magnificPopup(this.config);
		}

		/**
   * Setup popup params
   *
   * Note: only for internal purpose
   *
   * @since 2.1.0
   * @private
   */

	}, {
		key: 'popupConfig',
		value: function popupConfig() {
			if ('magnificPopup' === this.config.externalPlugin) {
				this.config.items = this.config.items || {
					src: this.config.template,
					type: 'inline'
				};

				this.config.removalDelay = 300;
				this.config.fixedContentPos = true;
				this.config.fixedBgPos = true;
				this.config.alignTop = true;
				this.config.showCloseBtn = false;
				this.config.closeOnBgClick = false;
				this.config.enableEscapeKey = true;
				this.config.focus = '.give-popup-close-button';
			}
		}

		/**
   * Click close button event handler
   *
   * @since 2.1.0
   * @private
   *
   * @param {object} event Event object.
   */

	}, {
		key: 'render',


		/**
   * Give's Notice Popup
   *
   * @since 2.1.0
   *
   * @return {object} GiveModal class object.
   */
		value: function render() {
			switch (this.config.externalPlugin) {
				case 'magnificPopup':
					if (!this.config.triggerSelector) {
						jQuery.magnificPopup.open(this.config);
					}

					break;
			}

			return this;
		}
	}], [{
		key: '__closePopup',
		value: function __closePopup(event) {
			event.preventDefault();
			jQuery.magnificPopup.instance.close();
		}
	}]);

	return GiveModal;
}();

/**
 * This class will handle error alert modal
 *
 * @since 2.1.0
 */


var GiveErrorAlert = function (_GiveModal) {
	_inherits(GiveErrorAlert, _GiveModal);

	function GiveErrorAlert(obj) {
		_classCallCheck(this, GiveErrorAlert);

		obj.type = 'alert';

		var _this = _possibleConstructorReturn(this, (GiveErrorAlert.__proto__ || Object.getPrototypeOf(GiveErrorAlert)).call(this, obj));

		_this.config.classes.modalWrapper = 'give-modal--error';

		_this.init();
		return _this;
	}

	return GiveErrorAlert;
}(GiveModal);

/**
 * This class will handle warning alert modal
 *
 * @since 2.1.0
 */


var GiveWarningAlert = function (_GiveModal2) {
	_inherits(GiveWarningAlert, _GiveModal2);

	function GiveWarningAlert(obj) {
		_classCallCheck(this, GiveWarningAlert);

		obj.type = 'alert';

		var _this2 = _possibleConstructorReturn(this, (GiveWarningAlert.__proto__ || Object.getPrototypeOf(GiveWarningAlert)).call(this, obj));

		_this2.config.classes.modalWrapper = 'give-modal--warning';

		_this2.init();
		return _this2;
	}

	return GiveWarningAlert;
}(GiveModal);

/**
 * This class will handle notice alert modal
 *
 * @since 2.1.0
 */


var GiveNoticeAlert = function (_GiveModal3) {
	_inherits(GiveNoticeAlert, _GiveModal3);

	function GiveNoticeAlert(obj) {
		_classCallCheck(this, GiveNoticeAlert);

		obj.type = 'alert';

		var _this3 = _possibleConstructorReturn(this, (GiveNoticeAlert.__proto__ || Object.getPrototypeOf(GiveNoticeAlert)).call(this, obj));

		_this3.config.classes.modalWrapper = 'give-modal--notice';

		_this3.init();
		return _this3;
	}

	return GiveNoticeAlert;
}(GiveModal);

/**
 * This class will handle success alert modal
 *
 * @since 2.1.0
 */


var GiveSuccessAlert = function (_GiveModal4) {
	_inherits(GiveSuccessAlert, _GiveModal4);

	function GiveSuccessAlert(obj) {
		_classCallCheck(this, GiveSuccessAlert);

		obj.type = 'alert';

		var _this4 = _possibleConstructorReturn(this, (GiveSuccessAlert.__proto__ || Object.getPrototypeOf(GiveSuccessAlert)).call(this, obj));

		_this4.config.classes.modalWrapper = 'give-modal--success';

		_this4.init();
		return _this4;
	}

	return GiveSuccessAlert;
}(GiveModal);

/**
 * This class will handle confirm modal
 *
 * @since 2.1.0
 */


var GiveConfirmModal = function (_GiveModal5) {
	_inherits(GiveConfirmModal, _GiveModal5);

	function GiveConfirmModal(obj) {
		_classCallCheck(this, GiveConfirmModal);

		obj.type = 'confirm';

		var _this5 = _possibleConstructorReturn(this, (GiveConfirmModal.__proto__ || Object.getPrototypeOf(GiveConfirmModal)).call(this, obj));

		if ('undefined' !== typeof obj.modalWrapper && '' !== obj.modalWrapper) {
			_this5.config.classes.modalWrapper = obj.modalWrapper;
		}

		_this5.init();
		return _this5;
	}

	/**
  * Confirm button click event handler
  *
  * Note: only for internal purpose
  *
  * @since 2.1.0
  * @private
  */


	_createClass(GiveConfirmModal, null, [{
		key: '__confirmPopup',
		value: function __confirmPopup() {
			if ('function' === typeof jQuery.magnificPopup.instance.st.successConfirm) {
				jQuery.magnificPopup.instance.st.successConfirm({
					el: jQuery.magnificPopup.instance.st.el
				});
				jQuery.magnificPopup.close();
			}
		}
	}]);

	return GiveConfirmModal;
}(GiveModal);

/**
 * This class will handle Form modal
 *
 * @since 2.2.0
 */


var GiveFormModal = function (_GiveModal6) {
	_inherits(GiveFormModal, _GiveModal6);

	function GiveFormModal(obj) {
		_classCallCheck(this, GiveFormModal);

		obj.type = 'form';

		var _this6 = _possibleConstructorReturn(this, (GiveFormModal.__proto__ || Object.getPrototypeOf(GiveFormModal)).call(this, obj));

		if ('undefined' !== typeof obj.modalWrapper && '' !== obj.modalWrapper) {
			_this6.config.classes.modalWrapper = obj.modalWrapper;
		}

		_this6.init();
		return _this6;
	}

	/**
  * Submit button click event handler
  *
  * Note: only for internal purpose
  *
  * @since 2.2.0
  * @private
  */


	_createClass(GiveFormModal, null, [{
		key: '__submitPopup',
		value: function __submitPopup() {
			if ('function' === typeof jQuery.magnificPopup.instance.st.successConfirm) {
				jQuery.magnificPopup.instance.st.successConfirm({
					el: jQuery.magnificPopup.instance.st.el
				});
			}
		}
	}]);

	return GiveFormModal;
}(GiveModal);

/**
 * Add events
 */


window.addDynamicEventListener(document, 'click', '.give-popup-close-button', GiveModal.__closePopup, {});
window.addDynamicEventListener(document, 'click', '.give-popup-confirm-button', GiveConfirmModal.__confirmPopup, {});
window.addDynamicEventListener(document, 'click', '.give-popup-form-button', GiveFormModal.__submitPopup, {});



/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(26);
module.exports = __webpack_require__(27);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fn", function() { return fn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modal", function() { return modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chosen_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chosen_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chosen_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flot__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flot_orderbars_js_jquery_flot_orderBars__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flot_orderbars_js_jquery_flot_orderBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flot_orderbars_js_jquery_flot_orderBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flot_jquery_flot_time__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flot_jquery_flot_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flot_jquery_flot_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_give_ajaxify_fields__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_give_ajaxify_fields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__plugins_give_ajaxify_fields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_selector_cache__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_selector_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__plugins_selector_cache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_repeatable_fields__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_repeatable_fields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__plugins_repeatable_fields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_give_hint_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_give_hint_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__plugins_give_hint_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_modal_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_forms__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__admin_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin_settings__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__admin_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_export__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_export___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__admin_export__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__admin_widgets__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__admin_widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__admin_widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__admin_scripts__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__admin_importer__ = __webpack_require__(40);
// Plugins






// Give plugins.








// Give core.







__WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__["a" /* default */].modal = __WEBPACK_IMPORTED_MODULE_10__plugins_modal_js__;
var init = __WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__["a" /* default */].init,
    fn = __WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__["a" /* default */].fn,
    cache = __WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__["a" /* default */].cache,
    modal = __WEBPACK_IMPORTED_MODULE_9__plugins_give_api_api__["a" /* default */].modal;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

(function() {
  var $, AbstractChosen, Chosen, SelectParser,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SelectParser = (function() {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, i, len, option, ref, results1;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        title: group.title ? group.title : void 0,
        children: 0,
        disabled: group.disabled,
        classes: group.className
      });
      ref = group.childNodes;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        results1.push(this.add_option(option, group_position, group.disabled));
      }
      return results1;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            title: option.title ? option.title : void 0,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label: group_position != null ? this.parsed[group_position].label : null,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, i, len, parser, ref;
    parser = new SelectParser();
    ref = select.childNodes;
    for (i = 0, len = ref.length; i < len; i++) {
      child = ref[i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  AbstractChosen = (function() {
    function AbstractChosen(form_field, options1) {
      this.form_field = form_field;
      this.options = options1 != null ? options1 : {};
      this.label_click_handler = bind(this.label_click_handler, this);
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function() {
      this.click_test_action = (function(_this) {
        return function(evt) {
          return _this.test_active_click(evt);
        };
      })(this);
      this.activate_action = (function(_this) {
        return function(evt) {
          return _this.activate_field(evt);
        };
      })(this);
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      this.case_sensitive_search = this.options.case_sensitive_search || false;
      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      this.default_text = this.escape_html(this.default_text);
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };

    AbstractChosen.prototype.choice_label = function(item) {
      if (this.include_group_label_in_selected && (item.group_label != null)) {
        return "<b class='group-name'>" + (this.escape_html(item.group_label)) + "</b>" + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.container_mousedown();
            };
          })(this)), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout(((function(_this) {
          return function() {
            return _this.blur_test();
          };
        })(this)), 100);
      }
    };

    AbstractChosen.prototype.label_click_handler = function(evt) {
      if (this.is_multiple) {
        return this.container_mousedown(evt);
      } else {
        return this.activate_field();
      }
    };

    AbstractChosen.prototype.results_option_build = function(options) {
      var content, data, data_content, i, len, ref, shown_results;
      content = '';
      shown_results = 0;
      ref = this.results_data;
      for (i = 0, len = ref.length; i < len; i++) {
        data = ref[i];
        data_content = '';
        if (data.group) {
          data_content = this.result_add_group(data);
        } else {
          data_content = this.result_add_option(data);
        }
        if (data_content !== '') {
          shown_results++;
          content += data_content;
        }
        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }
        if (shown_results >= this.max_shown_results) {
          break;
        }
      }
      return content;
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, option_el;
      if (!option.search_match) {
        return '';
      }
      if (!this.include_option_in_results(option)) {
        return '';
      }
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }
      if (option.selected) {
        classes.push("result-selected");
      }
      if (option.group_array_index != null) {
        classes.push("group-option");
      }
      if (option.classes !== "") {
        classes.push(option.classes);
      }
      option_el = document.createElement("li");
      option_el.className = classes.join(" ");
      if (option.style) {
        option_el.style.cssText = option.style;
      }
      option_el.setAttribute("data-option-array-index", option.array_index);
      option_el.innerHTML = option.highlighted_html || option.html;
      if (option.title) {
        option_el.title = option.title;
      }
      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function(group) {
      var classes, group_el;
      if (!(group.search_match || group.group_match)) {
        return '';
      }
      if (!(group.active_options > 0)) {
        return '';
      }
      classes = [];
      classes.push("group-result");
      if (group.classes) {
        classes.push(group.classes);
      }
      group_el = document.createElement("li");
      group_el.className = classes.join(" ");
      group_el.innerHTML = group.highlighted_html || this.escape_html(group.label);
      if (group.title) {
        group_el.title = group.title;
      }
      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function() {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.results_build();
      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function() {
      var i, len, ref, result, results1;
      ref = this.results_data;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        result = ref[i];
        if (result.selected) {
          results1.push(result.selected = false);
        } else {
          results1.push(void 0);
        }
      }
      return results1;
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function(options) {
      var escapedQuery, fix, i, len, option, prefix, query, ref, regex, results, results_group, search_match, startpos, suffix, text;
      this.no_results_clear();
      results = 0;
      query = this.get_search_text();
      escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      regex = this.get_search_regex(escapedQuery);
      ref = this.results_data;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        option.search_match = false;
        results_group = null;
        search_match = null;
        option.highlighted_html = '';
        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }
          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];
            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }
            results_group.active_options += 1;
          }
          text = option.group ? option.label : option.text;
          if (!(option.group && !this.group_search)) {
            search_match = this.search_string_match(text, regex);
            option.search_match = search_match != null;
            if (option.search_match && !option.group) {
              results += 1;
            }
            if (option.search_match) {
              if (query.length) {
                startpos = search_match.index;
                prefix = text.slice(0, startpos);
                fix = text.slice(startpos, startpos + query.length);
                suffix = text.slice(startpos + query.length);
                option.highlighted_html = (this.escape_html(prefix)) + "<em>" + (this.escape_html(fix)) + "</em>" + (this.escape_html(suffix));
              }
              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }
      this.result_clear_highlight();
      if (results < 1 && query.length) {
        this.update_results_content("");
        return this.no_results(query);
      } else {
        this.update_results_content(this.results_option_build());
        if (!(options != null ? options.skip_highlight : void 0)) {
          return this.winnow_results_set_highlight();
        }
      }
    };

    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
      var regex_flag, regex_string;
      regex_string = this.search_contains ? escaped_search_string : "(^|\\s|\\b)" + escaped_search_string + "[^\\s]*";
      if (!(this.enable_split_word_search || this.search_contains)) {
        regex_string = "^" + regex_string;
      }
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_string, regex_flag);
    };

    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
      var match;
      match = regex.exec(search_string);
      if (!this.search_contains && (match != null ? match[1] : void 0)) {
        match.index += 1;
      }
      return match;
    };

    AbstractChosen.prototype.choices_count = function() {
      var i, len, option, ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      ref = this.form_field.options;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      this.activate_field();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keydown_checker = function(evt) {
      var ref, stroke;
      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.get_search_field_value().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 27:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 32:
          if (this.disable_search) {
            evt.preventDefault();
          }
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var ref, stroke;
      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          break;
        case 9:
        case 16:
        case 17:
        case 18:
        case 38:
        case 40:
        case 91:
          break;
        default:
          this.results_search();
          break;
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
      if (this.is_disabled) {
        return;
      }
      return setTimeout(((function(_this) {
        return function() {
          return _this.results_search();
        };
      })(this)), 50);
    };

    AbstractChosen.prototype.container_width = function() {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return this.form_field.offsetWidth + "px";
      }
    };

    AbstractChosen.prototype.include_option_in_results = function(option) {
      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
        return false;
      }
      if (!this.display_disabled_options && option.disabled) {
        return false;
      }
      if (option.empty) {
        return false;
      }
      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function(evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function(evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function(evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function(element) {
      var tmp;
      if (element.outerHTML) {
        return element.outerHTML;
      }
      tmp = document.createElement("div");
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.prototype.get_single_html = function() {
      return "<a class=\"chosen-single chosen-default\">\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_multi_html = function() {
      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_no_results_html = function(terms) {
      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + (this.escape_html(terms)) + "</span>\n</li>";
    };

    AbstractChosen.browser_is_supported = function() {
      if ("Microsoft Internet Explorer" === window.navigator.appName) {
        return document.documentMode >= 8;
      }
      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        return false;
      }
      return true;
    };

    AbstractChosen.default_multiple_text = "Select Some Options";

    AbstractChosen.default_single_text = "Select an Option";

    AbstractChosen.default_no_result_text = "No results match";

    return AbstractChosen;

  })();

  $ = jQuery;

  $.fn.extend({
    chosen: function(options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function(input_field) {
        var $this, chosen;
        $this = $(this);
        chosen = $this.data('chosen');
        if (options === 'destroy') {
          if (chosen instanceof Chosen) {
            chosen.destroy();
          }
          return;
        }
        if (!(chosen instanceof Chosen)) {
          $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function(superClass) {
    extend(Chosen, superClass);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function() {
      this.form_field_jq = $(this.form_field);
      return this.current_selectedIndex = this.form_field.selectedIndex;
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_props;
      container_classes = ["chosen-container"];
      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chosen-rtl");
      }
      container_props = {
        'class': container_classes.join(' '),
        'title': this.form_field.title
      };
      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
      }
      this.container = $("<div />", container_props);
      this.container.width(this.container_width());
      if (this.is_multiple) {
        this.container.html(this.get_multi_html());
      } else {
        this.container.html(this.get_single_html());
      }
      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find('div.chosen-drop').first();
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chosen-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chosen-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chosen-search').first();
        this.selected_item = this.container.find('.chosen-single').first();
      }
      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function() {
      return this.form_field_jq.trigger("chosen:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      this.container.on('touchstart.chosen', (function(_this) {
        return function(evt) {
          _this.container_mousedown(evt);
        };
      })(this));
      this.container.on('touchend.chosen', (function(_this) {
        return function(evt) {
          _this.container_mouseup(evt);
        };
      })(this));
      this.container.on('mousedown.chosen', (function(_this) {
        return function(evt) {
          _this.container_mousedown(evt);
        };
      })(this));
      this.container.on('mouseup.chosen', (function(_this) {
        return function(evt) {
          _this.container_mouseup(evt);
        };
      })(this));
      this.container.on('mouseenter.chosen', (function(_this) {
        return function(evt) {
          _this.mouse_enter(evt);
        };
      })(this));
      this.container.on('mouseleave.chosen', (function(_this) {
        return function(evt) {
          _this.mouse_leave(evt);
        };
      })(this));
      this.search_results.on('mouseup.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_mouseup(evt);
        };
      })(this));
      this.search_results.on('mouseover.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_mouseover(evt);
        };
      })(this));
      this.search_results.on('mouseout.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_mouseout(evt);
        };
      })(this));
      this.search_results.on('mousewheel.chosen DOMMouseScroll.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_mousewheel(evt);
        };
      })(this));
      this.search_results.on('touchstart.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_touchstart(evt);
        };
      })(this));
      this.search_results.on('touchmove.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_touchmove(evt);
        };
      })(this));
      this.search_results.on('touchend.chosen', (function(_this) {
        return function(evt) {
          _this.search_results_touchend(evt);
        };
      })(this));
      this.form_field_jq.on("chosen:updated.chosen", (function(_this) {
        return function(evt) {
          _this.results_update_field(evt);
        };
      })(this));
      this.form_field_jq.on("chosen:activate.chosen", (function(_this) {
        return function(evt) {
          _this.activate_field(evt);
        };
      })(this));
      this.form_field_jq.on("chosen:open.chosen", (function(_this) {
        return function(evt) {
          _this.container_mousedown(evt);
        };
      })(this));
      this.form_field_jq.on("chosen:close.chosen", (function(_this) {
        return function(evt) {
          _this.close_field(evt);
        };
      })(this));
      this.search_field.on('blur.chosen', (function(_this) {
        return function(evt) {
          _this.input_blur(evt);
        };
      })(this));
      this.search_field.on('keyup.chosen', (function(_this) {
        return function(evt) {
          _this.keyup_checker(evt);
        };
      })(this));
      this.search_field.on('keydown.chosen', (function(_this) {
        return function(evt) {
          _this.keydown_checker(evt);
        };
      })(this));
      this.search_field.on('focus.chosen', (function(_this) {
        return function(evt) {
          _this.input_focus(evt);
        };
      })(this));
      this.search_field.on('cut.chosen', (function(_this) {
        return function(evt) {
          _this.clipboard_event_checker(evt);
        };
      })(this));
      this.search_field.on('paste.chosen', (function(_this) {
        return function(evt) {
          _this.clipboard_event_checker(evt);
        };
      })(this));
      if (this.is_multiple) {
        return this.search_choices.on('click.chosen', (function(_this) {
          return function(evt) {
            _this.choices_click(evt);
          };
        })(this));
      } else {
        return this.container.on('click.chosen', function(evt) {
          evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function() {
      $(this.container[0].ownerDocument).off('click.chosen', this.click_test_action);
      if (this.form_field_label.length > 0) {
        this.form_field_label.off('click.chosen');
      }
      if (this.search_field[0].tabIndex) {
        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
      }
      this.container.remove();
      this.form_field_jq.removeData('chosen');
      return this.form_field_jq.show();
    };

    Chosen.prototype.search_field_disabled = function() {
      this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
      this.container.toggleClass('chosen-disabled', this.is_disabled);
      this.search_field[0].disabled = this.is_disabled;
      if (!this.is_multiple) {
        this.selected_item.off('focus.chosen', this.activate_field);
      }
      if (this.is_disabled) {
        return this.close_field();
      } else if (!this.is_multiple) {
        return this.selected_item.on('focus.chosen', this.activate_field);
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      var ref;
      if (this.is_disabled) {
        return;
      }
      if (evt && ((ref = evt.type) === 'mousedown' || ref === 'touchstart') && !this.results_showing) {
        evt.preventDefault();
      }
      if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
        if (!this.active_field) {
          if (this.is_multiple) {
            this.search_field.val("");
          }
          $(this.container[0].ownerDocument).on('click.chosen', this.click_test_action);
          this.results_show();
        } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
          evt.preventDefault();
          this.results_toggle();
        }
        return this.activate_field();
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function(evt) {
      var delta;
      if (evt.originalEvent) {
        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
      }
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }
        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      $(this.container[0].ownerDocument).off("click.chosen", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chosen-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      this.search_field_scale();
      return this.search_field.blur();
    };

    Chosen.prototype.activate_field = function() {
      if (this.is_disabled) {
        return;
      }
      this.container.addClass("chosen-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      var active_container;
      active_container = $(evt.target).closest('.chosen-container');
      if (active_container.length && this.container[0] === active_container[0]) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.find("li.search-choice").remove();
      } else {
        this.single_set_selected_text();
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass("chosen-container-single-nosearch");
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass("chosen-container-single-nosearch");
        }
      }
      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger("chosen:maxselected", {
          chosen: this
        });
        return false;
      }
      this.container.addClass("chosen-with-drop");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.get_search_field_value());
      this.winnow_results();
      return this.form_field_jq.trigger("chosen:showing_dropdown", {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function(content) {
      return this.search_results.html(content);
    };

    Chosen.prototype.results_hide = function() {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass("chosen-with-drop");
        this.form_field_jq.trigger("chosen:hiding_dropdown", {
          chosen: this
        });
      }
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field[0].tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function() {
      this.form_field_label = this.form_field_jq.parents("label");
      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $("label[for='" + this.form_field.id + "']");
      }
      if (this.form_field_label.length > 0) {
        return this.form_field_label.on('click.chosen', this.label_click_handler);
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if ($(evt.target).hasClass("active-result") || $(evt.target).parents('.active-result').first()) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice, close_link;
      choice = $('<li />', {
        "class": "search-choice"
      }).html("<span>" + (this.choice_label(item)) + "</span>");
      if (item.disabled) {
        choice.addClass('search-choice-disabled');
      } else {
        close_link = $('<a />', {
          "class": 'search-choice-close',
          'data-option-array-index': item.array_index
        });
        close_link.on('click.chosen', (function(_this) {
          return function(evt) {
            return _this.choice_destroy_link_click(evt);
          };
        })(this));
        choice.append(close_link);
      }
      return this.search_container.before(choice);
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        return this.choice_destroy($(evt.target));
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
        if (this.active_field) {
          this.search_field.focus();
        } else {
          this.show_search_field_default();
        }
        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.trigger_form_field_change();
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function(evt) {
      var high, item;
      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("chosen:maxselected", {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClass("active-result");
        } else {
          this.reset_single_select_options();
        }
        high.addClass("result-selected");
        item = this.results_data[high[0].getAttribute("data-option-array-index")];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }
        if (this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey))) {
          if (evt.metaKey || evt.ctrlKey) {
            this.winnow_results({
              skip_highlight: true
            });
          } else {
            this.search_field.val("");
            this.winnow_results();
          }
        } else {
          this.results_hide();
          this.show_search_field_default();
        }
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.trigger_form_field_change({
            selected: this.form_field.options[item.options_index].value
          });
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function(text) {
      if (text == null) {
        text = this.default_text;
      }
      if (text === this.default_text) {
        this.selected_item.addClass("chosen-default");
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClass("chosen-default");
      }
      return this.selected_item.find("span").html(text);
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();
        if (this.results_showing) {
          this.winnow_results();
        }
        this.trigger_form_field_change({
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.find("abbr").length) {
        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
      return this.selected_item.addClass("chosen-single-with-deselect");
    };

    Chosen.prototype.get_search_field_value = function() {
      return this.search_field.val();
    };

    Chosen.prototype.get_search_text = function() {
      return $.trim(this.get_search_field_value());
    };

    Chosen.prototype.escape_html = function(text) {
      return $('<div/>').text(text).html();
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high, selected_results;
      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function(terms) {
      var no_results_html;
      no_results_html = this.get_no_results_html(terms);
      this.search_results.append(no_results_html);
      return this.form_field_jq.trigger("chosen:no_results", {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function() {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function() {
      var next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.search_field_scale = function() {
      var div, i, len, style, style_block, styles, width;
      if (!this.is_multiple) {
        return;
      }
      style_block = {
        position: 'absolute',
        left: '-1000px',
        top: '-1000px',
        display: 'none',
        whiteSpace: 'pre'
      };
      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];
      for (i = 0, len = styles.length; i < len; i++) {
        style = styles[i];
        style_block[style] = this.search_field.css(style);
      }
      div = $('<div />').css(style_block);
      div.text(this.get_search_field_value());
      $('body').append(div);
      width = div.width() + 25;
      div.remove();
      if (this.container.is(':visible')) {
        width = Math.min(this.container.outerWidth() - 10, width);
      }
      return this.search_field.width(width);
    };

    Chosen.prototype.trigger_form_field_change = function(extra) {
      this.form_field_jq.trigger("input", extra);
      return this.form_field_jq.trigger("change", extra);
    };

    return Chosen;

  })(AbstractChosen);

}).call(this);


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/* Javascript plotting library for jQuery, version 0.8 alpha.

Copyright (c) 2007-2012 IOLA and Ole Laursen.
Licensed under the MIT license.

*/

// first an inline dependency, jquery.colorhelpers.js, we inline it here
// for convenience

/* Plugin for jQuery for working with colors.
 *
 * Version 1.1.
 *
 * Inspiration from jQuery color animation plugin by John Resig.
 *
 * Released under the MIT license by Ole Laursen, October 2009.
 *
 * Examples:
 *
 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
 *   var c = $.color.extract($("#mydiv"), 'background-color');
 *   console.log(c.r, c.g, c.b, c.a);
 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
 *
 * Note that .scale() and .add() return the same modified object
 * instead of making a new one.
 *
 * V. 1.1: Fix error handling so e.g. parsing an empty string does
 * produce a color rather than just crashing.
 */
(function(B){B.color={};B.color.make=function(F,E,C,D){var G={};G.r=F||0;G.g=E||0;G.b=C||0;G.a=D!=null?D:1;G.add=function(J,I){for(var H=0;H<J.length;++H){G[J.charAt(H)]+=I}return G.normalize()};G.scale=function(J,I){for(var H=0;H<J.length;++H){G[J.charAt(H)]*=I}return G.normalize()};G.toString=function(){if(G.a>=1){return"rgb("+[G.r,G.g,G.b].join(",")+")"}else{return"rgba("+[G.r,G.g,G.b,G.a].join(",")+")"}};G.normalize=function(){function H(J,K,I){return K<J?J:(K>I?I:K)}G.r=H(0,parseInt(G.r),255);G.g=H(0,parseInt(G.g),255);G.b=H(0,parseInt(G.b),255);G.a=H(0,G.a,1);return G};G.clone=function(){return B.color.make(G.r,G.b,G.g,G.a)};return G.normalize()};B.color.extract=function(D,C){var E;do{E=D.css(C).toLowerCase();if(E!=""&&E!="transparent"){break}D=D.parent()}while(!B.nodeName(D.get(0),"body"));if(E=="rgba(0, 0, 0, 0)"){E="transparent"}return B.color.parse(E)};B.color.parse=function(F){var E,C=B.color.make;if(E=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(F)){return C(parseInt(E[1],10),parseInt(E[2],10),parseInt(E[3],10))}if(E=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(F)){return C(parseInt(E[1],10),parseInt(E[2],10),parseInt(E[3],10),parseFloat(E[4]))}if(E=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(F)){return C(parseFloat(E[1])*2.55,parseFloat(E[2])*2.55,parseFloat(E[3])*2.55)}if(E=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(F)){return C(parseFloat(E[1])*2.55,parseFloat(E[2])*2.55,parseFloat(E[3])*2.55,parseFloat(E[4]))}if(E=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(F)){return C(parseInt(E[1],16),parseInt(E[2],16),parseInt(E[3],16))}if(E=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(F)){return C(parseInt(E[1]+E[1],16),parseInt(E[2]+E[2],16),parseInt(E[3]+E[3],16))}var D=B.trim(F).toLowerCase();if(D=="transparent"){return C(255,255,255,0)}else{E=A[D]||[0,0,0];return C(E[0],E[1],E[2])}};var A={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}})(jQuery);

// the actual Flot code
(function($) {
    function Plot(placeholder, data_, options_, plugins) {
        // data is on the form:
        //   [ series1, series2 ... ]
        // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
        // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }

        var series = [],
            options = {
                // the color theme used for graphs
                colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
                legend: {
                    show: true,
                    noColumns: 1, // number of colums in legend table
                    labelFormatter: null, // fn: string -> string
                    labelBoxBorderColor: "#ccc", // border color for the little label boxes
                    container: null, // container (as jQuery object) to put legend in, null means default on top of graph
                    position: "ne", // position of default legend container within plot
                    margin: 5, // distance from grid edge to default legend container within plot
                    backgroundColor: null, // null means auto-detect
                    backgroundOpacity: 0.85, // set to 0 to avoid background
                    sorted: null    // default to no legend sorting
                },
                xaxis: {
                    show: null, // null = auto-detect, true = always, false = never
                    position: "bottom", // or "top"
                    mode: null, // null or "time"
                    timezone: null, // "browser" for local to the client or timezone for timezone-js
                    font: null, // null (derived from CSS in placeholder) or object like { size: 11, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
                    color: null, // base color, labels, ticks
                    tickColor: null, // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
                    transform: null, // null or f: number -> number to transform axis
                    inverseTransform: null, // if transform is set, this should be the inverse function
                    min: null, // min. value to show, null means set automatically
                    max: null, // max. value to show, null means set automatically
                    autoscaleMargin: null, // margin in % to add if auto-setting min/max
                    ticks: null, // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
                    tickFormatter: null, // fn: number -> string
                    labelWidth: null, // size of tick labels in pixels
                    labelHeight: null,
                    reserveSpace: null, // whether to reserve space even if axis isn't shown
                    tickLength: null, // size in pixels of ticks, or "full" for whole line
                    alignTicksWithAxis: null, // axis number or null for no sync

                    // mode specific options
                    tickDecimals: null, // no. of decimals, null means auto
                    tickSize: null, // number or [number, "unit"]
                    minTickSize: null, // number or [number, "unit"]
                    monthNames: null, // list of names of months
                    timeformat: null, // format string to use
                    twelveHourClock: false // 12 or 24 time in time mode
                },
                yaxis: {
                    autoscaleMargin: 0.02,
                    position: "left" // or "right"
                },
                xaxes: [],
                yaxes: [],
                series: {
                    points: {
                        show: false,
                        radius: 3,
                        lineWidth: 2, // in pixels
                        fill: true,
                        fillColor: "#ffffff",
                        symbol: "circle" // or callback
                    },
                    lines: {
                        // we don't put in show: false so we can see
                        // whether lines were actively disabled
                        lineWidth: 2, // in pixels
                        fill: false,
                        fillColor: null,
                        steps: false
                        // Omit 'zero', so we can later default its value to
                        // match that of the 'fill' option.
                    },
                    bars: {
                        show: false,
                        lineWidth: 2, // in pixels
                        barWidth: 1, // in units of the x axis
                        fill: true,
                        fillColor: null,
                        align: "left", // "left", "right", or "center"
                        horizontal: false,
                        zero: true
                    },
                    shadowSize: 3,
                    highlightColor: null
                },
                grid: {
                    show: true,
                    aboveData: false,
                    color: "#545454", // primary color used for outline and labels
                    backgroundColor: null, // null for transparent, else color
                    borderColor: null, // set if different from the grid color
                    tickColor: null, // color for the ticks, e.g. "rgba(0,0,0,0.15)"
                    margin: 0, // distance from the canvas edge to the grid
                    labelMargin: 5, // in pixels
                    axisMargin: 8, // in pixels
                    borderWidth: 2, // in pixels
                    minBorderMargin: null, // in pixels, null means taken from points radius
                    markings: null, // array of ranges or fn: axes -> array of ranges
                    markingsColor: "#f4f4f4",
                    markingsLineWidth: 2,
                    // interactive stuff
                    clickable: false,
                    hoverable: false,
                    autoHighlight: true, // highlight in case mouse is near
                    mouseActiveRadius: 10 // how far the mouse can be away to activate an item
                },
                interaction: {
                    redrawOverlayInterval: 1000/60 // time between updates, -1 means in same flow
                },
                hooks: {}
            },
        canvas = null,      // the canvas for the plot itself
        overlay = null,     // canvas for interactive stuff on top of plot
        eventHolder = null, // jQuery object that events should be bound to
        ctx = null, octx = null,
        xaxes = [], yaxes = [],
        plotOffset = { left: 0, right: 0, top: 0, bottom: 0},
        canvasWidth = 0, canvasHeight = 0,
        plotWidth = 0, plotHeight = 0,
        hooks = {
            processOptions: [],
            processRawData: [],
            processDatapoints: [],
            processOffset: [],
            drawBackground: [],
            drawSeries: [],
            draw: [],
            bindEvents: [],
            drawOverlay: [],
            shutdown: []
        },
        plot = this;

        // public functions
        plot.setData = setData;
        plot.setupGrid = setupGrid;
        plot.draw = draw;
        plot.getPlaceholder = function() { return placeholder; };
        plot.getCanvas = function() { return canvas; };
        plot.getPlotOffset = function() { return plotOffset; };
        plot.width = function () { return plotWidth; };
        plot.height = function () { return plotHeight; };
        plot.offset = function () {
            var o = eventHolder.offset();
            o.left += plotOffset.left;
            o.top += plotOffset.top;
            return o;
        };
        plot.getData = function () { return series; };
        plot.getAxes = function () {
            var res = {}, i;
            $.each(xaxes.concat(yaxes), function (_, axis) {
                if (axis)
                    res[axis.direction + (axis.n != 1 ? axis.n : "") + "axis"] = axis;
            });
            return res;
        };
        plot.getXAxes = function () { return xaxes; };
        plot.getYAxes = function () { return yaxes; };
        plot.c2p = canvasToAxisCoords;
        plot.p2c = axisToCanvasCoords;
        plot.getOptions = function () { return options; };
        plot.highlight = highlight;
        plot.unhighlight = unhighlight;
        plot.triggerRedrawOverlay = triggerRedrawOverlay;
        plot.pointOffset = function(point) {
            return {
                left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
                top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
            };
        };
        plot.shutdown = shutdown;
        plot.resize = function () {
            getCanvasDimensions();
            resizeCanvas(canvas);
            resizeCanvas(overlay);
        };

        // public attributes
        plot.hooks = hooks;

        // initialize
        initPlugins(plot);
        parseOptions(options_);
        setupCanvases();
        setData(data_);
        setupGrid();
        draw();
        bindEvents();


        function executeHooks(hook, args) {
            args = [plot].concat(args);
            for (var i = 0; i < hook.length; ++i)
                hook[i].apply(this, args);
        }

        function initPlugins() {
            for (var i = 0; i < plugins.length; ++i) {
                var p = plugins[i];
                p.init(plot);
                if (p.options)
                    $.extend(true, options, p.options);
            }
        }

        function parseOptions(opts) {
            var i;

            $.extend(true, options, opts);

            if (options.xaxis.color == null)
                options.xaxis.color = options.grid.color;
            if (options.yaxis.color == null)
                options.yaxis.color = options.grid.color;

            if (options.xaxis.tickColor == null) // backwards-compatibility
                options.xaxis.tickColor = options.grid.tickColor;
            if (options.yaxis.tickColor == null) // backwards-compatibility
                options.yaxis.tickColor = options.grid.tickColor;

            if (options.grid.borderColor == null)
                options.grid.borderColor = options.grid.color;
            if (options.grid.tickColor == null)
                options.grid.tickColor = $.color.parse(options.grid.color).scale('a', 0.22).toString();

            // fill in defaults in axes, copy at least always the
            // first as the rest of the code assumes it'll be there
            for (i = 0; i < Math.max(1, options.xaxes.length); ++i)
                options.xaxes[i] = $.extend(true, {}, options.xaxis, options.xaxes[i]);
            for (i = 0; i < Math.max(1, options.yaxes.length); ++i)
                options.yaxes[i] = $.extend(true, {}, options.yaxis, options.yaxes[i]);

            // backwards compatibility, to be removed in future
            if (options.xaxis.noTicks && options.xaxis.ticks == null)
                options.xaxis.ticks = options.xaxis.noTicks;
            if (options.yaxis.noTicks && options.yaxis.ticks == null)
                options.yaxis.ticks = options.yaxis.noTicks;
            if (options.x2axis) {
                options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
                options.xaxes[1].position = "top";
            }
            if (options.y2axis) {
                options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
                options.yaxes[1].position = "right";
            }
            if (options.grid.coloredAreas)
                options.grid.markings = options.grid.coloredAreas;
            if (options.grid.coloredAreasColor)
                options.grid.markingsColor = options.grid.coloredAreasColor;
            if (options.lines)
                $.extend(true, options.series.lines, options.lines);
            if (options.points)
                $.extend(true, options.series.points, options.points);
            if (options.bars)
                $.extend(true, options.series.bars, options.bars);
            if (options.shadowSize != null)
                options.series.shadowSize = options.shadowSize;
            if (options.highlightColor != null)
                options.series.highlightColor = options.highlightColor;

            // save options on axes for future reference
            for (i = 0; i < options.xaxes.length; ++i)
                getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
            for (i = 0; i < options.yaxes.length; ++i)
                getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];

            // add hooks from options
            for (var n in hooks)
                if (options.hooks[n] && options.hooks[n].length)
                    hooks[n] = hooks[n].concat(options.hooks[n]);

            executeHooks(hooks.processOptions, [options]);
        }

        function setData(d) {
            series = parseData(d);
            fillInSeriesOptions();
            processData();
        }

        function parseData(d) {
            var res = [];
            for (var i = 0; i < d.length; ++i) {
                var s = $.extend(true, {}, options.series);

                if (d[i].data != null) {
                    s.data = d[i].data; // move the data instead of deep-copy
                    delete d[i].data;

                    $.extend(true, s, d[i]);

                    d[i].data = s.data;
                }
                else
                    s.data = d[i];
                res.push(s);
            }

            return res;
        }

        function axisNumber(obj, coord) {
            var a = obj[coord + "axis"];
            if (typeof a == "object") // if we got a real axis, extract number
                a = a.n;
            if (typeof a != "number")
                a = 1; // default to first axis
            return a;
        }

        function allAxes() {
            // return flat array without annoying null entries
            return $.grep(xaxes.concat(yaxes), function (a) { return a; });
        }

        function canvasToAxisCoords(pos) {
            // return an object with x/y corresponding to all used axes
            var res = {}, i, axis;
            for (i = 0; i < xaxes.length; ++i) {
                axis = xaxes[i];
                if (axis && axis.used)
                    res["x" + axis.n] = axis.c2p(pos.left);
            }

            for (i = 0; i < yaxes.length; ++i) {
                axis = yaxes[i];
                if (axis && axis.used)
                    res["y" + axis.n] = axis.c2p(pos.top);
            }

            if (res.x1 !== undefined)
                res.x = res.x1;
            if (res.y1 !== undefined)
                res.y = res.y1;

            return res;
        }

        function axisToCanvasCoords(pos) {
            // get canvas coords from the first pair of x/y found in pos
            var res = {}, i, axis, key;

            for (i = 0; i < xaxes.length; ++i) {
                axis = xaxes[i];
                if (axis && axis.used) {
                    key = "x" + axis.n;
                    if (pos[key] == null && axis.n == 1)
                        key = "x";

                    if (pos[key] != null) {
                        res.left = axis.p2c(pos[key]);
                        break;
                    }
                }
            }

            for (i = 0; i < yaxes.length; ++i) {
                axis = yaxes[i];
                if (axis && axis.used) {
                    key = "y" + axis.n;
                    if (pos[key] == null && axis.n == 1)
                        key = "y";

                    if (pos[key] != null) {
                        res.top = axis.p2c(pos[key]);
                        break;
                    }
                }
            }

            return res;
        }

        function getOrCreateAxis(axes, number) {
            if (!axes[number - 1])
                axes[number - 1] = {
                    n: number, // save the number for future reference
                    direction: axes == xaxes ? "x" : "y",
                    options: $.extend(true, {}, axes == xaxes ? options.xaxis : options.yaxis)
                };

            return axes[number - 1];
        }

        function fillInSeriesOptions() {

            var neededColors = series.length, maxIndex = -1, i;

            // Subtract the number of series that already have fixed colors or
            // color indexes from the number that we still need to generate.

            for (i = 0; i < series.length; ++i) {
                var sc = series[i].color;
                if (sc != null) {
                    neededColors--;
                    if (typeof sc == "number" && sc > maxIndex) {
                        maxIndex = sc;
                    }
                }
            }

            // If any of the series have fixed color indexes, then we need to
            // generate at least as many colors as the highest index.

            if (neededColors <= maxIndex) {
                neededColors = maxIndex + 1;
            }

            // Generate all the colors, using first the option colors and then
            // variations on those colors once they're exhausted.

            var c, colors = [], colorPool = options.colors,
                colorPoolSize = colorPool.length, variation = 0;

            for (i = 0; i < neededColors; i++) {

                c = $.color.parse(colorPool[i % colorPoolSize] || "#666");

                // Each time we exhaust the colors in the pool we adjust
                // a scaling factor used to produce more variations on
                // those colors. The factor alternates negative/positive
                // to produce lighter/darker colors.

                // Reset the variation after every few cycles, or else
                // it will end up producing only white or black colors.

                if (i % colorPoolSize == 0 && i) {
                    if (variation >= 0) {
                        if (variation < 0.5) {
                            variation = -variation - 0.2;
                        } else variation = 0;
                    } else variation = -variation;
                }

                colors[i] = c.scale('rgb', 1 + variation);
            }

            // Finalize the series options, filling in their colors

            var colori = 0, s;
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                // assign colors
                if (s.color == null) {
                    s.color = colors[colori].toString();
                    ++colori;
                }
                else if (typeof s.color == "number")
                    s.color = colors[s.color].toString();

                // turn on lines automatically in case nothing is set
                if (s.lines.show == null) {
                    var v, show = true;
                    for (v in s)
                        if (s[v] && s[v].show) {
                            show = false;
                            break;
                        }
                    if (show)
                        s.lines.show = true;
                }

                // If nothing was provided for lines.zero, default it to match
                // lines.fill, since areas by default should extend to zero.

                if (s.lines.zero == null) {
                    s.lines.zero = !!s.lines.fill;
                }

                // setup axes
                s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
                s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
            }
        }

        function processData() {
            var topSentry = Number.POSITIVE_INFINITY,
                bottomSentry = Number.NEGATIVE_INFINITY,
                fakeInfinity = Number.MAX_VALUE,
                i, j, k, m, length,
                s, points, ps, x, y, axis, val, f, p,
                data, format;

            function updateAxis(axis, min, max) {
                if (min < axis.datamin && min != -fakeInfinity)
                    axis.datamin = min;
                if (max > axis.datamax && max != fakeInfinity)
                    axis.datamax = max;
            }

            $.each(allAxes(), function (_, axis) {
                // init axis
                axis.datamin = topSentry;
                axis.datamax = bottomSentry;
                axis.used = false;
            });

            for (i = 0; i < series.length; ++i) {
                s = series[i];
                s.datapoints = { points: [] };

                executeHooks(hooks.processRawData, [ s, s.data, s.datapoints ]);
            }

            // first pass: clean and copy data
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                data = s.data;
                format = s.datapoints.format;

                if (!format) {
                    format = [];
                    // find out how to copy
                    format.push({ x: true, number: true, required: true });
                    format.push({ y: true, number: true, required: true });

                    if (s.bars.show || (s.lines.show && s.lines.fill)) {
                        var autoscale = !!((s.bars.show && s.bars.zero) || (s.lines.show && s.lines.zero));
                        format.push({ y: true, number: true, required: false, defaultValue: 0, autoscale: autoscale });
                        if (s.bars.horizontal) {
                            delete format[format.length - 1].y;
                            format[format.length - 1].x = true;
                        }
                    }

                    s.datapoints.format = format;
                }

                if (s.datapoints.pointsize != null)
                    continue; // already filled in

                s.datapoints.pointsize = format.length;

                ps = s.datapoints.pointsize;
                points = s.datapoints.points;

                var insertSteps = s.lines.show && s.lines.steps;
                s.xaxis.used = s.yaxis.used = true;

                for (j = k = 0; j < data.length; ++j, k += ps) {
                    p = data[j];

                    var nullify = p == null;
                    if (!nullify) {
                        for (m = 0; m < ps; ++m) {
                            val = p[m];
                            f = format[m];

                            if (f) {
                                if (f.number && val != null) {
                                    val = +val; // convert to number
                                    if (isNaN(val))
                                        val = null;
                                    else if (val == Infinity)
                                        val = fakeInfinity;
                                    else if (val == -Infinity)
                                        val = -fakeInfinity;
                                }

                                if (val == null) {
                                    if (f.required)
                                        nullify = true;

                                    if (f.defaultValue != null)
                                        val = f.defaultValue;
                                }
                            }

                            points[k + m] = val;
                        }
                    }

                    if (nullify) {
                        for (m = 0; m < ps; ++m) {
                            val = points[k + m];
                            if (val != null) {
                                f = format[m];
                                // extract min/max info
                                if (f.x)
                                    updateAxis(s.xaxis, val, val);
                                if (f.y)
                                    updateAxis(s.yaxis, val, val);
                            }
                            points[k + m] = null;
                        }
                    }
                    else {
                        // a little bit of line specific stuff that
                        // perhaps shouldn't be here, but lacking
                        // better means...
                        if (insertSteps && k > 0
                            && points[k - ps] != null
                            && points[k - ps] != points[k]
                            && points[k - ps + 1] != points[k + 1]) {
                            // copy the point to make room for a middle point
                            for (m = 0; m < ps; ++m)
                                points[k + ps + m] = points[k + m];

                            // middle point has same y
                            points[k + 1] = points[k - ps + 1];

                            // we've added a point, better reflect that
                            k += ps;
                        }
                    }
                }
            }

            // give the hooks a chance to run
            for (i = 0; i < series.length; ++i) {
                s = series[i];

                executeHooks(hooks.processDatapoints, [ s, s.datapoints]);
            }

            // second pass: find datamax/datamin for auto-scaling
            for (i = 0; i < series.length; ++i) {
                s = series[i];
                points = s.datapoints.points,
                ps = s.datapoints.pointsize;
                format = s.datapoints.format;

                var xmin = topSentry, ymin = topSentry,
                    xmax = bottomSentry, ymax = bottomSentry;

                for (j = 0; j < points.length; j += ps) {
                    if (points[j] == null)
                        continue;

                    for (m = 0; m < ps; ++m) {
                        val = points[j + m];
                        f = format[m];
                        if (!f || f.autoscale === false || val == fakeInfinity || val == -fakeInfinity)
                            continue;

                        if (f.x) {
                            if (val < xmin)
                                xmin = val;
                            if (val > xmax)
                                xmax = val;
                        }
                        if (f.y) {
                            if (val < ymin)
                                ymin = val;
                            if (val > ymax)
                                ymax = val;
                        }
                    }
                }

                if (s.bars.show) {
                    // make sure we got room for the bar on the dancing floor
                    var delta;

                    switch (s.bars.align) {
                        case "left":
                            delta = 0;
                            break;
                        case "right":
                            delta = -s.bars.barWidth;
                            break;
                        case "center":
                            delta = -s.bars.barWidth / 2;
                            break;
                        default:
                            throw new Error("Invalid bar alignment: " + s.bars.align);
                    }

                    if (s.bars.horizontal) {
                        ymin += delta;
                        ymax += delta + s.bars.barWidth;
                    }
                    else {
                        xmin += delta;
                        xmax += delta + s.bars.barWidth;
                    }
                }

                updateAxis(s.xaxis, xmin, xmax);
                updateAxis(s.yaxis, ymin, ymax);
            }

            $.each(allAxes(), function (_, axis) {
                if (axis.datamin == topSentry)
                    axis.datamin = null;
                if (axis.datamax == bottomSentry)
                    axis.datamax = null;
            });
        }

        //////////////////////////////////////////////////////////////////////////////////
        // Returns the display's ratio between physical and device-independent pixels.
        //
        // This is the ratio between the width that the browser advertises and the number
        // of pixels actually available in that space.  The iPhone 4, for example, has a
        // device-independent width of 320px, but its screen is actually 640px wide.  It
        // therefore has a pixel ratio of 2, while most normal devices have a ratio of 1.

        function getPixelRatio(cctx) {
            var devicePixelRatio = window.devicePixelRatio || 1;
            var backingStoreRatio =
                cctx.webkitBackingStorePixelRatio ||
                cctx.mozBackingStorePixelRatio ||
                cctx.msBackingStorePixelRatio ||
                cctx.oBackingStorePixelRatio ||
                cctx.backingStorePixelRatio || 1;

            return devicePixelRatio / backingStoreRatio;
        }

        function makeCanvas(cls) {

            var c = document.createElement('canvas');
            c.className = cls;

			$(c).css({ direction: "ltr", position: "absolute", left: 0, top: 0 })
				.appendTo(placeholder);

			// If HTML5 Canvas isn't available, fall back to Excanvas

			if (!c.getContext) {
				if (window.G_vmlCanvasManager) {
					c = window.G_vmlCanvasManager.initElement(c);
				} else {
					throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
				}
			}

            var cctx = c.getContext("2d");

            // Increase the canvas density based on the display's pixel ratio; basically
            // giving the canvas more pixels without increasing the size of its element,
            // to take advantage of the fact that retina displays have that many more
            // pixels than they actually use for page & element widths.

            var pixelRatio = getPixelRatio(cctx);

            c.width = canvasWidth * pixelRatio;
            c.height = canvasHeight * pixelRatio;
            c.style.width = canvasWidth + "px";
            c.style.height = canvasHeight + "px";

            // Save the context so we can reset in case we get replotted

            cctx.save();

            // Scale the coordinate space to match the display density; so even though we
            // may have twice as many pixels, we still want lines and other drawing to
            // appear at the same size; the extra pixels will just make them crisper.

            cctx.scale(pixelRatio, pixelRatio);

            return c;
        }

        function getCanvasDimensions() {
            canvasWidth = placeholder.width();
            canvasHeight = placeholder.height();

            if (canvasWidth <= 0 || canvasHeight <= 0)
                throw new Error("Invalid dimensions for plot, width = " + canvasWidth + ", height = " + canvasHeight);
        }

        function resizeCanvas(c) {

            var cctx = c.getContext("2d");

            // Handle pixel ratios > 1 for retina displays, as explained in makeCanvas

            var pixelRatio = getPixelRatio(cctx);

            // Resizing should reset the state (excanvas seems to be buggy though)

            if (c.style.width != canvasWidth) {
                c.width = canvasWidth * pixelRatio;
                c.style.width = canvasWidth + "px";
            }

            if (c.style.height != canvasHeight) {
                c.height = canvasHeight * pixelRatio;
                c.style.height = canvasHeight + "px";
            }

            // so try to get back to the initial state (even if it's
            // gone now, this should be safe according to the spec)
            cctx.restore();

            // and save again
            cctx.save();

            // Apply scaling for retina displays, as explained in makeCanvas

            cctx.scale(pixelRatio, pixelRatio);
        }

        function setupCanvases() {
            var reused,
                existingCanvas = placeholder.children("canvas.flot-base"),
                existingOverlay = placeholder.children("canvas.flot-overlay");

            if (existingCanvas.length == 0 || existingOverlay == 0) {
                // init everything

                placeholder.html(""); // make sure placeholder is clear

                placeholder.css({ padding: 0 }); // padding messes up the positioning

                if (placeholder.css("position") == 'static')
                    placeholder.css("position", "relative"); // for positioning labels and overlay

                getCanvasDimensions();

                canvas = makeCanvas("flot-base");
                overlay = makeCanvas("flot-overlay"); // overlay canvas for interactive features

                reused = false;
            }
            else {
                // reuse existing elements

                canvas = existingCanvas.get(0);
                overlay = existingOverlay.get(0);

                reused = true;
            }

            ctx = canvas.getContext("2d");
            octx = overlay.getContext("2d");

            // define which element we're listening for events on
            eventHolder = $(overlay);

            if (reused) {
                // run shutdown in the old plot object
                placeholder.data("plot").shutdown();

                // reset reused canvases
                plot.resize();

                // make sure overlay pixels are cleared (canvas is cleared when we redraw)
                octx.clearRect(0, 0, canvasWidth, canvasHeight);

                // then whack any remaining obvious garbage left
                eventHolder.unbind();
                placeholder.children().not([canvas, overlay]).remove();
            }

            // save in case we get replotted
            placeholder.data("plot", plot);
        }

        function bindEvents() {
            // bind events
            if (options.grid.hoverable) {
                eventHolder.mousemove(onMouseMove);

                // Use bind, rather than .mouseleave, because we officially
                // still support jQuery 1.2.6, which doesn't define a shortcut
                // for mouseenter or mouseleave.  This was a bug/oversight that
                // was fixed somewhere around 1.3.x.  We can return to using
                // .mouseleave when we drop support for 1.2.6.

                eventHolder.bind("mouseleave", onMouseLeave);
            }

            if (options.grid.clickable)
                eventHolder.click(onClick);

            executeHooks(hooks.bindEvents, [eventHolder]);
        }

        function shutdown() {
            if (redrawTimeout)
                clearTimeout(redrawTimeout);

            eventHolder.unbind("mousemove", onMouseMove);
            eventHolder.unbind("mouseleave", onMouseLeave);
            eventHolder.unbind("click", onClick);

            executeHooks(hooks.shutdown, [eventHolder]);
        }

        function setTransformationHelpers(axis) {
            // set helper functions on the axis, assumes plot area
            // has been computed already

            function identity(x) { return x; }

            var s, m, t = axis.options.transform || identity,
                it = axis.options.inverseTransform;

            // precompute how much the axis is scaling a point
            // in canvas space
            if (axis.direction == "x") {
                s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
                m = Math.min(t(axis.max), t(axis.min));
            }
            else {
                s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
                s = -s;
                m = Math.max(t(axis.max), t(axis.min));
            }

            // data point to canvas coordinate
            if (t == identity) // slight optimization
                axis.p2c = function (p) { return (p - m) * s; };
            else
                axis.p2c = function (p) { return (t(p) - m) * s; };
            // canvas coordinate to data point
            if (!it)
                axis.c2p = function (c) { return m + c / s; };
            else
                axis.c2p = function (c) { return it(m + c / s); };
        }

        function measureTickLabels(axis) {
            var opts = axis.options, ticks = axis.ticks || [],
                axisw = opts.labelWidth || 0, axish = opts.labelHeight || 0,
                f = axis.font;

            ctx.save();
            ctx.font = f.style + " " + f.variant + " " + f.weight + " " + f.size + "px '" + f.family + "'";

            for (var i = 0; i < ticks.length; ++i) {
                var t = ticks[i];

                t.lines = [];
                t.width = t.height = 0;

                if (!t.label)
                    continue;

                // accept various kinds of newlines, including HTML ones
                // (you can actually split directly on regexps in Javascript,
                // but IE < 9 is unfortunately broken)
                var lines = (t.label + "").replace(/<br ?\/?>|\r\n|\r/g, "\n").split("\n");
                for (var j = 0; j < lines.length; ++j) {
                    var line = { text: lines[j] },
                        m = ctx.measureText(line.text);

                    line.width = m.width;
                    // m.height might not be defined, not in the
                    // standard yet
                    line.height = m.height != null ? m.height : f.size;

                    // add a bit of margin since font rendering is
                    // not pixel perfect and cut off letters look
                    // bad, this also doubles as spacing between
                    // lines
                    line.height += Math.round(f.size * 0.15);

                    t.width = Math.max(line.width, t.width);
                    t.height += line.height;

                    t.lines.push(line);
                }

                if (opts.labelWidth == null)
                    axisw = Math.max(axisw, t.width);
                if (opts.labelHeight == null)
                    axish = Math.max(axish, t.height);
            }
            ctx.restore();

            axis.labelWidth = Math.ceil(axisw);
            axis.labelHeight = Math.ceil(axish);
        }

        function allocateAxisBoxFirstPhase(axis) {
            // find the bounding box of the axis by looking at label
            // widths/heights and ticks, make room by diminishing the
            // plotOffset; this first phase only looks at one
            // dimension per axis, the other dimension depends on the
            // other axes so will have to wait

            var lw = axis.labelWidth,
                lh = axis.labelHeight,
                pos = axis.options.position,
                tickLength = axis.options.tickLength,
                axisMargin = options.grid.axisMargin,
                padding = options.grid.labelMargin,
                all = axis.direction == "x" ? xaxes : yaxes,
                index, innermost;

            // determine axis margin
            var samePosition = $.grep(all, function (a) {
                return a && a.options.position == pos && a.reserveSpace;
            });
            if ($.inArray(axis, samePosition) == samePosition.length - 1)
                axisMargin = 0; // outermost

            // determine tick length - if we're innermost, we can use "full"
            if (tickLength == null) {
                var sameDirection = $.grep(all, function (a) {
                    return a && a.reserveSpace;
                });

                innermost = $.inArray(axis, sameDirection) == 0;
                if (innermost)
                    tickLength = "full";
                else
                    tickLength = 5;
            }

            if (!isNaN(+tickLength))
                padding += +tickLength;

            // compute box
            if (axis.direction == "x") {
                lh += padding;

                if (pos == "bottom") {
                    plotOffset.bottom += lh + axisMargin;
                    axis.box = { top: canvasHeight - plotOffset.bottom, height: lh };
                }
                else {
                    axis.box = { top: plotOffset.top + axisMargin, height: lh };
                    plotOffset.top += lh + axisMargin;
                }
            }
            else {
                lw += padding;

                if (pos == "left") {
                    axis.box = { left: plotOffset.left + axisMargin, width: lw };
                    plotOffset.left += lw + axisMargin;
                }
                else {
                    plotOffset.right += lw + axisMargin;
                    axis.box = { left: canvasWidth - plotOffset.right, width: lw };
                }
            }

             // save for future reference
            axis.position = pos;
            axis.tickLength = tickLength;
            axis.box.padding = padding;
            axis.innermost = innermost;
        }

        function allocateAxisBoxSecondPhase(axis) {
            // now that all axis boxes have been placed in one
            // dimension, we can set the remaining dimension coordinates
            if (axis.direction == "x") {
                axis.box.left = plotOffset.left - axis.labelWidth / 2;
                axis.box.width = canvasWidth - plotOffset.left - plotOffset.right + axis.labelWidth;
            }
            else {
                axis.box.top = plotOffset.top - axis.labelHeight / 2;
                axis.box.height = canvasHeight - plotOffset.bottom - plotOffset.top + axis.labelHeight;
            }
        }

        function adjustLayoutForThingsStickingOut() {
            // possibly adjust plot offset to ensure everything stays
            // inside the canvas and isn't clipped off

            var minMargin = options.grid.minBorderMargin,
                margins = { x: 0, y: 0 }, i, axis;

            // check stuff from the plot (FIXME: this should just read
            // a value from the series, otherwise it's impossible to
            // customize)
            if (minMargin == null) {
                minMargin = 0;
                for (i = 0; i < series.length; ++i)
                    minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth/2));
            }

            margins.x = margins.y = Math.ceil(minMargin);

            // check axis labels, note we don't check the actual
            // labels but instead use the overall width/height to not
            // jump as much around with replots
            $.each(allAxes(), function (_, axis) {
                var dir = axis.direction;
                if (axis.reserveSpace)
                    margins[dir] = Math.ceil(Math.max(margins[dir], (dir == "x" ? axis.labelWidth : axis.labelHeight) / 2));
            });

            plotOffset.left = Math.max(margins.x, plotOffset.left);
            plotOffset.right = Math.max(margins.x, plotOffset.right);
            plotOffset.top = Math.max(margins.y, plotOffset.top);
            plotOffset.bottom = Math.max(margins.y, plotOffset.bottom);
        }

        function setupGrid() {
            var i, axes = allAxes(), showGrid = options.grid.show;

            // Initialize the plot's offset from the edge of the canvas

            for (var a in plotOffset) {
                var margin = options.grid.margin || 0;
                plotOffset[a] = typeof margin == "number" ? margin : margin[a] || 0;
            }

            executeHooks(hooks.processOffset, [plotOffset]);

            // If the grid is visible, add its border width to the offset

            for (var a in plotOffset) {
                if(typeof(options.grid.borderWidth) == "object") {
                    plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
                }
                else {
                    plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
                }
            }

            // init axes
            $.each(axes, function (_, axis) {
                axis.show = axis.options.show;
                if (axis.show == null)
                    axis.show = axis.used; // by default an axis is visible if it's got data

                axis.reserveSpace = axis.show || axis.options.reserveSpace;

                setRange(axis);
            });

            if (showGrid) {
                // determine from the placeholder the font size ~ height of font ~ 1 em
                var fontDefaults = {
                    style: placeholder.css("font-style"),
                    size: Math.round(0.8 * (+placeholder.css("font-size").replace("px", "") || 13)),
                    variant: placeholder.css("font-variant"),
                    weight: placeholder.css("font-weight"),
                    family: placeholder.css("font-family")
                };

                var allocatedAxes = $.grep(axes, function (axis) { return axis.reserveSpace; });

                $.each(allocatedAxes, function (_, axis) {
                    // make the ticks
                    setupTickGeneration(axis);
                    setTicks(axis);
                    snapRangeToTicks(axis, axis.ticks);

                    // find labelWidth/Height for axis
                    axis.font = $.extend({}, fontDefaults, axis.options.font);
                    measureTickLabels(axis);
                });

                // with all dimensions calculated, we can compute the
                // axis bounding boxes, start from the outside
                // (reverse order)
                for (i = allocatedAxes.length - 1; i >= 0; --i)
                    allocateAxisBoxFirstPhase(allocatedAxes[i]);

                // make sure we've got enough space for things that
                // might stick out
                adjustLayoutForThingsStickingOut();

                $.each(allocatedAxes, function (_, axis) {
                    allocateAxisBoxSecondPhase(axis);
                });
            }

            plotWidth = canvasWidth - plotOffset.left - plotOffset.right;
            plotHeight = canvasHeight - plotOffset.bottom - plotOffset.top;

            // now we got the proper plot dimensions, we can compute the scaling
            $.each(axes, function (_, axis) {
                setTransformationHelpers(axis);
            });

            insertLegend();
        }

        function setRange(axis) {
            var opts = axis.options,
                min = +(opts.min != null ? opts.min : axis.datamin),
                max = +(opts.max != null ? opts.max : axis.datamax),
                delta = max - min;

            if (delta == 0.0) {
                // degenerate case
                var widen = max == 0 ? 1 : 0.01;

                if (opts.min == null)
                    min -= widen;
                // always widen max if we couldn't widen min to ensure we
                // don't fall into min == max which doesn't work
                if (opts.max == null || opts.min != null)
                    max += widen;
            }
            else {
                // consider autoscaling
                var margin = opts.autoscaleMargin;
                if (margin != null) {
                    if (opts.min == null) {
                        min -= delta * margin;
                        // make sure we don't go below zero if all values
                        // are positive
                        if (min < 0 && axis.datamin != null && axis.datamin >= 0)
                            min = 0;
                    }
                    if (opts.max == null) {
                        max += delta * margin;
                        if (max > 0 && axis.datamax != null && axis.datamax <= 0)
                            max = 0;
                    }
                }
            }
            axis.min = min;
            axis.max = max;
        }

        function setupTickGeneration(axis) {
            var opts = axis.options;

            // estimate number of ticks
            var noTicks;
            if (typeof opts.ticks == "number" && opts.ticks > 0)
                noTicks = opts.ticks;
            else
                // heuristic based on the model a*sqrt(x) fitted to
                // some data points that seemed reasonable
                noTicks = 0.3 * Math.sqrt(axis.direction == "x" ? canvasWidth : canvasHeight);

            axis.delta = (axis.max - axis.min) / noTicks;

            // Time mode was moved to a plug-in in 0.8, but since so many people use this
            // we'll add an especially friendly make sure they remembered to include it.

            if (opts.mode == "time" && !axis.tickGenerator) {
                throw new Error("Time mode requires the flot.time plugin.");
            }

            // Flot supports base-10 axes; any other mode else is handled by a plug-in,
            // like flot.time.js.

            if (!axis.tickGenerator) {

                axis.tickGenerator = function (axis) {
                    var maxDec = opts.tickDecimals,
                        dec = -Math.floor(Math.log(axis.delta) / Math.LN10);

                    if (maxDec != null && dec > maxDec)
                        dec = maxDec;

                    var magn = Math.pow(10, -dec),
                        norm = axis.delta / magn, // norm is between 1.0 and 10.0
                        size,

                        ticks = [],
                        start,
                        i = 0,
                        v = Number.NaN,
                        prev;

                    if (norm < 1.5)
                        size = 1;
                    else if (norm < 3) {
                        size = 2;
                        // special case for 2.5, requires an extra decimal
                        if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
                            size = 2.5;
                            ++dec;
                        }
                    }
                    else if (norm < 7.5)
                        size = 5;
                    else size = 10;

                    size *= magn;

                    if (opts.minTickSize != null && size < opts.minTickSize)
                        size = opts.minTickSize;

                    axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
                    axis.tickSize = opts.tickSize || size;

                    start = floorInBase(axis.min, axis.tickSize)

                    do {
                        prev = v;
                        v = start + i * axis.tickSize;
                        ticks.push(v);
                        ++i;
                    } while (v < axis.max && v != prev);
                    return ticks;
                };

				axis.tickFormatter = function (value, axis) {

					var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1;
					var formatted = "" + Math.round(value * factor) / factor;

					// If tickDecimals was specified, ensure that we have exactly that
					// much precision; otherwise default to the value's own precision.

					if (axis.tickDecimals != null) {
						var decimal = formatted.indexOf(".");
						var precision = decimal == -1 ? 0 : formatted.length - decimal - 1;
						if (precision < axis.tickDecimals) {
							return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
						}
					}

                    return formatted;
                };
            }

            if ($.isFunction(opts.tickFormatter))
                axis.tickFormatter = function (v, axis) { return "" + opts.tickFormatter(v, axis); };

            if (opts.alignTicksWithAxis != null) {
                var otherAxis = (axis.direction == "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
                if (otherAxis && otherAxis.used && otherAxis != axis) {
                    // consider snapping min/max to outermost nice ticks
                    var niceTicks = axis.tickGenerator(axis);
                    if (niceTicks.length > 0) {
                        if (opts.min == null)
                            axis.min = Math.min(axis.min, niceTicks[0]);
                        if (opts.max == null && niceTicks.length > 1)
                            axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
                    }

                    axis.tickGenerator = function (axis) {
                        // copy ticks, scaled to this axis
                        var ticks = [], v, i;
                        for (i = 0; i < otherAxis.ticks.length; ++i) {
                            v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
                            v = axis.min + v * (axis.max - axis.min);
                            ticks.push(v);
                        }
                        return ticks;
                    };

                    // we might need an extra decimal since forced
                    // ticks don't necessarily fit naturally
                    if (!axis.mode && opts.tickDecimals == null) {
                        var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
                            ts = axis.tickGenerator(axis);

                        // only proceed if the tick interval rounded
                        // with an extra decimal doesn't give us a
                        // zero at end
                        if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec))))
                            axis.tickDecimals = extraDec;
                    }
                }
            }
        }

        function setTicks(axis) {
            var oticks = axis.options.ticks, ticks = [];
            if (oticks == null || (typeof oticks == "number" && oticks > 0))
                ticks = axis.tickGenerator(axis);
            else if (oticks) {
                if ($.isFunction(oticks))
                    // generate the ticks
                    ticks = oticks(axis);
                else
                    ticks = oticks;
            }

            // clean up/labelify the supplied ticks, copy them over
            var i, v;
            axis.ticks = [];
            for (i = 0; i < ticks.length; ++i) {
                var label = null;
                var t = ticks[i];
                if (typeof t == "object") {
                    v = +t[0];
                    if (t.length > 1)
                        label = t[1];
                }
                else
                    v = +t;
                if (label == null)
                    label = axis.tickFormatter(v, axis);
                if (!isNaN(v))
                    axis.ticks.push({ v: v, label: label });
            }
        }

        function snapRangeToTicks(axis, ticks) {
            if (axis.options.autoscaleMargin && ticks.length > 0) {
                // snap to ticks
                if (axis.options.min == null)
                    axis.min = Math.min(axis.min, ticks[0].v);
                if (axis.options.max == null && ticks.length > 1)
                    axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
            }
        }

        function draw() {
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);

            executeHooks(hooks.drawBackground, [ctx]);

            var grid = options.grid;

            // draw background, if any
            if (grid.show && grid.backgroundColor)
                drawBackground();

            if (grid.show && !grid.aboveData) {
                drawGrid();
                drawAxisLabels();
            }

            for (var i = 0; i < series.length; ++i) {
                executeHooks(hooks.drawSeries, [ctx, series[i]]);
                drawSeries(series[i]);
            }

            executeHooks(hooks.draw, [ctx]);

            if (grid.show && grid.aboveData) {
                drawGrid();
                drawAxisLabels();
            }
        }

        function extractRange(ranges, coord) {
            var axis, from, to, key, axes = allAxes();

            for (var i = 0; i < axes.length; ++i) {
                axis = axes[i];
                if (axis.direction == coord) {
                    key = coord + axis.n + "axis";
                    if (!ranges[key] && axis.n == 1)
                        key = coord + "axis"; // support x1axis as xaxis
                    if (ranges[key]) {
                        from = ranges[key].from;
                        to = ranges[key].to;
                        break;
                    }
                }
            }

            // backwards-compat stuff - to be removed in future
            if (!ranges[key]) {
                axis = coord == "x" ? xaxes[0] : yaxes[0];
                from = ranges[coord + "1"];
                to = ranges[coord + "2"];
            }

            // auto-reverse as an added bonus
            if (from != null && to != null && from > to) {
                var tmp = from;
                from = to;
                to = tmp;
            }

            return { from: from, to: to, axis: axis };
        }

        function drawBackground() {
            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
            ctx.fillRect(0, 0, plotWidth, plotHeight);
            ctx.restore();
        }

        function drawGrid() {
            var i, axes, bw, bc;

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            // draw markings
            var markings = options.grid.markings;
            if (markings) {
                if ($.isFunction(markings)) {
                    axes = plot.getAxes();
                    // xmin etc. is backwards compatibility, to be
                    // removed in the future
                    axes.xmin = axes.xaxis.min;
                    axes.xmax = axes.xaxis.max;
                    axes.ymin = axes.yaxis.min;
                    axes.ymax = axes.yaxis.max;

                    markings = markings(axes);
                }

                for (i = 0; i < markings.length; ++i) {
                    var m = markings[i],
                        xrange = extractRange(m, "x"),
                        yrange = extractRange(m, "y");

                    // fill in missing
                    if (xrange.from == null)
                        xrange.from = xrange.axis.min;
                    if (xrange.to == null)
                        xrange.to = xrange.axis.max;
                    if (yrange.from == null)
                        yrange.from = yrange.axis.min;
                    if (yrange.to == null)
                        yrange.to = yrange.axis.max;

                    // clip
                    if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max ||
                        yrange.to < yrange.axis.min || yrange.from > yrange.axis.max)
                        continue;

                    xrange.from = Math.max(xrange.from, xrange.axis.min);
                    xrange.to = Math.min(xrange.to, xrange.axis.max);
                    yrange.from = Math.max(yrange.from, yrange.axis.min);
                    yrange.to = Math.min(yrange.to, yrange.axis.max);

                    if (xrange.from == xrange.to && yrange.from == yrange.to)
                        continue;

                    // then draw
                    xrange.from = xrange.axis.p2c(xrange.from);
                    xrange.to = xrange.axis.p2c(xrange.to);
                    yrange.from = yrange.axis.p2c(yrange.from);
                    yrange.to = yrange.axis.p2c(yrange.to);

                    if (xrange.from == xrange.to || yrange.from == yrange.to) {
                        // draw line
                        ctx.beginPath();
                        ctx.strokeStyle = m.color || options.grid.markingsColor;
                        ctx.lineWidth = m.lineWidth || options.grid.markingsLineWidth;
                        ctx.moveTo(xrange.from, yrange.from);
                        ctx.lineTo(xrange.to, yrange.to);
                        ctx.stroke();
                    }
                    else {
                        // fill area
                        ctx.fillStyle = m.color || options.grid.markingsColor;
                        ctx.fillRect(xrange.from, yrange.to,
                                     xrange.to - xrange.from,
                                     yrange.from - yrange.to);
                    }
                }
            }

            // draw the ticks
            axes = allAxes();
            bw = options.grid.borderWidth;

            for (var j = 0; j < axes.length; ++j) {
                var axis = axes[j], box = axis.box,
                    t = axis.tickLength, x, y, xoff, yoff;
                if (!axis.show || axis.ticks.length == 0)
                    continue;

                ctx.strokeStyle = axis.options.tickColor || $.color.parse(axis.options.color).scale('a', 0.22).toString();
                ctx.lineWidth = 1;

                // find the edges
                if (axis.direction == "x") {
                    x = 0;
                    if (t == "full")
                        y = (axis.position == "top" ? 0 : plotHeight);
                    else
                        y = box.top - plotOffset.top + (axis.position == "top" ? box.height : 0);
                }
                else {
                    y = 0;
                    if (t == "full")
                        x = (axis.position == "left" ? 0 : plotWidth);
                    else
                        x = box.left - plotOffset.left + (axis.position == "left" ? box.width : 0);
                }

                // draw tick bar
                if (!axis.innermost) {
                    ctx.beginPath();
                    xoff = yoff = 0;
                    if (axis.direction == "x")
                        xoff = plotWidth;
                    else
                        yoff = plotHeight;

                    if (ctx.lineWidth == 1) {
                        x = Math.floor(x) + 0.5;
                        y = Math.floor(y) + 0.5;
                    }

                    ctx.moveTo(x, y);
                    ctx.lineTo(x + xoff, y + yoff);
                    ctx.stroke();
                }

                // draw ticks
                ctx.beginPath();
                for (i = 0; i < axis.ticks.length; ++i) {
                    var v = axis.ticks[i].v;

                    xoff = yoff = 0;

                    if (isNaN(v) || v < axis.min || v > axis.max
                        // skip those lying on the axes if we got a border
                        || (t == "full"
                            && ((typeof bw == "object" && bw[axis.position] > 0) || bw > 0)
                            && (v == axis.min || v == axis.max)))
                        continue;

                    if (axis.direction == "x") {
                        x = axis.p2c(v);
                        yoff = t == "full" ? -plotHeight : t;

                        if (axis.position == "top")
                            yoff = -yoff;
                    }
                    else {
                        y = axis.p2c(v);
                        xoff = t == "full" ? -plotWidth : t;

                        if (axis.position == "left")
                            xoff = -xoff;
                    }

                    if (ctx.lineWidth == 1) {
                        if (axis.direction == "x")
                            x = Math.floor(x) + 0.5;
                        else
                            y = Math.floor(y) + 0.5;
                    }

                    ctx.moveTo(x, y);
                    ctx.lineTo(x + xoff, y + yoff);
                }

                ctx.stroke();
            }


            // draw border
            if (bw) {
                // If either borderWidth or borderColor is an object, then draw the border
                // line by line instead of as one rectangle
                bc = options.grid.borderColor;
                if(typeof bw == "object" || typeof bc == "object") {
                    if (typeof bw !== "object") {
                        bw = {top: bw, right: bw, bottom: bw, left: bw};
                    }
                    if (typeof bc !== "object") {
                        bc = {top: bc, right: bc, bottom: bc, left: bc};
                    }

                    if (bw.top > 0) {
                        ctx.strokeStyle = bc.top;
                        ctx.lineWidth = bw.top;
                        ctx.beginPath();
                        ctx.moveTo(0 - bw.left, 0 - bw.top/2);
                        ctx.lineTo(plotWidth, 0 - bw.top/2);
                        ctx.stroke();
                    }

                    if (bw.right > 0) {
                        ctx.strokeStyle = bc.right;
                        ctx.lineWidth = bw.right;
                        ctx.beginPath();
                        ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
                        ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
                        ctx.stroke();
                    }

                    if (bw.bottom > 0) {
                        ctx.strokeStyle = bc.bottom;
                        ctx.lineWidth = bw.bottom;
                        ctx.beginPath();
                        ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
                        ctx.lineTo(0, plotHeight + bw.bottom / 2);
                        ctx.stroke();
                    }

                    if (bw.left > 0) {
                        ctx.strokeStyle = bc.left;
                        ctx.lineWidth = bw.left;
                        ctx.beginPath();
                        ctx.moveTo(0 - bw.left/2, plotHeight + bw.bottom);
                        ctx.lineTo(0- bw.left/2, 0);
                        ctx.stroke();
                    }
                }
                else {
                    ctx.lineWidth = bw;
                    ctx.strokeStyle = options.grid.borderColor;
                    ctx.strokeRect(-bw/2, -bw/2, plotWidth + bw, plotHeight + bw);
                }
            }

            ctx.restore();
        }

        function drawAxisLabels() {
            ctx.save();

            $.each(allAxes(), function (_, axis) {
                if (!axis.show || axis.ticks.length == 0)
                    return;

                var box = axis.box, f = axis.font;
                // placeholder.append('<div style="position:absolute;opacity:0.10;background-color:red;left:' + box.left + 'px;top:' + box.top + 'px;width:' + box.width +  'px;height:' + box.height + 'px"></div>') // debug

                ctx.fillStyle = axis.options.color;
                // Important: Don't use quotes around axis.font.family! Just around single
                // font names like 'Times New Roman' that have a space or special character in it.
                ctx.font = f.style + " " + f.variant + " " + f.weight + " " + f.size + "px " + f.family;
                ctx.textAlign = "start";
                // middle align the labels - top would be more
                // natural, but browsers can differ a pixel or two in
                // where they consider the top to be, so instead we
                // middle align to minimize variation between browsers
                // and compensate when calculating the coordinates
                ctx.textBaseline = "middle";

                for (var i = 0; i < axis.ticks.length; ++i) {
                    var tick = axis.ticks[i];
                    if (!tick.label || tick.v < axis.min || tick.v > axis.max)
                        continue;

                    var x, y, offset = 0, line;
                    for (var k = 0; k < tick.lines.length; ++k) {
                        line = tick.lines[k];

                        if (axis.direction == "x") {
                            x = plotOffset.left + axis.p2c(tick.v) - line.width/2;
                            if (axis.position == "bottom")
                                y = box.top + box.padding;
                            else
                                y = box.top + box.height - box.padding - tick.height;
                        }
                        else {
                            y = plotOffset.top + axis.p2c(tick.v) - tick.height/2;
                            if (axis.position == "left")
                                x = box.left + box.width - box.padding - line.width;
                            else
                                x = box.left + box.padding;
                        }

                        // account for middle aligning and line number
                        y += line.height/2 + offset;
                        offset += line.height;

                        if (!!(window.opera && window.opera.version().split('.')[0] < 12)) {
                            // FIXME: LEGACY BROWSER FIX
                            // AFFECTS: Opera < 12.00

                            // round the coordinates since Opera
                            // otherwise switches to more ugly
                            // rendering (probably non-hinted) and
                            // offset the y coordinates since it seems
                            // to be off pretty consistently compared
                            // to the other browsers
                            x = Math.floor(x);
                            y = Math.ceil(y - 2);
                        }
                        ctx.fillText(line.text, x, y);
                    }
                }
            });

            ctx.restore();
        }

        function drawSeries(series) {
            if (series.lines.show)
                drawSeriesLines(series);
            if (series.bars.show)
                drawSeriesBars(series);
            if (series.points.show)
                drawSeriesPoints(series);
        }

        function drawSeriesLines(series) {
            function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
                var points = datapoints.points,
                    ps = datapoints.pointsize,
                    prevx = null, prevy = null;

                ctx.beginPath();
                for (var i = ps; i < points.length; i += ps) {
                    var x1 = points[i - ps], y1 = points[i - ps + 1],
                        x2 = points[i], y2 = points[i + 1];

                    if (x1 == null || x2 == null)
                        continue;

                    // clip with ymin
                    if (y1 <= y2 && y1 < axisy.min) {
                        if (y2 < axisy.min)
                            continue;   // line segment is outside
                        // compute new intersection point
                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.min;
                    }
                    else if (y2 <= y1 && y2 < axisy.min) {
                        if (y1 < axisy.min)
                            continue;
                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.min;
                    }

                    // clip with ymax
                    if (y1 >= y2 && y1 > axisy.max) {
                        if (y2 > axisy.max)
                            continue;
                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.max;
                    }
                    else if (y2 >= y1 && y2 > axisy.max) {
                        if (y1 > axisy.max)
                            continue;
                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.max;
                    }

                    // clip with xmin
                    if (x1 <= x2 && x1 < axisx.min) {
                        if (x2 < axisx.min)
                            continue;
                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.min;
                    }
                    else if (x2 <= x1 && x2 < axisx.min) {
                        if (x1 < axisx.min)
                            continue;
                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.min;
                    }

                    // clip with xmax
                    if (x1 >= x2 && x1 > axisx.max) {
                        if (x2 > axisx.max)
                            continue;
                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.max;
                    }
                    else if (x2 >= x1 && x2 > axisx.max) {
                        if (x1 > axisx.max)
                            continue;
                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.max;
                    }

                    if (x1 != prevx || y1 != prevy)
                        ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);

                    prevx = x2;
                    prevy = y2;
                    ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
                }
                ctx.stroke();
            }

            function plotLineArea(datapoints, axisx, axisy) {
                var points = datapoints.points,
                    ps = datapoints.pointsize,
                    bottom = Math.min(Math.max(0, axisy.min), axisy.max),
                    i = 0, top, areaOpen = false,
                    ypos = 1, segmentStart = 0, segmentEnd = 0;

                // we process each segment in two turns, first forward
                // direction to sketch out top, then once we hit the
                // end we go backwards to sketch the bottom
                while (true) {
                    if (ps > 0 && i > points.length + ps)
                        break;

                    i += ps; // ps is negative if going backwards

                    var x1 = points[i - ps],
                        y1 = points[i - ps + ypos],
                        x2 = points[i], y2 = points[i + ypos];

                    if (areaOpen) {
                        if (ps > 0 && x1 != null && x2 == null) {
                            // at turning point
                            segmentEnd = i;
                            ps = -ps;
                            ypos = 2;
                            continue;
                        }

                        if (ps < 0 && i == segmentStart + ps) {
                            // done with the reverse sweep
                            ctx.fill();
                            areaOpen = false;
                            ps = -ps;
                            ypos = 1;
                            i = segmentStart = segmentEnd + ps;
                            continue;
                        }
                    }

                    if (x1 == null || x2 == null)
                        continue;

                    // clip x values

                    // clip with xmin
                    if (x1 <= x2 && x1 < axisx.min) {
                        if (x2 < axisx.min)
                            continue;
                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.min;
                    }
                    else if (x2 <= x1 && x2 < axisx.min) {
                        if (x1 < axisx.min)
                            continue;
                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.min;
                    }

                    // clip with xmax
                    if (x1 >= x2 && x1 > axisx.max) {
                        if (x2 > axisx.max)
                            continue;
                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x1 = axisx.max;
                    }
                    else if (x2 >= x1 && x2 > axisx.max) {
                        if (x1 > axisx.max)
                            continue;
                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
                        x2 = axisx.max;
                    }

                    if (!areaOpen) {
                        // open area
                        ctx.beginPath();
                        ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
                        areaOpen = true;
                    }

                    // now first check the case where both is outside
                    if (y1 >= axisy.max && y2 >= axisy.max) {
                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
                        continue;
                    }
                    else if (y1 <= axisy.min && y2 <= axisy.min) {
                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
                        continue;
                    }

                    // else it's a bit more complicated, there might
                    // be a flat maxed out rectangle first, then a
                    // triangular cutout or reverse; to find these
                    // keep track of the current x values
                    var x1old = x1, x2old = x2;

                    // clip the y values, without shortcutting, we
                    // go through all cases in turn

                    // clip with ymin
                    if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.min;
                    }
                    else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.min;
                    }

                    // clip with ymax
                    if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y1 = axisy.max;
                    }
                    else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
                        y2 = axisy.max;
                    }

                    // if the x value was changed we got a rectangle
                    // to fill
                    if (x1 != x1old) {
                        ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
                        // it goes to (x1, y1), but we fill that below
                    }

                    // fill triangular section, this sometimes result
                    // in redundant points if (x1, y1) hasn't changed
                    // from previous line to, but we just ignore that
                    ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
                    ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));

                    // fill the other rectangle if it's there
                    if (x2 != x2old) {
                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
                        ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
                    }
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);
            ctx.lineJoin = "round";

            var lw = series.lines.lineWidth,
                sw = series.shadowSize;
            // FIXME: consider another form of shadow when filling is turned on
            if (lw > 0 && sw > 0) {
                // draw shadow as a thick and thin line with transparency
                ctx.lineWidth = sw;
                ctx.strokeStyle = "rgba(0,0,0,0.1)";
                // position shadow at angle from the mid of line
                var angle = Math.PI/18;
                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/2), Math.cos(angle) * (lw/2 + sw/2), series.xaxis, series.yaxis);
                ctx.lineWidth = sw/2;
                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/4), Math.cos(angle) * (lw/2 + sw/4), series.xaxis, series.yaxis);
            }

            ctx.lineWidth = lw;
            ctx.strokeStyle = series.color;
            var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
            if (fillStyle) {
                ctx.fillStyle = fillStyle;
                plotLineArea(series.datapoints, series.xaxis, series.yaxis);
            }

            if (lw > 0)
                plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
            ctx.restore();
        }

        function drawSeriesPoints(series) {
            function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
                var points = datapoints.points, ps = datapoints.pointsize;

                for (var i = 0; i < points.length; i += ps) {
                    var x = points[i], y = points[i + 1];
                    if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
                        continue;

                    ctx.beginPath();
                    x = axisx.p2c(x);
                    y = axisy.p2c(y) + offset;
                    if (symbol == "circle")
                        ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);
                    else
                        symbol(ctx, x, y, radius, shadow);
                    ctx.closePath();

                    if (fillStyle) {
                        ctx.fillStyle = fillStyle;
                        ctx.fill();
                    }
                    ctx.stroke();
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            var lw = series.points.lineWidth,
                sw = series.shadowSize,
                radius = series.points.radius,
                symbol = series.points.symbol;

            // If the user sets the line width to 0, we change it to a very 
            // small value. A line width of 0 seems to force the default of 1.
            // Doing the conditional here allows the shadow setting to still be 
            // optional even with a lineWidth of 0.

            if( lw == 0 )
                lw = 0.0001;

            if (lw > 0 && sw > 0) {
                // draw shadow in two steps
                var w = sw / 2;
                ctx.lineWidth = w;
                ctx.strokeStyle = "rgba(0,0,0,0.1)";
                plotPoints(series.datapoints, radius, null, w + w/2, true,
                           series.xaxis, series.yaxis, symbol);

                ctx.strokeStyle = "rgba(0,0,0,0.2)";
                plotPoints(series.datapoints, radius, null, w/2, true,
                           series.xaxis, series.yaxis, symbol);
            }

            ctx.lineWidth = lw;
            ctx.strokeStyle = series.color;
            plotPoints(series.datapoints, radius,
                       getFillStyle(series.points, series.color), 0, false,
                       series.xaxis, series.yaxis, symbol);
            ctx.restore();
        }

        function drawBar(x, y, b, barLeft, barRight, offset, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
            var left, right, bottom, top,
                drawLeft, drawRight, drawTop, drawBottom,
                tmp;

            // in horizontal mode, we start the bar from the left
            // instead of from the bottom so it appears to be
            // horizontal rather than vertical
            if (horizontal) {
                drawBottom = drawRight = drawTop = true;
                drawLeft = false;
                left = b;
                right = x;
                top = y + barLeft;
                bottom = y + barRight;

                // account for negative bars
                if (right < left) {
                    tmp = right;
                    right = left;
                    left = tmp;
                    drawLeft = true;
                    drawRight = false;
                }
            }
            else {
                drawLeft = drawRight = drawTop = true;
                drawBottom = false;
                left = x + barLeft;
                right = x + barRight;
                bottom = b;
                top = y;

                // account for negative bars
                if (top < bottom) {
                    tmp = top;
                    top = bottom;
                    bottom = tmp;
                    drawBottom = true;
                    drawTop = false;
                }
            }

            // clip
            if (right < axisx.min || left > axisx.max ||
                top < axisy.min || bottom > axisy.max)
                return;

            if (left < axisx.min) {
                left = axisx.min;
                drawLeft = false;
            }

            if (right > axisx.max) {
                right = axisx.max;
                drawRight = false;
            }

            if (bottom < axisy.min) {
                bottom = axisy.min;
                drawBottom = false;
            }

            if (top > axisy.max) {
                top = axisy.max;
                drawTop = false;
            }

            left = axisx.p2c(left);
            bottom = axisy.p2c(bottom);
            right = axisx.p2c(right);
            top = axisy.p2c(top);

            // fill the bar
            if (fillStyleCallback) {
                c.beginPath();
                c.moveTo(left, bottom);
                c.lineTo(left, top);
                c.lineTo(right, top);
                c.lineTo(right, bottom);
                c.fillStyle = fillStyleCallback(bottom, top);
                c.fill();
            }

            // draw outline
            if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
                c.beginPath();

                // FIXME: inline moveTo is buggy with excanvas
                c.moveTo(left, bottom + offset);
                if (drawLeft)
                    c.lineTo(left, top + offset);
                else
                    c.moveTo(left, top + offset);
                if (drawTop)
                    c.lineTo(right, top + offset);
                else
                    c.moveTo(right, top + offset);
                if (drawRight)
                    c.lineTo(right, bottom + offset);
                else
                    c.moveTo(right, bottom + offset);
                if (drawBottom)
                    c.lineTo(left, bottom + offset);
                else
                    c.moveTo(left, bottom + offset);
                c.stroke();
            }
        }

        function drawSeriesBars(series) {
            function plotBars(datapoints, barLeft, barRight, offset, fillStyleCallback, axisx, axisy) {
                var points = datapoints.points, ps = datapoints.pointsize;

                for (var i = 0; i < points.length; i += ps) {
                    if (points[i] == null)
                        continue;
                    drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, offset, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
                }
            }

            ctx.save();
            ctx.translate(plotOffset.left, plotOffset.top);

            // FIXME: figure out a way to add shadows (for instance along the right edge)
            ctx.lineWidth = series.bars.lineWidth;
            ctx.strokeStyle = series.color;

            var barLeft;

            switch (series.bars.align) {
                case "left":
                    barLeft = 0;
                    break;
                case "right":
                    barLeft = -series.bars.barWidth;
                    break;
                case "center":
                    barLeft = -series.bars.barWidth / 2;
                    break;
                default:
                    throw new Error("Invalid bar alignment: " + series.bars.align);
            }

            var fillStyleCallback = series.bars.fill ? function (bottom, top) { return getFillStyle(series.bars, series.color, bottom, top); } : null;
            plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, 0, fillStyleCallback, series.xaxis, series.yaxis);
            ctx.restore();
        }

        function getFillStyle(filloptions, seriesColor, bottom, top) {
            var fill = filloptions.fill;
            if (!fill)
                return null;

            if (filloptions.fillColor)
                return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);

            var c = $.color.parse(seriesColor);
            c.a = typeof fill == "number" ? fill : 0.4;
            c.normalize();
            return c.toString();
        }

        function insertLegend() {

            placeholder.find(".legend").remove();

            if (!options.legend.show)
                return;

            var fragments = [], entries = [], rowStarted = false,
                lf = options.legend.labelFormatter, s, label;

            // Build a list of legend entries, with each having a label and a color

            for (var i = 0; i < series.length; ++i) {
                s = series[i];
                if (s.label) {
                    label = lf ? lf(s.label, s) : s.label;
                    if (label) {
                        entries.push({
                            label: label,
                            color: s.color
                        });
                    }
                }
            }

            // Sort the legend using either the default or a custom comparator

            if (options.legend.sorted) {
                if ($.isFunction(options.legend.sorted)) {
                    entries.sort(options.legend.sorted);
                } else if (options.legend.sorted == "reverse") {
                	entries.reverse();
                } else {
                    var ascending = options.legend.sorted != "descending";
                    entries.sort(function(a, b) {
                        return a.label == b.label ? 0 : (
                            (a.label < b.label) != ascending ? 1 : -1   // Logical XOR
                        );
                    });
                }
            }

            // Generate markup for the list of entries, in their final order

            for (var i = 0; i < entries.length; ++i) {

                var entry = entries[i];

                if (i % options.legend.noColumns == 0) {
                    if (rowStarted)
                        fragments.push('</tr>');
                    fragments.push('<tr>');
                    rowStarted = true;
                }

                fragments.push(
                    '<td class="legendColorBox"><div style="border:1px solid ' + options.legend.labelBoxBorderColor + ';padding:1px"><div style="width:4px;height:0;border:5px solid ' + entry.color + ';overflow:hidden"></div></div></td>' +
                    '<td class="legendLabel">' + entry.label + '</td>'
                );
            }

            if (rowStarted)
                fragments.push('</tr>');

            if (fragments.length == 0)
                return;

            var table = '<table style="font-size:smaller;color:' + options.grid.color + '">' + fragments.join("") + '</table>';
            if (options.legend.container != null)
                $(options.legend.container).html(table);
            else {
                var pos = "",
                    p = options.legend.position,
                    m = options.legend.margin;
                if (m[0] == null)
                    m = [m, m];
                if (p.charAt(0) == "n")
                    pos += 'top:' + (m[1] + plotOffset.top) + 'px;';
                else if (p.charAt(0) == "s")
                    pos += 'bottom:' + (m[1] + plotOffset.bottom) + 'px;';
                if (p.charAt(1) == "e")
                    pos += 'right:' + (m[0] + plotOffset.right) + 'px;';
                else if (p.charAt(1) == "w")
                    pos += 'left:' + (m[0] + plotOffset.left) + 'px;';
                var legend = $('<div class="legend">' + table.replace('style="', 'style="position:absolute;' + pos +';') + '</div>').appendTo(placeholder);
                if (options.legend.backgroundOpacity != 0.0) {
                    // put in the transparent background
                    // separately to avoid blended labels and
                    // label boxes
                    var c = options.legend.backgroundColor;
                    if (c == null) {
                        c = options.grid.backgroundColor;
                        if (c && typeof c == "string")
                            c = $.color.parse(c);
                        else
                            c = $.color.extract(legend, 'background-color');
                        c.a = 1;
                        c = c.toString();
                    }
                    var div = legend.children();
                    $('<div style="position:absolute;width:' + div.width() + 'px;height:' + div.height() + 'px;' + pos +'background-color:' + c + ';"> </div>').prependTo(legend).css('opacity', options.legend.backgroundOpacity);
                }
            }
        }


        // interactive features

        var highlights = [],
            redrawTimeout = null;

        // returns the data item the mouse is over, or null if none is found
        function findNearbyItem(mouseX, mouseY, seriesFilter) {
            var maxDistance = options.grid.mouseActiveRadius,
                smallestDistance = maxDistance * maxDistance + 1,
                item = null, foundPoint = false, i, j, ps;

            for (i = series.length - 1; i >= 0; --i) {
                if (!seriesFilter(series[i]))
                    continue;

                var s = series[i],
                    axisx = s.xaxis,
                    axisy = s.yaxis,
                    points = s.datapoints.points,
                    mx = axisx.c2p(mouseX), // precompute some stuff to make the loop faster
                    my = axisy.c2p(mouseY),
                    maxx = maxDistance / axisx.scale,
                    maxy = maxDistance / axisy.scale;

                ps = s.datapoints.pointsize;
                // with inverse transforms, we can't use the maxx/maxy
                // optimization, sadly
                if (axisx.options.inverseTransform)
                    maxx = Number.MAX_VALUE;
                if (axisy.options.inverseTransform)
                    maxy = Number.MAX_VALUE;

                if (s.lines.show || s.points.show) {
                    for (j = 0; j < points.length; j += ps) {
                        var x = points[j], y = points[j + 1];
                        if (x == null)
                            continue;

                        // For points and lines, the cursor must be within a
                        // certain distance to the data point
                        if (x - mx > maxx || x - mx < -maxx ||
                            y - my > maxy || y - my < -maxy)
                            continue;

                        // We have to calculate distances in pixels, not in
                        // data units, because the scales of the axes may be different
                        var dx = Math.abs(axisx.p2c(x) - mouseX),
                            dy = Math.abs(axisy.p2c(y) - mouseY),
                            dist = dx * dx + dy * dy; // we save the sqrt

                        // use <= to ensure last point takes precedence
                        // (last generally means on top of)
                        if (dist < smallestDistance) {
                            smallestDistance = dist;
                            item = [i, j / ps];
                        }
                    }
                }

                if (s.bars.show && !item) { // no other point can be nearby
                    var barLeft = s.bars.align == "left" ? 0 : -s.bars.barWidth/2,
                        barRight = barLeft + s.bars.barWidth;

                    for (j = 0; j < points.length; j += ps) {
                        var x = points[j], y = points[j + 1], b = points[j + 2];
                        if (x == null)
                            continue;

                        // for a bar graph, the cursor must be inside the bar
                        if (series[i].bars.horizontal ?
                            (mx <= Math.max(b, x) && mx >= Math.min(b, x) &&
                             my >= y + barLeft && my <= y + barRight) :
                            (mx >= x + barLeft && mx <= x + barRight &&
                             my >= Math.min(b, y) && my <= Math.max(b, y)))
                                item = [i, j / ps];
                    }
                }
            }

            if (item) {
                i = item[0];
                j = item[1];
                ps = series[i].datapoints.pointsize;

                return { datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
                         dataIndex: j,
                         series: series[i],
                         seriesIndex: i };
            }

            return null;
        }

        function onMouseMove(e) {
            if (options.grid.hoverable)
                triggerClickHoverEvent("plothover", e,
                                       function (s) { return s["hoverable"] != false; });
        }

        function onMouseLeave(e) {
            if (options.grid.hoverable)
                triggerClickHoverEvent("plothover", e,
                                       function (s) { return false; });
        }

        function onClick(e) {
            triggerClickHoverEvent("plotclick", e,
                                   function (s) { return s["clickable"] != false; });
        }

        // trigger click or hover event (they send the same parameters
        // so we share their code)
        function triggerClickHoverEvent(eventname, event, seriesFilter) {
            var offset = eventHolder.offset(),
                canvasX = event.pageX - offset.left - plotOffset.left,
                canvasY = event.pageY - offset.top - plotOffset.top,
            pos = canvasToAxisCoords({ left: canvasX, top: canvasY });

            pos.pageX = event.pageX;
            pos.pageY = event.pageY;

            var item = findNearbyItem(canvasX, canvasY, seriesFilter);

            if (item) {
                // fill in mouse pos for any listeners out there
                item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
                item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
            }

            if (options.grid.autoHighlight) {
                // clear auto-highlights
                for (var i = 0; i < highlights.length; ++i) {
                    var h = highlights[i];
                    if (h.auto == eventname &&
                        !(item && h.series == item.series &&
                          h.point[0] == item.datapoint[0] &&
                          h.point[1] == item.datapoint[1]))
                        unhighlight(h.series, h.point);
                }

                if (item)
                    highlight(item.series, item.datapoint, eventname);
            }

            placeholder.trigger(eventname, [ pos, item ]);
        }

        function triggerRedrawOverlay() {
            var t = options.interaction.redrawOverlayInterval;
            if (t == -1) {      // skip event queue
                drawOverlay();
                return;
            }

            if (!redrawTimeout)
                redrawTimeout = setTimeout(drawOverlay, t);
        }

        function drawOverlay() {
            redrawTimeout = null;

            // draw highlights
            octx.save();
            octx.clearRect(0, 0, canvasWidth, canvasHeight);
            octx.translate(plotOffset.left, plotOffset.top);

            var i, hi;
            for (i = 0; i < highlights.length; ++i) {
                hi = highlights[i];

                if (hi.series.bars.show)
                    drawBarHighlight(hi.series, hi.point);
                else
                    drawPointHighlight(hi.series, hi.point);
            }
            octx.restore();

            executeHooks(hooks.drawOverlay, [octx]);
        }

        function highlight(s, point, auto) {
            if (typeof s == "number")
                s = series[s];

            if (typeof point == "number") {
                var ps = s.datapoints.pointsize;
                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
            }

            var i = indexOfHighlight(s, point);
            if (i == -1) {
                highlights.push({ series: s, point: point, auto: auto });

                triggerRedrawOverlay();
            }
            else if (!auto)
                highlights[i].auto = false;
        }

        function unhighlight(s, point) {
            if (s == null && point == null) {
                highlights = [];
                triggerRedrawOverlay();
            }

            if (typeof s == "number")
                s = series[s];

            if (typeof point == "number")
                point = s.data[point];

            var i = indexOfHighlight(s, point);
            if (i != -1) {
                highlights.splice(i, 1);

                triggerRedrawOverlay();
            }
        }

        function indexOfHighlight(s, p) {
            for (var i = 0; i < highlights.length; ++i) {
                var h = highlights[i];
                if (h.series == s && h.point[0] == p[0]
                    && h.point[1] == p[1])
                    return i;
            }
            return -1;
        }

        function drawPointHighlight(series, point) {
            var x = point[0], y = point[1],
                axisx = series.xaxis, axisy = series.yaxis,
                highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString();

            if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
                return;

            var pointRadius = series.points.radius + series.points.lineWidth / 2;
            octx.lineWidth = pointRadius;
            octx.strokeStyle = highlightColor;
            var radius = 1.5 * pointRadius;
            x = axisx.p2c(x);
            y = axisy.p2c(y);

            octx.beginPath();
            if (series.points.symbol == "circle")
                octx.arc(x, y, radius, 0, 2 * Math.PI, false);
            else
                series.points.symbol(octx, x, y, radius, false);
            octx.closePath();
            octx.stroke();
        }

        function drawBarHighlight(series, point) {
            var highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString(),
                fillStyle = highlightColor,
                barLeft = series.bars.align == "left" ? 0 : -series.bars.barWidth/2;

            octx.lineWidth = series.bars.lineWidth;
            octx.strokeStyle = highlightColor;

            drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth,
                    0, function () { return fillStyle; }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
        }

        function getColorOrGradient(spec, bottom, top, defaultColor) {
            if (typeof spec == "string")
                return spec;
            else {
                // assume this is a gradient spec; IE currently only
                // supports a simple vertical gradient properly, so that's
                // what we support too
                var gradient = ctx.createLinearGradient(0, top, 0, bottom);

                for (var i = 0, l = spec.colors.length; i < l; ++i) {
                    var c = spec.colors[i];
                    if (typeof c != "string") {
                        var co = $.color.parse(defaultColor);
                        if (c.brightness != null)
                            co = co.scale('rgb', c.brightness);
                        if (c.opacity != null)
                            co.a *= c.opacity;
                        c = co.toString();
                    }
                    gradient.addColorStop(i / (l - 1), c);
                }

                return gradient;
            }
        }
    }

    // Add the plot function to the top level of the jQuery object

    $.plot = function(placeholder, data, options) {
        //var t0 = new Date();
        var plot = new Plot($(placeholder), data, options, $.plot.plugins);
        //(window.console ? console.log : alert)("time used (msecs): " + ((new Date()).getTime() - t0.getTime()));
        return plot;
    };

    $.plot.version = "0.8-alpha";

    $.plot.plugins = [];

    // Also add the plot function as a chainable property

    $.fn.plot = function(data, options) {
        return this.each(function() {
            $.plot(this, data, options);
        });
    }

    // round to nearby lower multiple of base
    function floorInBase(n, base) {
        return base * Math.floor(n / base);
    }

})(jQuery);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/*
 * Flot plugin to order bars side by side.
 *
 * Released under the MIT license by Benjamin BUFFET, 20-Sep-2010.
 * Modifications made by Steven Hall <github.com/emmerich>, 01-May-2013.
 *
 * This plugin is an alpha version.
 *
 * To activate the plugin you must specify the parameter "order" for the specific serie :
 *
 *  $.plot($("#placeholder"), [{ data: [ ... ], bars :{ order = null or integer }])
 *
 * If 2 series have the same order param, they are ordered by the position in the array;
 *
 * The plugin adjust the point by adding a value depanding of the barwidth
 * Exemple for 3 series (barwidth : 0.1) :
 *
 *          first bar décalage : -0.15
 *          second bar décalage : -0.05
 *          third bar décalage : 0.05
 *
 */

// INFO: decalage/decallage is French for gap. It's used to denote the spacing applied to each
// bar.
(function($){
    function init(plot){
        var orderedBarSeries;
        var nbOfBarsToOrder;
        var borderWidth;
        var borderWidthInXabsWidth;
        var pixelInXWidthEquivalent = 1;
        var isHorizontal = false;

        // A mapping of order integers to decallage.
        var decallageByOrder = {};

        /*
         * This method add shift to x values
         */
        function reOrderBars(plot, serie, datapoints){
            var shiftedPoints = null;

            if(serieNeedToBeReordered(serie)){
                checkIfGraphIsHorizontal(serie);
                calculPixel2XWidthConvert(plot);
                retrieveBarSeries(plot);
                calculBorderAndBarWidth(serie);

                if(nbOfBarsToOrder >= 2){
                    var position = findPosition(serie);
                    var decallage = 0;

                    var centerBarShift = calculCenterBarShift();

                    // If we haven't already calculated the decallage for this order value, do it.
                    if(typeof decallageByOrder[serie.bars.order] === 'undefined') {
                        if (isBarAtLeftOfCenter(position)){
                            decallageByOrder[serie.bars.order] = -1*(sumWidth(orderedBarSeries,position-1,Math.floor(nbOfBarsToOrder / 2)-1)) - centerBarShift;
                        }else{
                            decallageByOrder[serie.bars.order] = sumWidth(orderedBarSeries,Math.ceil(nbOfBarsToOrder / 2),position-2) + centerBarShift + borderWidthInXabsWidth*2;
                        }
                    }

                    // Lookup the decallage based on the series' order value.
                    decallage = decallageByOrder[serie.bars.order];

                    shiftedPoints = shiftPoints(datapoints,serie,decallage);
                    datapoints.points = shiftedPoints;
                }
            }
            return shiftedPoints;
        }

        function serieNeedToBeReordered(serie){
            return serie.bars != null
                && serie.bars.show
                && serie.bars.order != null;
        }

        function calculPixel2XWidthConvert(plot){
            var gridDimSize = isHorizontal ? plot.getPlaceholder().innerHeight() : plot.getPlaceholder().innerWidth();
            var minMaxValues = isHorizontal ? getAxeMinMaxValues(plot.getData(),1) : getAxeMinMaxValues(plot.getData(),0);
            var AxeSize = minMaxValues[1] - minMaxValues[0];
            pixelInXWidthEquivalent = AxeSize / gridDimSize;
        }

        function getAxeMinMaxValues(series,AxeIdx){
            var minMaxValues = new Array();
            for(var i = 0; i < series.length; i++){
                minMaxValues[0] = (series[i].data[0]) ? series[i].data[0][AxeIdx]: null;
                minMaxValues[1] = (series[i].data[series[i].data.length - 1]) ? series[i].data[series[i].data.length - 1][AxeIdx]: null;
            }
            return minMaxValues;
        }

        function retrieveBarSeries(plot){
            orderedBarSeries = findOthersBarsToReOrders(plot.getData());
            nbOfBarsToOrder = orderedBarSeries.length;
        }

        function findOthersBarsToReOrders(series){
            var retSeries = new Array();
            var orderValuesSeen = [];

            for(var i = 0; i < series.length; i++){
                if(series[i].bars.order != null && series[i].bars.show &&
                    orderValuesSeen.indexOf(series[i].bars.order) < 0){

                    orderValuesSeen.push(series[i].bars.order);
                    retSeries.push(series[i]);
                }
            }
            return retSeries.sort(sortByOrder);
        }

        function sortByOrder(serie1,serie2){
            var x = serie1.bars.order;
            var y = serie2.bars.order;
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }

        function  calculBorderAndBarWidth(serie){
            borderWidth = typeof serie.bars.lineWidth !== 'undefined' ? serie.bars.lineWidth  : 2;
            borderWidthInXabsWidth = borderWidth * pixelInXWidthEquivalent;
        }

        function checkIfGraphIsHorizontal(serie){
            if(serie.bars.horizontal){
                isHorizontal = true;
            }
        }

        function findPosition(serie){
            var pos = 0
            for (var i = 0; i < orderedBarSeries.length; ++i) {
                if (serie == orderedBarSeries[i]){
                    pos = i;
                    break;
                }
            }

            return pos+1;
        }

        function calculCenterBarShift(){
            var width = 0;

            if(nbOfBarsToOrder%2 != 0)
                width = (orderedBarSeries[Math.ceil(nbOfBarsToOrder / 2)].bars.barWidth)/2;

            return width;
        }

        function isBarAtLeftOfCenter(position){
            return position <= Math.ceil(nbOfBarsToOrder / 2);
        }

        function sumWidth(series,start,end){
            var totalWidth = 0;

            for(var i = start; i <= end; i++){
                totalWidth += series[i].bars.barWidth+borderWidthInXabsWidth*2;
            }

            return totalWidth;
        }

        function shiftPoints(datapoints,serie,dx){
            var ps = datapoints.pointsize;
            var points = datapoints.points;
            var j = 0;
            for(var i = isHorizontal ? 1 : 0;i < points.length; i += ps){
                points[i] += dx;
                //Adding the new x value in the serie to be abble to display the right tooltip value,
                //using the index 3 to not overide the third index.
                serie.data[j][3] = points[i];
                j++;
            }

            return points;
        }

        plot.hooks.processDatapoints.push(reOrderBars);

    }

    var options = {
        series : {
            bars: {order: null} // or number/string
        }
    };

    $.plot.plugins.push({
        init: init,
        options: options,
        name: "orderBars",
        version: "0.2"
    });

})(jQuery);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

/* Pretty handling of time axes.

Copyright (c) 2007-2012 IOLA and Ole Laursen.
Licensed under the MIT license.

Set axis.mode to "time" to enable. See the section "Time series data" in
API.txt for details.

*/

(function($) {

	var options = {};

	// round to nearby lower multiple of base

	function floorInBase(n, base) {
		return base * Math.floor(n / base);
	}

	// Returns a string with the date d formatted according to fmt.
	// A subset of the Open Group's strftime format is supported.

	function formatDate(d, fmt, monthNames, dayNames) {

		if (typeof d.strftime == "function") {
			return d.strftime(fmt);
		}

		var leftPad = function(n, pad) {
			n = "" + n;
			pad = "" + (pad == null ? "0" : pad);
			return n.length == 1 ? pad + n : n;
		};

		var r = [];
		var escape = false;
		var hours = d.getHours();
		var isAM = hours < 12;

		if (monthNames == null) {
			monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		}

		if (dayNames == null) {
			dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
		}

		var hours12;

		if (hours > 12) {
			hours12 = hours - 12;
		} else if (hours == 0) {
			hours12 = 12;
		} else {
			hours12 = hours;
		}

		for (var i = 0; i < fmt.length; ++i) {

			var c = fmt.charAt(i);

			if (escape) {
				switch (c) {
					case 'a': c = "" + dayNames[d.getDay()]; break;
					case 'b': c = "" + monthNames[d.getMonth()]; break;
					case 'd': c = leftPad(d.getDate()); break;
					case 'e': c = leftPad(d.getDate(), " "); break;
					case 'H': c = leftPad(hours); break;
					case 'I': c = leftPad(hours12); break;
					case 'l': c = leftPad(hours12, " "); break;
					case 'm': c = leftPad(d.getMonth() + 1); break;
					case 'M': c = leftPad(d.getMinutes()); break;
					// quarters not in Open Group's strftime specification
					case 'q':
						c = "" + (Math.floor(d.getMonth() / 3) + 1); break;
					case 'S': c = leftPad(d.getSeconds()); break;
					case 'y': c = leftPad(d.getFullYear() % 100); break;
					case 'Y': c = "" + d.getFullYear(); break;
					case 'p': c = (isAM) ? ("" + "am") : ("" + "pm"); break;
					case 'P': c = (isAM) ? ("" + "AM") : ("" + "PM"); break;
					case 'w': c = "" + d.getDay(); break;
				}
				r.push(c);
				escape = false;
			} else {
				if (c == "%") {
					escape = true;
				} else {
					r.push(c);
				}
			}
		}

		return r.join("");
	}

	// To have a consistent view of time-based data independent of which time
	// zone the client happens to be in we need a date-like object independent
	// of time zones.  This is done through a wrapper that only calls the UTC
	// versions of the accessor methods.

	function makeUtcWrapper(d) {

		function addProxyMethod(sourceObj, sourceMethod, targetObj, targetMethod) {
			sourceObj[sourceMethod] = function() {
				return targetObj[targetMethod].apply(targetObj, arguments);
			};
		};

		var utc = {
			date: d
		};

		// support strftime, if found

		if (d.strftime != undefined) {
			addProxyMethod(utc, "strftime", d, "strftime");
		}

		addProxyMethod(utc, "getTime", d, "getTime");
		addProxyMethod(utc, "setTime", d, "setTime");

		var props = ["Date", "Day", "FullYear", "Hours", "Milliseconds", "Minutes", "Month", "Seconds"];

		for (var p = 0; p < props.length; p++) {
			addProxyMethod(utc, "get" + props[p], d, "getUTC" + props[p]);
			addProxyMethod(utc, "set" + props[p], d, "setUTC" + props[p]);
		}

		return utc;
	};

	// select time zone strategy.  This returns a date-like object tied to the
	// desired timezone

	function dateGenerator(ts, opts) {
		if (opts.timezone == "browser") {
			return new Date(ts);
		} else if (!opts.timezone || opts.timezone == "utc") {
			return makeUtcWrapper(new Date(ts));
		} else if (typeof timezoneJS != "undefined" && typeof timezoneJS.Date != "undefined") {
			var d = new timezoneJS.Date();
			// timezone-js is fickle, so be sure to set the time zone before
			// setting the time.
			d.setTimezone(opts.timezone);
			d.setTime(ts);
			return d;
		} else {
			return makeUtcWrapper(new Date(ts));
		}
	}
	
	// map of app. size of time units in milliseconds

	var timeUnitSize = {
		"second": 1000,
		"minute": 60 * 1000,
		"hour": 60 * 60 * 1000,
		"day": 24 * 60 * 60 * 1000,
		"month": 30 * 24 * 60 * 60 * 1000,
		"quarter": 3 * 30 * 24 * 60 * 60 * 1000,
		"year": 365.2425 * 24 * 60 * 60 * 1000
	};

	// the allowed tick sizes, after 1 year we use
	// an integer algorithm

	var baseSpec = [
		[1, "second"], [2, "second"], [5, "second"], [10, "second"],
		[30, "second"], 
		[1, "minute"], [2, "minute"], [5, "minute"], [10, "minute"],
		[30, "minute"], 
		[1, "hour"], [2, "hour"], [4, "hour"],
		[8, "hour"], [12, "hour"],
		[1, "day"], [2, "day"], [3, "day"],
		[0.25, "month"], [0.5, "month"], [1, "month"],
		[2, "month"]
	];

	// we don't know which variant(s) we'll need yet, but generating both is
	// cheap

	var specMonths = baseSpec.concat([[3, "month"], [6, "month"],
		[1, "year"]]);
	var specQuarters = baseSpec.concat([[1, "quarter"], [2, "quarter"],
		[1, "year"]]);

	function init(plot) {
		plot.hooks.processDatapoints.push(function (plot, series, datapoints) {
			$.each(plot.getAxes(), function(axisName, axis) {

				var opts = axis.options;

				if (opts.mode == "time") {
					axis.tickGenerator = function(axis) {

						var ticks = [];
						var d = dateGenerator(axis.min, opts);
						var minSize = 0;

						// make quarter use a possibility if quarters are
						// mentioned in either of these options

						var spec = (opts.tickSize && opts.tickSize[1] ===
							"quarter") ||
							(opts.minTickSize && opts.minTickSize[1] ===
							"quarter") ? specQuarters : specMonths;

						if (opts.minTickSize != null) {
							if (typeof opts.tickSize == "number") {
								minSize = opts.tickSize;
							} else {
								minSize = opts.minTickSize[0] * timeUnitSize[opts.minTickSize[1]];
							}
						}

						for (var i = 0; i < spec.length - 1; ++i) {
							if (axis.delta < (spec[i][0] * timeUnitSize[spec[i][1]]
											  + spec[i + 1][0] * timeUnitSize[spec[i + 1][1]]) / 2
								&& spec[i][0] * timeUnitSize[spec[i][1]] >= minSize) {
								break;
							}
						}

						var size = spec[i][0];
						var unit = spec[i][1];

						// special-case the possibility of several years

						if (unit == "year") {

							// if given a minTickSize in years, just use it,
							// ensuring that it's an integer

							if (opts.minTickSize != null && opts.minTickSize[1] == "year") {
								size = Math.floor(opts.minTickSize[0]);
							} else {

								var magn = Math.pow(10, Math.floor(Math.log(axis.delta / timeUnitSize.year) / Math.LN10));
								var norm = (axis.delta / timeUnitSize.year) / magn;

								if (norm < 1.5) {
									size = 1;
								} else if (norm < 3) {
									size = 2;
								} else if (norm < 7.5) {
									size = 5;
								} else {
									size = 10;
								}

								size *= magn;
							}

							// minimum size for years is 1

							if (size < 1) {
								size = 1;
							}
						}

						axis.tickSize = opts.tickSize || [size, unit];
						var tickSize = axis.tickSize[0];
						unit = axis.tickSize[1];

						var step = tickSize * timeUnitSize[unit];

						if (unit == "second") {
							d.setSeconds(floorInBase(d.getSeconds(), tickSize));
						} else if (unit == "minute") {
							d.setMinutes(floorInBase(d.getMinutes(), tickSize));
						} else if (unit == "hour") {
							d.setHours(floorInBase(d.getHours(), tickSize));
						} else if (unit == "month") {
							d.setMonth(floorInBase(d.getMonth(), tickSize));
						} else if (unit == "quarter") {
							d.setMonth(3 * floorInBase(d.getMonth() / 3,
								tickSize));
						} else if (unit == "year") {
							d.setFullYear(floorInBase(d.getFullYear(), tickSize));
						}

						// reset smaller components

						d.setMilliseconds(0);

						if (step >= timeUnitSize.minute) {
							d.setSeconds(0);
						} else if (step >= timeUnitSize.hour) {
							d.setMinutes(0);
						} else if (step >= timeUnitSize.day) {
							d.setHours(0);
						} else if (step >= timeUnitSize.day * 4) {
							d.setDate(1);
						} else if (step >= timeUnitSize.month * 2) {
							d.setMonth(floorInBase(d.getMonth(), 3));
						} else if (step >= timeUnitSize.quarter * 2) {
							d.setMonth(floorInBase(d.getMonth(), 6));
						} else if (step >= timeUnitSize.year) {
							d.setMonth(0);
						}

						var carry = 0;
						var v = Number.NaN;
						var prev;

						do {

							prev = v;
							v = d.getTime();
							ticks.push(v);

							if (unit == "month" || unit == "quarter") {
								if (tickSize < 1) {

									// a bit complicated - we'll divide the
									// month/quarter up but we need to take
									// care of fractions so we don't end up in
									// the middle of a day

									d.setDate(1);
									var start = d.getTime();
									d.setMonth(d.getMonth() +
										(unit == "quarter" ? 3 : 1));
									var end = d.getTime();
									d.setTime(v + carry * timeUnitSize.hour + (end - start) * tickSize);
									carry = d.getHours();
									d.setHours(0);
								} else {
									d.setMonth(d.getMonth() +
										tickSize * (unit == "quarter" ? 3 : 1));
								}
							} else if (unit == "year") {
								d.setFullYear(d.getFullYear() + tickSize);
							} else {
								d.setTime(v + step);
							}
						} while (v < axis.max && v != prev);

						return ticks;
					};

					axis.tickFormatter = function (v, axis) {

						var d = dateGenerator(v, axis.options);

						// first check global format

						if (opts.timeformat != null) {
							return formatDate(d, opts.timeformat, opts.monthNames, opts.dayNames);
						}

						// possibly use quarters if quarters are mentioned in
						// any of these places

						var useQuarters = (axis.options.tickSize &&
								axis.options.tickSize[1] == "quarter") ||
							(axis.options.minTickSize &&
								axis.options.minTickSize[1] == "quarter");

						var t = axis.tickSize[0] * timeUnitSize[axis.tickSize[1]];
						var span = axis.max - axis.min;
						var suffix = (opts.twelveHourClock) ? " %p" : "";
						var hourCode = (opts.twelveHourClock) ? "%I" : "%H";
						var fmt;

						if (t < timeUnitSize.minute) {
							fmt = hourCode + ":%M:%S" + suffix;
						} else if (t < timeUnitSize.day) {
							if (span < 2 * timeUnitSize.day) {
								fmt = hourCode + ":%M" + suffix;
							} else {
								fmt = "%b %d " + hourCode + ":%M" + suffix;
							}
						} else if (t < timeUnitSize.month) {
							fmt = "%b %d";
						} else if ((useQuarters && t < timeUnitSize.quarter) ||
							(!useQuarters && t < timeUnitSize.year)) {
							if (span < timeUnitSize.year) {
								fmt = "%b";
							} else {
								fmt = "%b %Y";
							}
						} else if (useQuarters && t < timeUnitSize.year) {
							if (span < timeUnitSize.year) {
								fmt = "Q%q";
							} else {
								fmt = "Q%q %Y";
							}
						} else {
							fmt = "%Y";
						}

						var rt = formatDate(d, fmt, opts.monthNames, opts.dayNames);

						return rt;
					};
				}
			});
		});
	}

	$.plot.plugins.push({
		init: init,
		options: options,
		name: 'time',
		version: '1.0'
	});

	// Time-axis support used to be in Flot core, which exposed the
	// formatDate function on the plot object.  Various plugins depend
	// on the function, so we need to re-expose it here.

	$.plot.formatDate = formatDate;

})(jQuery);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Note: This script is under development. We are using this inside core only and can be update in future. Currently uses only for admin purpose.
 */
(function ($) {
	'use strict';

	$.extend({
		giveAjaxifyFields: function giveAjaxifyFields(customSettings) {
			var $countryField,
			    $parentWrapper,
			    defaultSettings = {

				// Supported types: country_state.
				type: '',

				// Define these setting only if type set to country_state.
				parentWrapper: 'form',
				countryFieldName: 'country',
				stateFieldName: 'state',
				stateFieldWrapper: '.give-field-wrap',
				chosenState: true
			};

			var settings = $.extend({}, defaultSettings, customSettings || {});

			switch (settings.type) {
				case 'country_state':
					$countryField = $('select[name="' + settings.countryFieldName + '"]');
					$parentWrapper = $countryField.closest(settings.parentWrapper);

					// Bailout.
					if (!$countryField.length || 'Country_state' === $countryField.data('give-ajaxify-field')) {
						return;
					}

					// Set data attribute.
					$countryField.data('give-ajaxify-field', 'country_state');

					// Update base state field based on selected base country
					$countryField.change(function () {
						var $this = $(this),
						    $stateField = $this.closest(settings.parentWrapper).find('[name="' + settings.stateFieldName + '"]'),
						    $stateFieldWrapper = $stateField.closest(settings.stateFieldWrapper),
						    $stateFieldLabel = $('label', $stateFieldWrapper);

						// If state does not has wrapper then find it's label
						if (!settings.stateFieldWrapper) {
							$stateFieldLabel = $('label[for="' + settings.stateFieldName + '"]', $parentWrapper);
							$stateFieldWrapper = $stateField.parent();
						}

						var data = {
							action: 'give_get_states',
							country: $this.val(),
							field_name: settings.stateFieldName
						};

						$.post(ajaxurl, data, function (response) {

							// Bailout.
							if (!response.show_field) {
								if (settings.stateFieldWrapper) {
									$stateFieldWrapper.addClass('give-hidden');
								} else {
									$stateField.addClass('give-hidden');
								}
								return;
							}

							if ($stateFieldLabel.length) {
								$stateFieldLabel.text(response.states_label);
							}

							if (settings.chosenState) {
								$stateField.chosen('destroy');
							}

							// Show field.
							if (settings.stateFieldWrapper) {
								$stateFieldWrapper.removeClass('give-hidden');
							} else {
								$stateField.removeClass('give-hidden');
							}

							if (_typeof(response.states_found) !== undefined && true === response.states_found) {
								// Update html.
								$stateField.replaceWith(response.data);

								// Update selector.
								$stateField = $('[name="' + settings.stateFieldName + '"]', $stateFieldWrapper);

								// Reset chosenState
								if (settings.chosenState) {
									$stateField.chosen();
								}
							} else {
								$stateField.replaceWith('<input type="text" name="' + settings.stateFieldName + '" value="' + response.default_state + '" class="medium-text"/>');

								// Update selector.
								$stateField = $('[name="' + settings.stateFieldName + '"]', $stateFieldWrapper);
							}
						});
					});

					break;
			}

			return this;
		}
	});
})(jQuery);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var Give_Selector_Cache = {
	collection: {},

	get: function get(selector, parent, refresh_cache) {
		// Bailout.
		if (!jQuery) {
			return -1;
		}

		// Set default parent.
		parent = undefined !== parent ? parent : undefined;
		refresh_cache = refresh_cache === true;

		if (undefined === this.collection[selector] || refresh_cache) {
			if (undefined !== parent) {
				this.collection[selector] = jQuery(selector, parent);
			} else {
				this.collection[selector] = jQuery(selector);
			}
		}

		return this.collection[selector];
	}
};

window.Give_Selector_Cache = Give_Selector_Cache;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

/*
 * jQuery Repeatable Fields v1.4.8
 * http://www.rhyzz.com/repeatable-fields.html
 *
 * Copyright (c) 2014-2015 Rhyzz
 * License MIT
 */

(function ($) {
	$.fn.repeatable_fields = function (custom_settings) {
		var default_settings = {
			wrapper: '.wrapper',
			container: '.container',
			row: '.row',
			add: '.add',
			remove: '.remove',
			confirm_before_remove_row: false,
			confirm_before_remove_row_text: '',
			move: '.move',
			template: '.template',
			is_sortable: true,
			before_add: null,
			after_add: after_add,
			before_remove: null,
			after_remove: null,
			sortable_options: null,
			row_count_placeholder: '{{row-count-placeholder}}'
		};

		var settings = $.extend({}, default_settings, custom_settings);

		// Initialize all repeatable field wrappers
		initialize(this);

		function initialize(parent) {
			$(settings.wrapper, parent).each(function (index, element) {
				var wrapper = this;

				var container = $(wrapper).children(settings.container);

				// Disable all form elements inside the row template
				$(container).children(settings.template).hide().find(':input').each(function () {
					$(this).prop('disabled', true);
				});

				var row_count = $(container).children(settings.row).filter(function () {
					return !$(this).hasClass(settings.template.replace('.', ''));
				}).length;

				$(container).attr('data-rf-row-count', row_count);

				$(wrapper).on('click', settings.add, function (event) {
					event.stopImmediatePropagation();

					var row_template = $($(container).children(settings.template).clone().removeClass(settings.template.replace('.', ''))[0].outerHTML);

					// Enable all form elements inside the row template
					$(row_template).find(':input').each(function () {
						$(this).prop('disabled', false);
					});

					if (typeof settings.before_add === 'function') {
						settings.before_add(container);
					}

					var new_row = $(row_template).show().appendTo(container);

					if (typeof settings.after_add === 'function') {
						settings.after_add(container, new_row, after_add);
					}

					// The new row might have it's own repeatable field wrappers so initialize them too
					initialize(new_row);
				});

				$(wrapper).on('click', settings.remove, function (event) {
					event.stopImmediatePropagation();

					if (settings.confirm_before_remove_row && settings.confirm_before_remove_row_text) {
						if (!confirm(settings.confirm_before_remove_row_text)) {
							return false;
						}
					}

					var row = $(this).parents(settings.row).first();

					if (typeof settings.before_remove === 'function') {
						settings.before_remove(container, row);
					}

					row.remove();

					if (typeof settings.after_remove === 'function') {
						settings.after_remove(container);
					}
				});

				if (settings.is_sortable === true && typeof $.ui !== 'undefined' && typeof $.ui.sortable !== 'undefined') {
					var sortable_options = settings.sortable_options !== null ? settings.sortable_options : {};

					sortable_options.handle = settings.move;

					$(wrapper).find(settings.container).sortable(sortable_options);
				}
			});
		}

		function after_add(container, new_row) {
			var row_count = $(container).attr('data-rf-row-count');

			row_count++;

			$('*', new_row).each(function () {
				$.each(this.attributes, function (index, element) {
					this.value = this.value.replace(settings.row_count_placeholder, row_count - 1);
				});
			});

			$(container).attr('data-rf-row-count', row_count);
		}
	};
})(jQuery);

/***/ }),
/* 35 */
/***/ (function(module, exports) {

/*!
 * Give Admin Forms JS
 *
 * @description: The Give Admin Forms scripts. Only enqueued on the give_forms CPT; used to validate fields, show/hide, and other functions
 * @package:     Give
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

(function ($) {
	/**
  * Default Radio Button
  *
  * @description: Allow only one radio button to be checked at a time
  * @since: 1.0
  */
	var handle_default_radio = function handle_default_radio() {
		$('body').on('change', '.give-give_default_radio_inline', function () {
			// Unset pre selected default level.
			$('.give-give_default_radio_inline').prop('checked', false);

			// Set level as default.
			$(this).prop('checked', true);
		});

		// Note: some cases is covered in admin-scripts.js.
		// For ref: handle_metabox_repeater_field_row_count, handle_metabox_repeater_field_row_remove
	};

	/**
  * Toggle Conditional Form Fields
  *
  *  @since: 1.0
  */
	var toggle_conditional_form_fields = function toggle_conditional_form_fields() {

		//Price Option
		var price_option = $('._give_price_option_field input:radio');

		price_option.on('change', function () {

			var price_option_val = $('._give_price_option_field input:radio:checked').val();
			if (price_option_val === 'set') {
				//set price shows
				$('._give_set_price_field').show();
				$('#_give_donation_levels_field').hide(); // Hide multi-val stuffs.
				$('._give_display_style_field').hide(); // Hide display style setting.
			} else {
				//multi-value shows
				$('._give_set_price_field').hide();
				$('#_give_donation_levels_field').show(); // Show set stuffs.
				$('._give_display_style_field').show(); // Show display style setting.
			}
		}).change();

		//Content Option
		var display_content = $('._give_display_content_field input:radio');
		display_content.on('change', function () {
			// Get checked radio button value.
			var display_content_val = $('._give_display_content_field input:radio:checked').val();

			if (display_content_val === 'enabled') {
				$('._give_content_placement_field').show();
				$('._give_form_content_field').show();
			} else {
				$('._give_content_placement_field').hide();
				$('._give_form_content_field').hide();
			}
		}).change();

		//Terms Option
		var terms_option = $('._give_terms_option_field input:radio');
		terms_option.on('change', function () {
			// Get checked radio button value.
			var terms_option_val = $('._give_terms_option_field input:radio:checked').val();

			if (terms_option_val === 'enabled') {
				$('._give_agree_label_field').show();
				$('._give_agree_text_field').show();
			} else {
				$('._give_agree_label_field').hide();
				$('._give_agree_text_field').hide();
			}
		}).change();

		//Payment Display
		var payment_display_option = $('._give_payment_display_field input:radio');
		payment_display_option.on('change', function () {
			var payment_display_option_val = $('._give_payment_display_field input:radio:checked').val();

			if (payment_display_option_val === 'onpage') {
				$('._give_reveal_label_field').hide();
			} else {
				$('._give_reveal_label_field').show();
			}
		}).change();

		//Custom Amount
		var custom_amount_option = $('._give_custom_amount_field input:radio');
		custom_amount_option.on('change', function () {
			var custom_amount_option_val = $('._give_custom_amount_field input:radio:checked').val();
			if (custom_amount_option_val === 'disabled') {
				$('._give_custom_amount_range_field ').hide();
				$('._give_custom_amount_text_field').hide();
			} else {
				$('._give_custom_amount_range_field ').show();
				$('._give_custom_amount_text_field').show();
			}
		}).change();

		//Goals
		var goal_option = $('._give_goal_option_field');
		var goal_format = $('._give_goal_format_field input:radio');
		//Close Form when Goal Achieved
		var close_form_when_goal_achieved_option = $('._give_close_form_when_goal_achieved_field input:radio');

		close_form_when_goal_achieved_option.on('change', function () {
			var close_form_when_goal_achieved_option_val = $('._give_close_form_when_goal_achieved_field input:radio:checked').val();
			if (close_form_when_goal_achieved_option_val === 'disabled') {
				$('._give_form_goal_achieved_message_field').hide();
			} else {
				$('._give_form_goal_achieved_message_field').show();
			}
		}).change();

		goal_option.on('change', function () {
			var goal_option = $('._give_goal_option_field input:radio:checked').val();
			if (goal_option === 'disabled') {

				$('._give_set_goal_field').hide();
				$('._give_goal_format_field').hide();
				$('._give_goal_color_field').hide();
				$('._give_close_form_when_goal_achieved_field').hide();
				$('._give_form_goal_achieved_message_field').hide();
				$('._give_number_of_donation_goal_field').hide();
				$('._give_number_of_donor_goal_field').hide();
			} else {
				$('._give_set_goal_field').show();
				$('._give_goal_format_field').show();
				$('._give_goal_color_field').show();
				$('._give_close_form_when_goal_achieved_field').show();

				var close_form_when_goal_achieved_option_val = $('._give_close_form_when_goal_achieved_field input:radio:checked').val();

				if (close_form_when_goal_achieved_option_val === 'enabled') {
					$('._give_form_goal_achieved_message_field').show();
				}

				// Trigger goal format option.
				goal_format.change();
			}
		}).change();

		goal_format.on('change', function () {
			var goal_format_val = $('._give_goal_format_field input:radio:checked').val();
			var goal_option_val = $('._give_goal_option_field input:radio:checked').val();

			if ('donation' === goal_format_val) {
				$('._give_set_goal_field, ._give_number_of_donor_goal_field,._give_number_of_donation_goal_field').hide();
				if ('disabled' !== goal_option_val) {
					$('._give_number_of_donation_goal_field').show();
				}
			} else if ('donors' === goal_format_val) {
				$('._give_set_goal_field, ._give_number_of_donation_goal_field, ._give_number_of_donor_goal_field').hide();
				if ('disabled' !== goal_option_val) {
					$('._give_number_of_donor_goal_field').show();
				}
			} else {
				'disabled' === goal_option_val ? $('._give_set_goal_field').hide() : $('._give_set_goal_field').show();
				$('._give_number_of_donation_goal_field, ._give_number_of_donor_goal_field').hide();
			}
		}).change();

		// Offline Donations.
		var offline_customization_option = $('._give_customize_offline_donations_field input:radio');
		offline_customization_option.on('change', function () {
			var offline_customization_option_val = $('._give_customize_offline_donations_field input:radio:checked').val();
			if ('enabled' === offline_customization_option_val) {
				$('._give_offline_checkout_notes_field').show();
				$('._give_offline_donation_enable_billing_fields_single_field').show();
				$('._give_offline_donation_subject_field').show();
				$('._give_offline_donation_email_field').show();
			} else {
				$('._give_offline_checkout_notes_field').hide();
				$('._give_offline_donation_enable_billing_fields_single_field').hide();
				$('._give_offline_donation_subject_field').hide();
				$('._give_offline_donation_email_field').hide();
			}
		}).change();

		//Email options.
		var email_options = $('._give_email_options_field input:radio');
		email_options.on('change', function () {
			// Get checked radio button value.
			var email_options_val = $('._give_email_options_field input:radio:checked').val();

			if (email_options_val === 'enabled') {
				$('#email_notification_options .give-field-wrap:not(._give_email_options_field)').show();
			} else {
				$('#email_notification_options .give-field-wrap:not(._give_email_options_field)').hide();
			}
		}).change();

		// Title Prefixes.
		var defaultNameTitlePrefixChecked = $('input[name="_give_name_title_prefix"]:checked').val();
		if ('required' === defaultNameTitlePrefixChecked || 'optional' === defaultNameTitlePrefixChecked) {
			$('.give-title-prefixes-wrap').show();
		}

		$('input[name="_give_name_title_prefix"]').on('change', function () {
			var titlePrefixChecked = $('input[name="_give_name_title_prefix"]:checked').val();

			if ('required' === titlePrefixChecked || 'optional' === titlePrefixChecked) {
				$('.give-title-prefixes-wrap').show();
			} else {
				$('.give-title-prefixes-wrap').hide();
			}
		});
	};

	//Handle Repeatable Row ID
	var handle_repeatable_row_ID = function handle_repeatable_row_ID() {

		//Ensure for new posts that the repeater is filled
		if ($('.give-level-id').text() === '') {
			var row_group = $('.cmb-repeatable-grouping');
			//loop through all repeatable rows and set vals
			row_group.each(function (index, object) {

				var row_id = $(object).data('iterator') + 1;

				$(object).find('.give-level-id').text(row_id);
				$(object).find('.give-level-id-input').val(row_id);
			});
		}

		$('body').on('cmb2_add_row', function (event, row) {
			set_row_ids(row);
		});
		$('body').on('cmb2_shift_rows_complete', function (event, self) {

			var row_group = $('.cmb-repeatable-grouping');
			//loop through all repeatable rows and set vals
			row_group.each(function (index, object) {

				var row_id = $(object).find('input.give-level-id-input').val();

				$(object).find('.give-level-id').text(row_id);
			});
		});

		/**
   * Set Row IDs
   *
   * @description: Sets values in the Multi-level donation repeatable field
   * @param row
   */
		function set_row_ids(row) {

			var row_count = count_repeatable_rows();

			//Add row ID value to hidden field
			$(row).find('input.give-level-id-input').val(row_count);
			//Add row ID to displayed ID
			$(row).find('.give-level-id').text(row_count);
		}

		/**
   * Loops through Multi-level repeater rows
   *
   * @description: First counts the rows then it compares the row count with the largest iterator count.
   *
   * @returns {number}
   */
		function count_repeatable_rows() {
			var row_counter = 0;
			var row_largest_number = 0;
			var row_number = 0;

			//Loop through repeatable rows to see what highest ID is currently
			$('#_give_donation_levels_repeat > .cmb-repeatable-grouping').each(function (index, value) {

				row_number = $(this).find('input.give-level-id-input').val();

				if (row_number > row_largest_number) {
					row_largest_number = row_number;
				}

				row_counter++;
			});

			if (typeof row_largest_number !== 'undefined' && row_largest_number >= row_counter) {
				return parseInt(row_largest_number) + 1; //ensure no duplicate rows returned
			} else {
				return row_counter;
			}
		}
	};

	/**
  * Misc Cleanup
  *
  * @description: Clean up and tweaks
  * @since: 1.0
  */
	function misc_cleanup() {

		//No Value = Placeholders: determine if value is 0.00 and remove if so in favor of placeholders
		$('.cmb2-text-money').each(function (index, object) {
			var this_val = parseInt($(object).val());
			if (!this_val) {
				$(object).removeAttr('value');
			}
		});
	}

	//On DOM Ready
	$(function () {

		handle_default_radio();
		toggle_conditional_form_fields();
		handle_repeatable_row_ID();
		misc_cleanup();
	});
})(jQuery);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

/*!
 * Give Admin Forms JS
 *
 * @description: The Give Admin Settings scripts. Only enqueued on the give-settings page; used for tabs and other show/hide functionality
 * @package:     Give
 * @since:       1.5
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

/* globals Give, jQuery */
jQuery(document).ready(function ($) {

	/**
  *  Sortable payment gateways.
  */
	var $payment_gateways = jQuery('ul.give-payment-gatways-list');
	if ($payment_gateways.length) {
		$payment_gateways.sortable();
	}

	/**
  * Change currency position symbol on changing the currency
  */
	var give_settings_currency = '#give-mainform #currency';
	var give_settings_position = '#give-mainform #currency_position';
	$('body').on('change', give_settings_currency, function () {
		var currency_text = $(give_settings_currency + ' option:selected').text(),
		    currency_sign = currency_text.split('(').pop().split(')').shift();

		if ('' === currency_sign) {
			currency_sign = Give.fn.getGlobalVar('currency_sign');
		}

		var before_text = $(give_settings_position).data('before-template');
		before_text = before_text.replace('{currency_pos}', currency_sign);
		$(give_settings_position + ' option[value="before"]').text(before_text);

		var after_text = $(give_settings_position).data('after-template');
		after_text = after_text.replace('{currency_pos}', currency_sign);
		$(give_settings_position + ' option[value="after"]').text(after_text);
	});

	/**
  * Show/Hide Title Prefixes
  */
	if ('disabled' !== $('input[name="name_title_prefix"]:checked').val()) {
		$('.give-title-prefixes-settings-wrap').show();
	}

	$('input[name="name_title_prefix"]').on('change', function () {
		if ('disabled' !== $(this).val()) {
			$('.give-title-prefixes-settings-wrap').show();
		} else {
			$('.give-title-prefixes-settings-wrap').hide();
		}
	});

	/**
  * Repeater setting field event.
  */
	$('a.give-repeat-setting-field').on('click', function (e) {
		e.preventDefault();
		var $parent = $(this).parents('td'),
		    $first_setting_field_group = $('p:first-child', $parent),
		    $new_setting_field_group = $first_setting_field_group.clone(),
		    setting_field_count = $('p', $parent).not('.give-field-description').length,
		    fieldID = $(this).data('id') + '_' + ++setting_field_count,
		    $prev_field = $(this).prev();

		// Create new field only if previous is non empty.
		if ($('input', $prev_field).val()) {
			// Add setting field html to dom.
			$(this).before($new_setting_field_group);
			$prev_field = $(this).prev();

			// Set id and value for setting field.
			$('input', $prev_field).attr('id', fieldID);
			$('input', $prev_field).val('');
		}

		return false;
	});

	$('.give-settings-page').on('click', 'span.give-remove-setting-field', function (e) {
		$(this).parents('p').remove();
	});

	/**
  * Enabled & disable email notification event.
  */
	$('.give-email-notification-status', 'table.giveemailnotifications').on('click', function () {
		var $this = $(this),
		    $icon_container = $('i', $this),
		    $loader = $(this).next(),
		    set_notification_status = $(this).hasClass('give-email-notification-enabled') ? 'disabled' : 'enabled',
		    notification_id = $(this).data('id');

		// Bailout if admin can not edit notification status setting.
		if (!parseInt($this.data('edit'))) {
			// Remove all notice.
			$('div.give-email-notification-status-notice').remove();

			// Add notice.
			$('hr.wp-header-end').after('<div class="updated error give-email-notification-status-notice"><p>' + $(this).closest('.give-email-notification-status').data('notice') + '</p></div>');

			// Scroll to notice.
			$('html, body').animate({ scrollTop: $('div.give-email-notification-status-notice').position().top }, 'slow');

			return false;
		}

		$.ajax({
			url: ajaxurl,
			method: 'POST',
			data: {
				action: 'give_set_notification_status',
				status: set_notification_status,
				notification_id: notification_id
			},
			beforeSend: function beforeSend() {
				$this.hide();
				$loader.addClass('is-active');
			},
			success: function success(res) {
				if (res.success) {
					$this.removeClass('give-email-notification-' + $this.data('status'));
					$this.addClass('give-email-notification-' + set_notification_status);
					$this.data('status', set_notification_status);

					if ('enabled' === set_notification_status) {
						$icon_container.removeClass('dashicons-no-alt');
						$icon_container.addClass('dashicons-yes');
					} else {
						$icon_container.removeClass('dashicons-yes');
						$icon_container.addClass('dashicons-no-alt');
					}

					$loader.removeClass('is-active');
					$this.show();
				}
			}
		});
	});

	/**
  * Ajax call to clear Give's cache.
  */
	$('#give-clear-cache').on('click', function () {
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				action: 'give_cache_flush'
			}
		}).done(function (response) {
			if (response.success) {
				new Give.modal.GiveSuccessAlert({
					modalContent: {
						title: Give.fn.getGlobalVar('flush_success'),
						desc: response.data.message,
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
			} else {
				new Give.modal.GiveErrorAlert({
					modalContent: {
						title: Give.fn.getGlobalVar('flush_error'),
						desc: response.data.message,
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
			}
		});
	});
});

/***/ }),
/* 37 */
/***/ (function(module, exports) {

/*!
 * Give Admin Export JS
 *
 * @description: The Give Admin Settings scripts. Only enqueued on the give-settings and give-tools page; used for exporting CSV
 * @package:     Give
 * @since:       2.1
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */
/* globals Give, jQuery */
jQuery(document).ready(function ($) {

	/**
  * Update Export Donation Form
  *
  * @since 2.1
  */
	function give_export_update_donation_form() {

		var $form = $('form#give-export_donations-form'),
		    $container = $($form).find('tr.give-export-donation-form .give-select-chosen'),
		    select = $container.prev(),
		    $search_field = $container.find('input[type="text"]'),
		    variations = $container.hasClass('variations'),
		    response = '';

		$('.give-export-donations-hide').addClass('give-hidden');
		$('li.give-export-donation-checkbox-remove').remove();

		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'give_form_search',
				s: '',
				fields: $($form).serialize()
			},
			beforeSend: function beforeSend() {
				select.closest('ul.chosen-results').empty();
			},
			success: function success(data) {

				// Remove all options but those that are selected.
				$('option', select).remove();
				var form_ids = [];

				if (data.length) {

					$form.find('.give-export-donation-button').prop('disabled', false);
					$.each(data, function (key, item) {
						select.prepend('<option value="' + item.id + '">' + item.name + '</option>');
						form_ids.push(item.id);
					});

					select.prepend('<option value="0" selected>' + select.data('placeholder') + '</option>');
				} else {
					// Trigger no result message event.
					select.prepend('<option value="0">' + select.data('no-form') + '</option>');

					$form.find('.give-export-donation-button').prop('disabled', true);
				}

				$form.find('.form_ids').val(form_ids.join());

				// Trigger update event.
				$container.prev('select.give-select-chosen').trigger('chosen:updated');

				output_give_donations_fields(response);
			}
		});
	}

	/**
  * Update export Donation Form when cat or tag are change
  *
  * @since 2.1
  */
	$('.give-export_donations #give-export_donations-form .give_forms_categories , .give-export_donations #give-export_donations-form .give_forms_tags').change(function () {
		give_export_update_donation_form();
	});

	/**
  * Ajax call to get donation fields.
  */
	$('.give-export_donations #give-export_donations-form #give_payment_form_select').change(function () {

		$('.give-export-donations-hide').addClass('give-hidden');

		$('li.give-export-donation-checkbox-remove').remove();

		jQuery(document).trigger('give_export_donations_form_change');

		var give_form_id;

		// Check for form ID.
		if (!(give_form_id = $(this).val())) {
			return false;
		}

		// Ajax.
		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				form_id: give_form_id,
				action: 'give_export_donations_get_custom_fields'
			},
			success: function success(response) {
				if (response) {
					output_give_donations_fields(response);
				} else {
					alert(Give.fn.getGlobalVar('error_message'));
				}

				jQuery(document).trigger('give_export_donations_form_response', response);
			}
		});
	});

	/**
  * Outputs the custom field checkboxes.
  *
  * @param response
  */
	function output_give_donations_fields(response) {

		/**
   * Standard Fields
   */
		var standard_fields = 'undefined' !== typeof response.standard_fields && null !== response.standard_fields ? response.standard_fields : '';
		var standard_field_list = $('.give-export-donations-standard-fields ul');
		if (standard_fields.length > 0) {
			standard_field_list.closest('tr').removeClass('give-hidden');
			// Loop through STANDARD fields & output
			$(standard_fields).each(function (index, value) {
				standard_field_list.append('<li class="give-export-donation-checkbox-remove"><label for="give-give-donations-standard-field-' + value + '"><input type="checkbox" name="give_give_donations_export_option[' + value + ']" id="give-give-donations-standard-field-' + value + '">' + value + '</label> </li>');
			});
		}

		/**
   * Hidden Fields
   */
		var hidden_fields = 'undefined' !== typeof response.hidden_fields && null !== response.hidden_fields ? response.hidden_fields : '';
		var hidden_field_list = $('.give-export-donations-hidden-fields ul');

		if (hidden_fields) {
			hidden_field_list.closest('tr').removeClass('give-hidden');

			// Loop through HIDDEN fields & output.
			$(hidden_fields).each(function (index, value) {
				hidden_field_list.append('<li class="give-export-donation-checkbox-remove"><label for="give-give-donations-hidden-field-' + value + '"><input type="checkbox" name="give_give_donations_export_option[' + value + ']" id="give-give-donations-hidden-field-' + value + '">' + value + '</label> </li>');
			});
		}
	}
});

/***/ }),
/* 38 */
/***/ (function(module, exports) {

/*!
 * Give Admin Widgets JS
 *
 * @description: The Give Admin Widget scripts. Only enqueued on the admin widgets screen; used to validate fields, show/hide, and other functions
 * @package:     Give
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

(function ($) {

	/**
  * Show/Hide continue button tile setting on basis of display setting for Give Form widget.
  */
	var continue_button_setting_js = function continue_button_setting_js() {
		$('.widget-liquid-right').on('change', '.give_forms_display_style_setting_row input', function () {
			var $parent = $(this).parents('p'),
			    $continue_button_title = $parent.next();

			if ('onpage' === $('input:checked', $parent).val()) {
				$continue_button_title.hide();
			} else {
				$continue_button_title.show();
			}
		});
	};

	//On DOM Ready
	$(function () {
		continue_button_setting_js();
		$('.give_forms_display_style_setting_row input', '.widget-liquid-right').trigger('change');
	});

	//Function to Refresh jQuery toggles for Yelp Widget Pro upon saving specific widget
	$(document).ajaxSuccess(function (e, xhr, settings) {
		continue_button_setting_js();
		$('.give_forms_display_style_setting_row input', '.widget-liquid-right').trigger('change');
	});
})(jQuery);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_modal__ = __webpack_require__(10);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Give Admin JS
 *
 * @package:     Give
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */
/* globals Give, jQuery */


// Provided access to global level.
var give_setting_edit = false;

(function ($) {
	/**
  * Show/Hide ajax loader.
  *
  * @since 2.0
  *
  * @param $parent
  * @param args
  */
	var giveAjaxLoader = function giveAjaxLoader($parent, args) {
		args = jQuery.extend({
			wrapper: true,
			show: false
		}, args);

		var $loaderParent = args.wrapper ? $('.give-spinner-wrapper', $parent) : {},
		    $loader = $('.give-spinner', $parent);

		// Show loader.
		if (args.show) {
			if ($loaderParent.length) {
				$loaderParent.addClass('is-active');
			}

			$loader.addClass('is-active');
			return;
		}

		// Hide loader.
		if ($loaderParent.length) {
			$loaderParent.removeClass('is-active');
		}

		$loader.removeClass('is-active');
	};

	/**
  * Onclick remove give-message parameter from url
  *
  * @since 1.8.14
  */
	var give_dismiss_notice = function give_dismiss_notice() {
		$('body').on('click', 'button.notice-dismiss', function () {
			if ('give-invalid-license' !== jQuery(this).closest('div.give-notice').data('notice-id')) {
				give_remove_give_message(jQuery(this).closest('div.give-notice').attr('id'));
			}
		});
	};

	/**
  * Remove give-message parameter from URL.
  *
  * @since 1.8.14
  * @since 2.1.4 Added new param key which remove the multiple message array from URL.
  *
  * @param key string to remove from url in multiple notices.
  */
	var give_remove_give_message = function give_remove_give_message(key) {
		var parameter = 'give-message',
		    url = document.location.href,
		    urlparts = url.split('?'),
		    key = undefined === key ? '' : key.replace('give-', '');

		if (urlparts.length >= 2) {
			var urlBase = urlparts.shift();
			var queryString = urlparts.join('?');
			var prefix = encodeURIComponent(parameter) + '=';

			var pars = queryString.split(/[&;]/g);
			for (var i = pars.length; i-- > 0;) {

				if (pars[i].lastIndexOf(prefix, 0) !== -1 || '' !== key && pars[i].lastIndexOf('give-messages', 0) !== -1 && pars[i].match(key + '$')) {
					pars.splice(i, 1);
				}
			}
			url = urlBase + '?' + pars.join('&');
			window.history.pushState('', document.title, url); // added this line to push the new url directly to url bar .
		}
		return url;
	};

	/**
  * Setup Admin Datepicker
  * @since: 1.0
  */
	var enable_admin_datepicker = function enable_admin_datepicker() {
		var datepicker = $('.give_datepicker');

		// Date picker.
		if (datepicker.length > 0) {
			datepicker.datepicker({
				dateFormat: Give.fn.getGlobalVar('date_format')
			});
		}
	};

	/**
  * Setup Pretty Chosen Select Fields
  */
	var setup_chosen_give_selects = function setup_chosen_give_selects() {

		// Setup Chosen Selects.
		var $give_chosen_containers = $('.give-select-chosen');

		if ($give_chosen_containers.hasClass('give-chosen-settings')) {

			// Do something to chosen used in metabox or admin settings.
			$give_chosen_containers.chosen({
				no_results_text: Give.fn.getGlobalVar('chosen_add_title_prefix') + ' ',
				width: '30%'
			}).on('chosen:no_results', function (evt, data) {

				$(data.chosen.container).on('keydown', function (event) {

					var chosenText = data.chosen.get_search_text();

					if (13 === event.keyCode && !jQuery(data.chosen.form_field).find('option[value="' + chosenText + '"]').length) {
						$(data.chosen.form_field).append('<option value="' + chosenText + '" selected>' + chosenText + '</option>').trigger('chosen:updated');
						data.chosen.result_highlight = data.chosen.search_results.find('li.active-result').lasteturn;
						data.chosen.result_select(evt);
					}
				});
			});
		} else {

			// Add loader with each input field.
			$give_chosen_containers.on('chosen:ready', function () {
				$(this).next('.chosen-container').find('input.chosen-search-input').after('<span class="spinner"></span>');
			});

			// Initiate chosen.
			$give_chosen_containers.chosen({
				inherit_select_classes: true,
				placeholder_text_single: Give.fn.getGlobalVar('one_option'),
				placeholder_text_multiple: Give.fn.getGlobalVar('one_or_more_option')
			});

			// No results returned from search trigger.
			$give_chosen_containers.on('chosen:no_results', function () {
				var $container = $(this).next('.chosen-container'),
				    $no_results_li = $container.find('li.no-results'),
				    error_string = '';

				if ($container.hasClass('give-select-chosen-ajax') && $no_results_li.length) {
					error_string = Give.fn.getGlobal.chosen.ajax_search_msg.replace('{search_term}', '"' + $('input', $container).val() + '"');
				} else {
					error_string = Give.fn.getGlobal.chosen.no_results_msg.replace('{search_term}', '"' + $('input', $container).val() + '"');
				}

				$no_results_li.html(error_string);

				// Variables for setting up the typing timer.
				var typingTimer; // Timer identifier.
				var doneTypingInterval = 342; // Time in ms, Slow - 521ms, Moderate - 342ms, Fast - 300ms.

				// Replace options with search results.
				$(document.body).on('keyup', '.give-select.chosen-container .chosen-search input, .give-select.chosen-container .search-field input', function (e) {

					var val = $(this).val(),
					    $container = $(this).closest('.give-select-chosen'),
					    select = $container.prev(),
					    $search_field = $container.find('input[type="text"]'),
					    variations = $container.hasClass('variations'),
					    lastKey = e.which,
					    search_type = 'give_form_search',
					    $this = this;

					// Detect if we have a defined search type, otherwise default to donation forms.
					if ($container.prev().data('search-type')) {

						// Don't trigger AJAX if this select has all options loaded.
						if ('no_ajax' === select.data('search-type')) {
							return;
						}
						search_type = 'give_' + select.data('search-type') + '_search';
					}

					// Don't fire if short or is a modifier key (shift, ctrl, apple command key, or arrow keys).
					if (val.length > 0 && val.length <= 3 || !search_type.length || 9 === lastKey || // Tab.
					13 === lastKey || // Enter.
					16 === lastKey || // Shift.
					17 === lastKey || // Ctrl.
					18 === lastKey || // Alt.
					19 === lastKey || // Pause, Break.
					20 === lastKey || // CapsLock.
					27 === lastKey || // Esc.
					33 === lastKey || // Page Up.
					34 === lastKey || // Page Down.
					35 === lastKey || // End.
					36 === lastKey || // Home.
					37 === lastKey || // Left arrow.
					38 === lastKey || // Up arrow.
					39 === lastKey || // Right arrow.
					40 === lastKey || // Down arrow.
					44 === lastKey || // PrntScrn.
					45 === lastKey || // Insert.
					144 === lastKey || // NumLock.
					145 === lastKey || // ScrollLock.
					91 === lastKey || // WIN Key (Start).
					93 === lastKey || // WIN Menu.
					224 === lastKey || // Command key.
					112 <= lastKey && 123 >= lastKey // F1 to F12 lastKey.
					) {
						return;
					}

					clearTimeout(typingTimer);
					$container.addClass('give-select-chosen-ajax');

					typingTimer = setTimeout(function () {
						$.ajax({
							type: 'POST',
							url: ajaxurl,
							data: {
								action: search_type,
								s: val,
								fields: $($this).closest('form').serialize()
							},
							dataType: 'json',
							beforeSend: function beforeSend() {
								select.closest('ul.chosen-results').empty();
								$search_field.prop('disabled', true);
							},
							success: function success(data) {

								$container.removeClass('give-select-chosen-ajax');

								// Remove all options but those that are selected.
								$('option:not(:selected)', select).remove();

								if (data.length) {
									$.each(data, function (key, item) {
										// Add any option that doesn't already exist.
										if (!$('option[value="' + item.id + '"]', select).length) {
											if (0 === val.length) {
												select.append('<option value="' + item.id + '">' + item.name + '</option>');
											} else {
												select.prepend('<option value="' + item.id + '">' + item.name + '</option>');
											}
										}
									});

									// Trigger update event.
									$container.prev('select.give-select-chosen').trigger('chosen:updated');
								} else {

									// Trigger no result message event.
									$container.prev('select.give-select-chosen').trigger('chosen:no_results');
								}

								// Ensure the original query is retained within the search input.
								$search_field.prop('disabled', false);
								$search_field.val(val).focus();
							}
						}).fail(function (response) {
							if (window.console && window.console.log) {
								console.log(response);
							}
						}).done(function (response) {
							$search_field.prop('disabled', false);
						});
					}, doneTypingInterval);
				});

				$('.give-select-chosen .chosen-search input').each(function () {
					var type = $(this).parent().parent().parent().prev('select.give-select-chosen').data('search-type');
					var placeholder = '';

					if ('form' === type) {
						placeholder = Give.fn.getGlobalVar('search_placeholder');
					} else {
						type = 'search_placeholder_' + type;
						if (Give.fn.getGlobalVar(type)) {
							placeholder = Give.fn.getGlobalVar(type);
						}
					}
					$(this).attr('placeholder', placeholder);
				});
			});
		}

		// Fix: Chosen JS - Zero Width Issue.
		// @see https://github.com/harvesthq/chosen/issues/472#issuecomment-344414059
		$('.chosen-container').each(function () {
			if (0 === $(this).width()) {
				$(this).css('width', '100%');
			}
		});

		// This fixes the Chosen box being 0px wide when the thickbox is opened.
		$('#post').on('click', '.give-thickbox', function () {
			$('.give-select-chosen', '#choose-give-form').css('width', '100%');
		});
	};

	/**
  * Unformat Currency
  *
  * @param   {string}      price Price
  * @param   {number|bool} dp    Number of decimals
  *
  * @returns {string}
  */
	function give_unformat_currency(price, dp) {
		price = accounting.unformat(price, Give.fn.getGlobalVar('decimal_separator')).toString();
		dp = 'undefined' === dp ? false : dp;

		// Set default value for number of decimals.
		if (false !== dp) {
			price = parseFloat(price).toFixed(dp);
		} else {

			// If price do not have decimal value then set default number of decimals.
			price = parseFloat(price).toFixed(Give.fn.getGlobalVar('currency_decimals'));
		}

		return price;
	}

	/**
  * List donation screen JS
  */

	var GiveListDonation = {

		init: function init() {
			this.deleteSingleDonation();
			this.resendSingleDonationReceipt();
		},

		deleteSingleDonation: function deleteSingleDonation() {
			new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
				triggerSelector: '.delete-single-donation',
				modalWrapper: 'give-modal--warning',
				modalContent: {
					title: Give.fn.getGlobalVar('confirm_delete_donation'),
					desc: Give.fn.getGlobalVar('delete_payment')
				},
				successConfirm: function successConfirm(args) {
					window.location.assign(args.el.attr('href'));
				}
			});
		},

		resendSingleDonationReceipt: function resendSingleDonationReceipt() {
			new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
				triggerSelector: '.resend-single-donation-receipt',
				modalContent: {
					title: Give.fn.getGlobalVar('confirm_resend'),
					desc: Give.fn.getGlobalVar('resend_receipt')
				},
				successConfirm: function successConfirm(args) {
					window.location.assign(args.el.attr('href'));
				}
			});
		}
	};

	/**
  * Edit donation screen JS
  */
	var Give_Edit_Donation = {

		init: function init() {
			this.edit_address();
			this.add_note();
			this.remove_note();
			this.new_donor();
			this.resend_receipt();
			this.variable_price_list();
		},

		edit_address: function edit_address() {

			// Update base state field based on selected base country.
			$('select[name="give-payment-address[0][country]"]').change(function () {
				var $this = $(this);

				data = {
					action: 'give_get_states',
					country: $this.val(),
					field_name: 'give-payment-address[0][state]'
				};
				$.post(ajaxurl, data, function (response) {

					// Show the states dropdown menu.
					$this.closest('.column-container').find('#give-order-address-state-wrap').removeClass('give-hidden');

					// Add support to zip fields.
					$this.closest('.column-container').find('.give-column').removeClass('column-full');
					$this.closest('.column-container').find('.give-column').addClass('column');

					var state_wrap = $('#give-order-address-state-wrap');
					state_wrap.find('*').not('.order-data-address-line').remove();
					if (_typeof(response.states_found) !== undefined && true === response.states_found) {
						state_wrap.append(response.data);
						state_wrap.find('select').chosen();
					} else {
						state_wrap.append('<input type="text" name="give-payment-address[0][state]" value="' + response.default_state + '" class="give-edit-toggles medium-text"/>');

						if (_typeof(response.show_field) !== undefined && false === response.show_field) {
							// Hide the states dropdown menu.
							$this.closest('.column-container').find('#give-order-address-state-wrap').addClass('give-hidden');

							// Add support to zip fields.
							$this.closest('.column-container').find('.give-column').addClass('column-full');
							$this.closest('.column-container').find('.give-column').removeClass('column');
						}
					}
				});

				return false;
			});
		},

		add_note: function add_note() {

			$('#give-add-payment-note').on('click', function (e) {
				e.preventDefault();
				var postData = {
					action: 'give_insert_payment_note',
					payment_id: $(this).data('payment-id'),
					note: $('#give-payment-note').val()
				};

				if (postData.note) {

					$.ajax({
						type: 'POST',
						data: postData,
						url: ajaxurl,
						success: function success(response) {
							$('#give-payment-notes-inner').append(response);
							$('.give-no-payment-notes').hide();
							$('#give-payment-note').val('');
						}
					}).fail(function (data) {
						if (window.console && window.console.log) {
							console.log(data);
						}
					});
				} else {
					var border_color = $('#give-payment-note').css('border-color');
					$('#give-payment-note').css('border-color', 'red');
					setTimeout(function () {
						$('#give-payment-note').css('border-color', border_color);
					}, 500);
				}
			});
		},

		remove_note: function remove_note() {

			$('body').on('click', '.give-delete-payment-note', function (e) {

				e.preventDefault();

				var that = this;

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
					modalContent: {
						title: Give.fn.getGlobalVar('confirm_deletion'),
						desc: Give.fn.getGlobalVar('delete_payment_note')
					},
					successConfirm: function successConfirm(args) {
						var postData = {
							action: 'give_delete_payment_note',
							payment_id: $(that).data('payment-id'),
							note_id: $(that).data('note-id')
						};

						$.ajax({
							type: 'POST',
							data: postData,
							url: ajaxurl,
							success: function success(response) {
								$('#give-payment-note-' + postData.note_id).remove();
								if (!$('.give-payment-note').length) {
									$('.give-no-payment-notes').show();
								}
								return false;
							}
						}).fail(function (data) {
							if (window.console && window.console.log) {
								console.log(data);
							}
						});
					}
				}).render();
			});
		},

		new_donor: function new_donor() {

			$('#give-donor-details').on('click', '.give-payment-new-donor, .give-payment-new-donor-cancel', function (e) {
				e.preventDefault();
				$('.donor-info').toggle();
				$('.new-donor').toggle();

				if ($('.new-donor').is(':visible')) {
					$('#give-new-donor').val(1);
				} else {
					$('#give-new-donor').val(0);
				}
			});
		},

		resend_receipt: function resend_receipt() {
			$('body').on('click', '#give-resend-receipt', function (e) {
				var that = this;

				e.preventDefault();

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
					modalContent: {
						title: Give.fn.getGlobalVar('confirm_action'),
						desc: Give.fn.getGlobalVar('resend_receipt')
					},
					successConfirm: function successConfirm() {
						window.location.assign($(that).attr('href'));

						return;
					}
				}).render();
			});
		},

		variable_price_list: function variable_price_list() {
			// Update variable price list when form changes.
			$('#give_payment_form_select').chosen().change(function () {
				var give_form_id,
				    variable_prices_html_container = $('.give-donation-level');

				// Check for form ID.
				if (!(give_form_id = $(this).val())) {
					return false;
				}

				// Bailout.
				if (!variable_prices_html_container.length) {
					return false;
				}

				// Ajax.
				$.ajax({
					type: 'POST',
					url: ajaxurl,
					data: {
						form_id: give_form_id,
						payment_id: $('input[name="give_payment_id"]').val(),
						action: 'give_check_for_form_price_variations_html'
					},
					success: function success(response) {
						response = response.trim();
						if (response) {

							// Update Variable price html.
							variable_prices_html_container.html(response);

							// Add chosen feature to select tag.
							$('select[name="give-variable-price"]').chosen().change();
						} else {
							// Update Variable price html.
							variable_prices_html_container.html('');
						}
					}
				});
			});

			// Add total donation amount if level changes.
			$('#give-donation-overview').on('change', 'select[name="give-variable-price"]', function () {
				var prices = jQuery(this).data('prices'),
				    $total_amount = $('#give-payment-total');

				if ('' !== prices && $(this).val() in prices) {

					$total_amount.val(prices[$(this).val()]).css('background-color', 'yellow');

					window.setTimeout(function () {
						$total_amount.css('background-color', 'white');
					}, 1000);
				}
			});
		}

	};

	/**
  * Settings screen JS
  */
	var Give_Settings = {

		init: function init() {
			this.toggle_gateways();
			this.setting_change_country();
			this.toggle_options();
			this.main_setting_update_notice();
			this.verify_settings();
			this.saveButtonTriggered();
			this.changeAlert();
			this.detectSettingsChange();
			this.sequentialDonationIDPreview();
		},

		/**
   * Disables the default gateway radio button if the
   * gateway is disabled.
   */
		toggle_gateways: function toggle_gateways() {
			var checkbox = $('.gateways-checkbox');

			checkbox.on('click', function () {

				// Get the radio button object related to this checkbox.
				var radio = $(this).prev('.gateways-radio');

				// Get the checked value of the current checbox.
				var checked = this.checked;

				// Get all the checkbox that are checked.
				var checked_cbs = $('.gateways-checkbox:checked');

				// Get the count of all the checked checkbox.
				var count_cbs = checked_cbs.length;

				/**
     * If there is only one checked checkbox, then
     * make that gateway the default gateway.
     */
				if (1 === count_cbs) {
					checked_cbs.prev('.gateways-radio').attr('checked', 'checked');

					if (this.checked) {
						radio.removeAttr('disabled');
					} else {
						radio.attr('disabled', 'disabled');
					}
				} else {
					if (this.checked) {
						radio.removeAttr('disabled');
						radio.removeAttr('checked');
					} else {
						radio.attr('disabled', 'disabled');
					}
				}
			});
		},

		/**
   * Fire when user change the country from the dropdown
   *
   * @since 1.8.14
   */
		setting_change_country: function setting_change_country() {
			$('select[name="base_country"]').change(function () {
				var $this = $(this);
				var data = {
					action: 'give_get_states',
					country: $this.val(),
					field_name: 'base_state'
				};

				$.post(ajaxurl, data, function (response) {
					// Show the states dropdown menu.
					$this.closest('tr').next().show();
					$('#base_state_chosen').remove();
					if (_typeof(response.states_found) != undefined && true == response.states_found) {
						$(':input[name="base_state"]').replaceWith(response.data).addClass('give-select-chosen');
						$(':input[name="base_state"]').chosen();
					} else {
						if (_typeof(response.show_field) != undefined && false == response.show_field) {
							// Hide the states dropdown menu.
							$this.closest('tr').next().hide();
						}
						$(':input[name="base_state"]').replaceWith('<input type="text" name="' + data.field_name + '" value="' + response.default_state + '" class="give-edit-toggles medium-text"/>');
					}
				});
				return false;
			});
		},

		toggle_options: function toggle_options() {

			/**
    * Email access
    */
			var emailAccess = $('input[name="email_access"]', '.give-setting-tab-body-general');
			emailAccess.on('change', function () {
				var fieldValueEmail = $('input[name="email_access"]:checked', '.give-setting-tab-body-general').val();
				var fieldValueRecaptcha = $('input[name="enable_recaptcha"]:checked', '.give-setting-tab-body-general').val();
				if ('enabled' === fieldValueEmail) {
					$('input[name="enable_recaptcha"]').parents('tr').show();

					if ('enabled' === fieldValueRecaptcha) {
						$('#recaptcha_key').parents('tr').show();
						$('#recaptcha_secret').parents('tr').show();
					} else {
						$('#recaptcha_key').parents('tr').hide();
						$('#recaptcha_secret').parents('tr').hide();
					}
				} else {
					$('#recaptcha_key').parents('tr').hide();
					$('#recaptcha_secret').parents('tr').hide();
					$('input[name="enable_recaptcha"]').parents('tr').hide();
				}
			}).change();

			/**
    * Email reCAPTCHA
    */
			var recaptcha = $('input[name="enable_recaptcha"]', '.give-setting-tab-body-general');
			recaptcha.on('change', function () {
				var fieldValueEmail = $('input[name="email_access"]:checked', '.give-setting-tab-body-general').val();
				var fieldValueRecaptcha = $('input[name="enable_recaptcha"]:checked', '.give-setting-tab-body-general').val();

				if ('enabled' === fieldValueEmail && 'enabled' === fieldValueRecaptcha) {
					$('#recaptcha_key').parents('tr').show();
					$('#recaptcha_secret').parents('tr').show();
				} else {
					$('#recaptcha_key').parents('tr').hide();
					$('#recaptcha_secret').parents('tr').hide();
				}
			}).change();

			/**
    * Form featured image
    */
			var form_featured_image = $('input[name="form_featured_img"]', '.give-setting-tab-body-display');
			form_featured_image.on('change', function () {
				var field_value = $('input[name="form_featured_img"]:checked', '.give-setting-tab-body-display').val();
				if ('enabled' === field_value) {
					$('#featured_image_size').parents('tr').show();
				} else {
					$('#featured_image_size').parents('tr').hide();
				}
			}).change();

			/**
    * Terms and Conditions
    */
			var terms_and_conditions = $('input[name="terms"]', '.give-setting-tab-body-display');
			terms_and_conditions.on('change', function () {
				var field_value = $('input[name="terms"]:checked', '.give-setting-tab-body-display').val();
				if ('enabled' === field_value) {
					$('#agree_to_terms_label').parents('tr').show();
					$('#wp-agreement_text-wrap').parents('tr').show();
				} else {
					$('#agree_to_terms_label').parents('tr').hide();
					$('#wp-agreement_text-wrap').parents('tr').hide();
				}
			}).change();

			/**
    * Disable admin notification
    */
			var admin_notification = $('input[name="admin_notices"]', '.give-setting-tab-body-emails');
			admin_notification.on('change', function () {
				var field_value = $('input[name="admin_notices"]:checked', '.give-setting-tab-body-emails').val();
				if ('enabled' === field_value) {
					$('#donation_notification_subject').parents('tr').show();
					$('#wp-donation_notification-wrap').parents('tr').show();
					$('#admin_notice_emails').parents('tr').show();
				} else {
					$('#donation_notification_subject').parents('tr').hide();
					$('#wp-donation_notification-wrap').parents('tr').hide();
					$('#admin_notice_emails').parents('tr').hide();
				}
			}).change();

			/**
    * Toggle sequential ordering settings
    */
			var sequential_ordering = $('input[name="sequential-ordering_status"]', '.give-setting-tab-body-general');
			sequential_ordering.on('change', function () {
				var field_value = $('input[name="sequential-ordering_status"]:checked', '.give-setting-tab-body-general').val(),
				    $parent = $(this).closest('table');
				if ('enabled' === field_value) {
					$('input', $parent).not('input[name="sequential-ordering_status"]').parents('tr').show();
				} else {
					$('input', $parent).not('input[name="sequential-ordering_status"]').parents('tr').hide();
				}
			}).change();
		},

		main_setting_update_notice: function main_setting_update_notice() {
			var $setting_message = $('#setting-error-give-setting-updated');
			if ($setting_message.length) {

				// auto hide setting message in 5 seconds.
				window.setTimeout(function () {
					$setting_message.slideUp();
				}, 5000);
			}
		},

		verify_settings: function verify_settings() {
			var success_setting = $('#success_page');
			var failure_setting = $('#failure_page');

			/**
    * Verify success and failure page.
    */
			success_setting.add(failure_setting).change(function () {
				if (success_setting.val() === failure_setting.val()) {
					var notice_html = '<div id="setting-error-give-matched-success-failure-page" class="updated settings-error notice is-dismissible"> <p><strong>' + Give.fn.getGlobalVar('matched_success_failure_page') + '</strong></p> <button type="button" class="notice-dismiss"><span class="screen-reader-text">' + Give.fn.getGlobalVar('dismiss_notice_text') + '</span></button> </div>',
					    $notice_container = $('#setting-error-give-matched-success-failure-page');

					// Unset setting field.
					$(this).val('');

					// Bailout.
					if ($notice_container.length) {
						return false;
					}

					// Add html.
					$('h1', '#give-mainform').after(notice_html);
					$notice_container = $('#setting-error-give-matched-success-failure-page');

					// Add event to  dismiss button.
					$('.notice-dismiss', $notice_container).click(function () {
						$notice_container.remove();
					});
				}
			}).change();
		},

		saveButtonTriggered: function saveButtonTriggered() {
			$('.give-settings-setting-page').on('click', '.give-save-button', function () {
				$(window).unbind('beforeunload');
			});
		},

		/**
   * Show alert when admin try to reload the page with saving the changes.
   *
   * @since 1.8.14
   */
		changeAlert: function changeAlert() {

			$(window).bind('beforeunload', function (e) {

				var confirmationMessage = Give.fn.getGlobalVar('setting_not_save_message');

				if (give_setting_edit) {
					(e || window.event).returnValue = confirmationMessage; //Gecko + IE.
					return confirmationMessage; //Webkit, Safari, Chrome.
				}
			});
		},

		/**
   * Display alert in setting page of give if user try to reload the page with saving the changes.
   *
   * @since 1.8.14
   */
		detectSettingsChange: function detectSettingsChange() {

			var settingsPage = $('.give-settings-setting-page');

			// Check if it give setting page or not.
			if (settingsPage.length > 0) {

				// Get the default value.
				var on_load_value = $('#give-mainform').serialize();

				/**
     * Keyup event add to support to text box and textarea.
     * blur event add to support to dropdown.
     * Change event add to support to rest all element.
     */
				settingsPage.on('change keyup blur', 'form', function () {
					// Get the form value after change.
					var on_change_value = $('#give-mainform').serialize();

					// If both the value are same then no change has being made else change has being made.
					give_setting_edit = on_load_value !== on_change_value ? true : false;
				});
			}
		},

		/**
   * Render donation id for sequential ordering.
   *
   * @since 2.1.0
   */
		sequentialDonationIDPreview: function sequentialDonationIDPreview() {
			var $previewField = jQuery('#sequential-ordering_preview');

			// Bailout.
			if (!$previewField.length) {
				return;
			}

			jQuery('#sequential-ordering_number_prefix, #sequential-ordering_number, #sequential-ordering_number_padding, #sequential-ordering_number_suffix').on('keyup change', function () {
				var prefix = jQuery('#sequential-ordering_number_prefix').val(),
				    startingNumber = jQuery('#sequential-ordering_number').val().trim() || '1',
				    numberPadding = jQuery('#sequential-ordering_number_padding').val().trim(),
				    suffix = jQuery('#sequential-ordering_number_suffix').val(),
				    $donationID = '' + prefix + startingNumber.padStart(numberPadding, '0') + suffix;

				$previewField.val($donationID);
			});

			jQuery('#sequential-ordering_number_prefix').trigger('keyup');

			jQuery('#sequential-ordering_number_prefix, #sequential-ordering_number_suffix').on('blur', function () {
				$(this).val($(this).val().replace(new RegExp(' ', 'g'), '-'));
			});
		}
	};

	/**
  * Reports / Exports / Tools screen JS
  */
	var Give_Reports = {

		init: function init() {
			this.date_options();
			this.donors_export();
			this.recount_stats();
		},

		date_options: function date_options() {

			// Show hide extended date options.
			$('#give-graphs-date-options').change(function () {
				var $this = $(this);
				if ('other' === $this.val()) {
					$('#give-date-range-options').show();
				} else {
					$('#give-date-range-options').hide();
				}
			});
		},

		donors_export: function donors_export() {

			// Show / hide Donation Form option when exporting donors.
			$('#give_donor_export_form').change(function () {

				var $this = $(this),
				    form_id = $('option:selected', $this).val(),
				    customer_export_option = $('#give_customer_export_option');

				if ('0' === $this.val()) {
					customer_export_option.show();
				} else {
					customer_export_option.hide();
				}

				var price_options_select = $('.give_price_options_select');

				// On Form Select, Check if Variable Prices Exist.
				if (parseInt(form_id) != 0) {
					var data = {
						action: 'give_check_for_form_price_variations',
						form_id: form_id,
						all_prices: true
					};

					$.post(ajaxurl, data, function (response) {
						price_options_select.remove();
						$('#give_donor_export_form_chosen').after(response);
					});
				} else {
					price_options_select.remove();
				}
			});
		},

		recount_stats: function recount_stats() {

			$('body').on('change', '#recount-stats-type', function () {

				var export_form = $('#give-tools-recount-form');
				var selected_type = $('option:selected', this).data('type');
				var submit_button = $('#recount-stats-submit');
				var forms = $('.tools-form-dropdown');

				// Reset the form
				export_form.find('.notice-wrap').remove();
				submit_button.removeClass('button-disabled').attr('disabled', false);
				forms.hide();
				$('.give-recount-stats-descriptions span').hide();

				if ('reset-stats' === selected_type) {
					export_form.append('<div class="notice-wrap"></div>');
					var notice_wrap = export_form.find('.notice-wrap');
					notice_wrap.html('<div class="notice notice-warning"><p><input type="checkbox" id="confirm-reset" name="confirm_reset_store" value="1" /> <label for="confirm-reset">' + Give.fn.getGlobalVar('reset_stats_warn') + '</label></p></div>');
					submit_button.addClass('button-disabled').attr('disabled', 'disabled');

					// Add check when admin try to delete all the test donors.
				} else if ('delete-test-donors' === selected_type) {
					export_form.append('<div class="notice-wrap"></div>');
					var notice_wrap = export_form.find('.notice-wrap');
					notice_wrap.html('<div class="notice notice-warning"><p><input type="checkbox" id="confirm-reset" name="confirm_reset_store" value="1" /> <label for="confirm-reset">' + Give.fn.getGlobalVar('delete_test_donor') + '</label></p></div>');
					submit_button.addClass('button-disabled').attr('disabled', 'disabled');
					// Add check when admin try to delete all the imported donations.
				} else if ('delete-import-donors' === selected_type) {

					export_form.append('<div class="notice-wrap"></div>');
					var notice_wrap = export_form.find('.notice-wrap');
					notice_wrap.html('<div class="notice notice-warning"><p><input type="checkbox" id="confirm-reset" name="confirm_reset_store" value="1" /> <label for="confirm-reset">' + Give.fn.getGlobalVar('delete_import_donor') + '</label></p></div>');
					submit_button.addClass('button-disabled').attr('disabled', 'disabled');
				} else {
					forms.hide();
					forms.val(0);
				}

				var current_forms = $('.tools-form-dropdown-' + selected_type);
				current_forms.show();
				current_forms.find('.give-select-chosen').css({
					'width': 'auto',
					'min-width': '250px'
				});
				$('#' + selected_type).show();
			});

			$('body').on('change', '#confirm-reset', function () {
				var checked = $(this).is(':checked');
				if (checked) {
					$('#recount-stats-submit').removeClass('button-disabled').removeAttr('disabled');
				} else {
					$('#recount-stats-submit').addClass('button-disabled').attr('disabled', 'disabled');
				}
			});

			$('#give-tools-recount-form').submit(function (e) {
				var selection = $('#recount-stats-type').val();
				var export_form = $(this);
				var selected_type = $('option:selected', this).data('type');

				if ('reset-stats' === selected_type) {
					var is_confirmed = $('#confirm-reset').is(':checked');
					if (is_confirmed) {
						return true;
					} else {
						has_errors = true;
					}
				}

				export_form.find('.notice-wrap').remove();

				export_form.append('<div class="notice-wrap"></div>');
				var notice_wrap = export_form.find('.notice-wrap');
				var has_errors = false;

				if (null === selection || 0 === selection) {
					// Needs to pick a method give_vars.batch_export_no_class.
					notice_wrap.html('<div class="updated error"><p>' + Give.fn.getGlobalVar('batch_export_no_class') + '</p></div>');
					has_errors = true;
				}

				if ('recount-form' === selected_type) {

					var selected_form = $('select[name="form_id"]').val();
					if (selected_form == 0) {
						// Needs to pick give_vars.batch_export_no_reqs.
						notice_wrap.html('<div class="updated error"><p>' + Give.fn.getGlobalVar('batch_export_no_reqs') + '</p></div>');
						has_errors = true;
					}
				}

				if (has_errors) {
					export_form.find('.button-disabled').removeClass('button-disabled');
					return false;
				}
			});
		}

	};

	/**
  * Export screen JS
  */
	var Give_Export = {

		init: function init() {
			this.submit();
			this.dismiss_message();
		},

		submit: function submit() {

			var self = this;

			$(document.body).on('submit', '.give-export-form', function (e) {
				e.preventDefault();

				var submitButton = $(this).find('input[type="submit"]');

				if (!submitButton.hasClass('button-disabled')) {

					var data = $(this).serialize();

					submitButton.addClass('button-disabled');
					$('form.give-export-form select').attr('disabled', true).trigger('chosen:updated');

					var parent_notices = $(this);

					// show notices inside add-notices class
					if ($(this).find('.add-notices').length > 0) {
						parent_notices = $(this).find('.add-notices');
					}

					parent_notices.find('.notice-wrap').remove();
					parent_notices.append('<div class="notice-wrap give-clearfix"><span class="spinner is-active"></span><div class="give-progress"><div></div></div></div>');

					// start the process
					self.process_step(1, data, self, this);
				}
			});
		},

		process_step: function process_step(step, data, self, form) {
			/**
    * Do not allow user to reload the page
    *
    * @since 1.8.14
    */
			give_setting_edit = true;

			var reset_form = false;

			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {
					form: data,
					action: 'give_do_ajax_export',
					step: step
				},
				dataType: 'json',
				success: function success(response) {

					if ('done' == response.step || response.error || response.success) {

						/**
       * Now allow user to reload the page
       *
       * @since 1.8.14
       */
						give_setting_edit = false;

						reset_form = true;

						// We need to get the actual in progress form, not all forms on the page
						var notice_wrap = $(form).parent().find('.notice-wrap');
						var export_form = notice_wrap.find('.give-progress');

						$(form).find('.button-disabled').removeClass('button-disabled');
						$(form).find('select').attr('disabled', false).trigger('chosen:updated');

						if (response.error) {
							var error_message = response.message;
							notice_wrap.html('<div class="updated error"><p>' + error_message + '</p></div>');
						} else if (response.success) {
							var success_message = response.message;
							notice_wrap.html('<div id="give-batch-success" class="updated notice is-dismissible"><p>' + success_message + '<span class="notice-dismiss"></span></p></div>');
						} else {
							notice_wrap.remove();
							window.location = response.url;
						}
					} else {
						$('.give-progress div').animate({
							width: response.percentage + '%'
						}, 50, function () {
							// Animation complete.
						});
						self.process_step(parseInt(response.step), data, self, form);
					}

					if (true === reset_form && $('#give-tools-recount-form').length > 0) {
						// Reset the form for preventing multiple ajax request.
						$('#give-tools-recount-form')[0].reset();
						$('#give-tools-recount-form .tools-form-dropdown').hide();
						$('#give-tools-recount-form .tools-form-dropdown-recount-form-select').val('0').trigger('chosen:updated');
					}
				}
			}).fail(function (response) {
				/**
     * Now allow user to reload the page
     *
     * @since 1.8.14
     */
				give_setting_edit = false;

				if (window.console && window.console.log) {
					console.log(response);
				}
				$('.notice-wrap').append(response.responseText);
			});
		},

		dismiss_message: function dismiss_message() {
			$('body').on('click', '#give-batch-success .notice-dismiss', function () {
				$('#give-batch-success').parent().slideUp('fast');
			});
		}

	};

	/**
  * Updates screen JS
  */
	var Give_Updates = {
		el: {},

		init: function init() {
			this.submit();
			this.dismiss_message();
		},

		submit: function submit() {
			var $self = this,
			    step = 1,
			    resume_update_step = 0;

			$self.el.main_container = Give_Selector_Cache.get('#give-db-updates');
			$self.el.update_link = Give_Selector_Cache.get('.give-update-now', $self.el.main_container);
			$self.el.run_upload_container = Give_Selector_Cache.get('.give-run-database-update', $self.el.progress_main_container);
			$self.el.progress_main_container = Give_Selector_Cache.get('.progress-container', $self.el.main_container);
			$self.el.heading = Give_Selector_Cache.get('.update-message', $self.el.progress_main_container);
			$self.el.progress_container = Give_Selector_Cache.get('.progress-content', $self.el.progress_main_container);
			$self.el.update_progress_counter = Give_Selector_Cache.get($('.give-update-progress-count'));

			if ($self.el.main_container.data('resume-update')) {
				$self.el.update_link.addClass('active').hide().removeClass('give-hidden');

				if (!$('#give-restart-upgrades').length) {
					// Start update by ajax if background update does not work.
					if (!Give.fn.getGlobalVar('ajax').length) {
						window.setTimeout(Give_Updates.start_db_update, 1000);
					}

					window.setTimeout(Give_Updates.get_db_updates_info, 1000, $self);
				}
			}

			// Bailout.
			if ($self.el.update_link.hasClass('active')) {
				return;
			}

			$self.el.update_link.on('click', '', function (e) {
				e.preventDefault();

				$self.el.run_upload_container.find('.notice').remove();
				$self.el.run_upload_container.append('<div class="notice notice-error non-dismissible give-run-update-containt"><p> <a href="#" class="give-run-update-button button">' + Give.fn.getGlobalVar('db_update_confirmation_msg_button') + '</a> ' + Give.fn.getGlobalVar('db_update_confirmation_msg') + '</p></div>');
			});

			$('#give-db-updates').on('click', 'a.give-run-update-button', function (e) {
				e.preventDefault();

				if ($(this).hasClass('active')) {
					return false;
				}

				$(this).addClass('active').fadeOut();
				$self.el.update_link.addClass('active').fadeOut();
				$('#give-db-updates .give-run-update-containt').slideUp();

				$self.el.progress_container.find('.notice-wrap').remove();
				$self.el.progress_container.append('<div class="notice-wrap give-clearfix"><span class="spinner is-active"></span><div class="give-progress"><div></div></div></div>');
				$self.el.progress_main_container.removeClass('give-hidden');

				Give_Updates.start_db_update();

				window.setTimeout(Give_Updates.get_db_updates_info, 500, $self);

				return false;
			});
		},

		start_db_update: function start_db_update() {
			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {
					action: 'give_run_db_updates',
					run_db_update: 1,
					nonce: Give.fn.getGlobalVar('db_update_nonce')
				},
				dataType: 'json',
				success: function success(response) {}
			}).always(function () {
				// Start update by ajax if background update does not work.
				if (!Give.fn.getGlobalVar('ajax').length) {
					window.setTimeout(Give_Updates.start_db_update, 1000);
				}
			});
		},

		get_db_updates_info: function get_db_updates_info($self) {
			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {
					action: 'give_db_updates_info'
				},
				dataType: 'json',
				success: function success(response) {
					// We need to get the actual in progress form, not all forms on the page.
					var notice_wrap = Give_Selector_Cache.get('.notice-wrap', $self.el.progress_container, true);

					if (-1 !== $.inArray('success', Object.keys(response))) {
						if (response.success) {
							if ($self.el.update_progress_counter.length) {
								$self.el.update_progress_counter.text('100%');
							}

							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading + '</strong>');
							}

							$self.el.update_link.closest('p').remove();
							notice_wrap.html('<div class="notice notice-success is-dismissible"><p>' + response.data.message + '</p><button type="button" class="notice-dismiss"></button></div>');
						} else {
							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading + '</strong>');
							}

							if (response.data.message) {
								$self.el.update_link.closest('p').remove();
								notice_wrap.html('<div class="notice notice-error is-dismissible"><p>' + response.data.message + '</p><button type="button" class="notice-dismiss"></button></div>');
							} else {
								setTimeout(function () {
									$self.el.update_link.removeClass('active').show();
									$self.el.progress_main_container.addClass('give-hidden');
								}, 1000);
							}
						}
					} else {
						if (response && -1 !== $.inArray('percentage', Object.keys(response.data))) {
							if ($self.el.update_progress_counter.length) {
								$self.el.update_progress_counter.text(response.data.total_percentage + '%');
							}

							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading + '</strong>');
							}

							// Update progress.
							$('.give-progress div', '#give-db-updates').animate({
								width: response.data.percentage + '%'
							}, 50, function () {
								// Animation complete.
							});

							window.setTimeout(Give_Updates.get_db_updates_info, 1000, $self);
						} else {
							notice_wrap.html('<div class="notice notice-error"><p>' + Give.fn.getGlobal().updates.ajax_error + '</p></div>');

							setTimeout(function () {
								$self.el.update_link.removeClass('active').show();
								$self.el.progress_main_container.addClass('give-hidden');
							}, 1000);
						}
					}
				}
			});
		},

		process_step: function process_step(step, update, $self) {

			give_setting_edit = true;

			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {
					action: 'give_do_ajax_updates',
					step: parseInt(step),
					update: parseInt(update)
				},
				dataType: 'json',
				success: function success(response) {
					give_setting_edit = false;

					// We need to get the actual in progress form, not all forms on the page.
					var notice_wrap = Give_Selector_Cache.get('.notice-wrap', $self.el.progress_container, true);

					if (-1 !== $.inArray('success', Object.keys(response))) {
						if (response.success) {
							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading + '</strong>');
							}

							$self.el.update_link.closest('p').remove();
							notice_wrap.html('<div class="notice notice-success is-dismissible"><p>' + response.data.message + '</p><button type="button" class="notice-dismiss"></button></div>');
						} else {
							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading + '</strong>');
							}

							notice_wrap.html('<div class="notice notice-error"><p>' + response.data.message + '</p></div>');

							setTimeout(function () {
								$self.el.update_link.removeClass('active').show();
								$self.el.progress_main_container.addClass('give-hidden');
							}, 5000);
						}
					} else {
						if (response && -1 !== $.inArray('percentage', Object.keys(response.data))) {
							// Update progress.
							$('.give-progress div', '#give-db-updates').animate({
								width: response.data.percentage + '%'
							}, 50, function () {
								// Animation complete.
							});

							// Update steps info.
							if (-1 !== $.inArray('heading', Object.keys(response.data))) {
								$self.el.heading.html('<strong>' + response.data.heading.replace('{update_count}', $self.el.heading.data('update-count')) + '</strong>');
							}

							$self.process_step(parseInt(response.data.step), response.data.update, $self);
						} else {
							notice_wrap.html('<div class="notice notice-error"><p>' + Give.fn.getGlobal().updates.ajax_error + '</p></div>');

							setTimeout(function () {
								$self.el.update_link.removeClass('active').show();
								$self.el.progress_main_container.addClass('give-hidden');
							}, 5000);
						}
					}
				}
			}).fail(function (response) {

				give_setting_edit = false;

				if (window.console && window.console.log) {
					console.log(response);
				}

				Give_Selector_Cache.get('.notice-wrap', self.el.progress_container).append(response.responseText);
			}).always(function () {});
		},

		dismiss_message: function dismiss_message() {
			$('body').on('click', '#poststuff .notice-dismiss', function () {
				$(this).parent().slideUp('fast');
			});
		}

	};

	/**
  * Give Upgrader
  */
	var Give_Upgrades = {
		init: function init() {
			this.restartUpgrade();
			this.stopUpgrade();
			this.restartUpdater();
		},

		/**
   * Function to restart the upgrade process.
   */
		restartUpgrade: function restartUpgrade() {
			jQuery('#give-restart-upgrades').click('click', function (e) {

				var that = this;

				e.preventDefault();

				jQuery('.give-doing-update-text-p').show();
				jQuery('.give-update-paused-text-p').hide();

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
					modalContent: {
						title: Give.fn.getGlobalVar('confirm_action'),
						desc: Give.fn.getGlobalVar('restart_upgrade')
					},
					successConfirm: function successConfirm() {
						window.location.assign(jQuery(that).data('redirect-url'));

						return;
					}
				}).render();
			});
		},

		/**
   * Function to pause the upgrade process.
   */
		stopUpgrade: function stopUpgrade() {
			jQuery('#give-pause-upgrades').click('click', function (e) {
				var that = this;

				e.preventDefault();

				jQuery('.give-doing-update-text-p').hide();
				jQuery('.give-update-paused-text-p').show();

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
					modalContent: {
						title: Give.fn.getGlobalVar('confirm_action'),
						desc: Give.fn.getGlobalVar('stop_upgrade')
					},
					successConfirm: function successConfirm() {
						window.location.assign(jQuery(that).data('redirect-url'));

						return;
					}
				}).render();
			});
		},

		/**
   * Function to restart the update process.
   */
		restartUpdater: function restartUpdater() {
			jQuery('.give-restart-updater-btn,.give-run-update-now').click('click', function (e) {

				var that = this;

				e.preventDefault();

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
					modalContent: {
						title: Give.fn.getGlobalVar('confirm_action'),
						desc: Give.fn.getGlobalVar('restart_update')
					},
					successConfirm: function successConfirm() {
						window.location.assign(jQuery(that).attr('href'));

						return;
					}
				}).render();
			});
		}
	};

	/**
  * Admin Status Select Field Change
  *
  * @description: Handle status switching
  * @since: 1.0
  */
	var handle_status_change = function handle_status_change() {

		$('select[name="give-payment-status"]').on('change', function () {

			var status = $(this).val();

			$('.give-donation-status').removeClass(function (index, css) {
				return (css.match(/\bstatus-\S+/g) || []).join(' ');
			}).addClass('status-' + status);
		});
	};

	/**
  * Donor management screen JS
  */
	var GiveDonor = {
		onLoadPageNumber: '',

		init: function init() {
			this.unlockDonorFields();
			this.editDonor();
			this.add_email();
			this.removeUser();
			this.cancelEdit();
			this.add_note();
			this.delete_checked();
			this.addressesAction();
			this.bulkDeleteDonor();
			GiveDonor.onLoadPageNumber = $('#current-page-selector').val();
			$('body').on('click', '#give-donors-filter .bulkactions input[type="submit"]', this.handleBulkActions);
		},

		unlockDonorFields: function unlockDonorFields(e) {
			$('body').on('click', '.give-lock-block', function (e) {
				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveErrorAlert"]({
					modalContent: {
						title: Give.fn.getGlobalVar('unlock_donor_fields_title'),
						desc: Give.fn.getGlobalVar('unlock_donor_fields_message'),
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
				e.preventDefault();
			});
		},

		editDonor: function editDonor() {
			$('body').on('click', '#edit-donor', function (e) {
				e.preventDefault();
				$('#give-donor-card-wrapper .editable').hide();
				$('#give-donor-card-wrapper .edit-item').fadeIn().css('display', 'block');
			});
		},

		removeUser: function removeUser() {
			$('body').on('click', '#disconnect-donor', function (e) {
				e.preventDefault();

				if (!confirm(Give.fn.getGlobalVar('disconnect_user'))) {
					return false;
				}

				var donorID = $('input[name="donor_info[id]"]').val();

				var postData = {
					give_action: 'disconnect-userid',
					customer_id: donorID,
					_wpnonce: $('#edit-donor-info #_wpnonce').val()
				};

				$.post(ajaxurl, postData, function (response) {
					window.location.href = response.redirect;
				}, 'json');
			});
		},

		cancelEdit: function cancelEdit() {
			$('body').on('click', '#give-edit-donor-cancel', function (e) {
				e.preventDefault();
				$('#give-donor-card-wrapper .edit-item').hide();
				$('#give-donor-card-wrapper .editable').show();
				$('.give_user_search_results').html('');
			});
		},

		add_note: function add_note() {
			$('body').on('click', '#add-donor-note', function (e) {
				e.preventDefault();
				var postData = {
					give_action: 'add-donor-note',
					customer_id: $('#donor-id').val(),
					donor_note: $('#donor-note').val(),
					add_donor_note_nonce: $('#add_donor_note_nonce').val()
				};

				if (postData.donor_note) {

					$.ajax({
						type: 'POST',
						data: postData,
						url: ajaxurl,
						success: function success(response) {
							$('#give-donor-notes').prepend(response);
							$('.give-no-donor-notes').hide();
							$('#donor-note').val('');
						}
					}).fail(function (data) {
						if (window.console && window.console.log) {
							console.log(data);
						}
					});
				} else {
					var border_color = $('#donor-note').css('border-color');
					$('#donor-note').css('border-color', 'red');
					setTimeout(function () {
						$('#donor-note').css('border-color', border_color);
					}, 500);
				}
			});
		},
		delete_checked: function delete_checked() {
			$('#give-donor-delete-confirm').change(function () {
				var records_input = $('#give-donor-delete-records');
				var submit_button = $('#give-delete-donor');

				if ($(this).prop('checked')) {
					records_input.attr('disabled', false);
					submit_button.attr('disabled', false);
				} else {
					records_input.attr('disabled', true);
					records_input.prop('checked', false);
					submit_button.attr('disabled', true);
				}
			});
		},
		add_email: function add_email() {
			if (!$('#add-donor-email').length) {
				return;
			}

			$(document.body).on('click', '#add-donor-email', function (e) {
				e.preventDefault();
				var button = $(this);
				var wrapper = button.parent();

				wrapper.parent().find('.notice-wrap').remove();
				wrapper.find('.spinner').css('visibility', 'visible');
				button.attr('disabled', true);

				var customer_id = wrapper.find('input[name="donor-id"]').val();
				var email = wrapper.find('input[name="additional-email"]').val();
				var primary = wrapper.find('input[name="make-additional-primary"]').is(':checked');
				var nonce = wrapper.find('input[name="add_email_nonce"]').val();

				var postData = {
					give_action: 'add_donor_email',
					customer_id: customer_id,
					email: email,
					primary: primary,
					_wpnonce: nonce
				};

				$.post(ajaxurl, postData, function (response) {

					if (true === response.success) {
						window.location.href = response.redirect;
					} else {
						button.attr('disabled', false);
						wrapper.after('<div class="notice-wrap"><div class="notice notice-error inline"><p>' + response.message + '</p></div></div>');
						wrapper.find('.spinner').css('visibility', 'hidden');
					}
				}, 'json');
			});
		},

		addressesAction: function addressesAction() {
			var $obj = this,
			    $addressWrapper = $('#donor-address-wrapper'),
			    $allAddress = $('.all-address', $addressWrapper),
			    $noAddressMessageWrapper = $('.give-no-address-message', $addressWrapper),
			    $allAddressParent = $($allAddress).parent(),
			    $addressForm = $('.address-form', $addressWrapper),
			    $addressFormCancelBtn = $('.js-cancel', $addressForm),
			    $addressFormCountryField = $('select[name="country"]', $addressForm),
			    $addNewAddressBtn = $('.add-new-address', $addressWrapper),
			    donorID = parseInt($('input[name="donor-id"]').val());

			$addressFormCountryField.on('change', function () {
				$(this).trigger('chosen:updated');
			});

			// Edit current address button event.
			$allAddress.on('click', '.js-edit', function (e) {
				var $parent = $(this).closest('.address');

				e.preventDefault();

				// Remove notice.
				$('.notice', $allAddressParent).remove();

				$obj.__set_address_form_val($parent);
				$obj.__set_address_form_action('update', $parent.data('address-id'));

				$addNewAddressBtn.hide();
				$allAddress.addClass('give-hidden');
				$addressForm.removeClass('add-new-address-form-hidden');
				$addressForm.data('process', 'update');
			});

			// Remove address button event.
			$allAddress.on('click', '.js-remove', function (e) {
				e.preventDefault();

				var $parent = $(this).closest('.address');

				// Remove notice.
				$('.notice', $allAddressParent).remove();

				$addressForm.data('changed', true);
				$obj.__set_address_form_val($parent);
				$obj.__set_address_form_action('remove', $parent.data('address-id'));

				$addressForm.trigger('submit');
			});

			// Add new address button event.
			$addNewAddressBtn.on('click', function (e) {
				e.preventDefault();

				// Remove notice.
				$('.notice', $allAddressParent).remove();

				$(this).hide();
				$allAddress.addClass('give-hidden');
				$addressForm.removeClass('add-new-address-form-hidden');
				$obj.__set_address_form_action('add');

				$obj.__set_address_form_action();
			});

			// Cancel add new address form button event.
			$addressFormCancelBtn.on('click', function (e) {
				e.preventDefault();

				// Reset form.
				$addressForm.find('input[type="text"]').val('');

				$addNewAddressBtn.show();
				$allAddress.removeClass('give-hidden');
				$addressForm.addClass('add-new-address-form-hidden');
			});

			// Save address.
			$addressForm.on('change', function () {
				$(this).data('changed', true);
			}).on('submit', function (e) {
				e.preventDefault();

				var $this = $(this);

				// Remove notice.
				$('.notice', $allAddressParent).remove();

				// Do not send ajax if form does not change.
				if (!$(this).data('changed')) {
					$addNewAddressBtn.show();
					$allAddress.removeClass('give-hidden');
					$addressForm.addClass('add-new-address-form-hidden');

					return false;
				}

				$.ajax({
					type: 'POST',
					url: ajaxurl,
					data: {
						action: 'donor_manage_addresses',
						donorID: donorID,
						form: $('form', $addressForm).serialize()
					},
					beforeSend: function beforeSend() {
						giveAjaxLoader($addressWrapper, { show: true });
					},
					success: function success(response) {
						giveAjaxLoader($addressWrapper);

						if (response.success) {
							var parent;

							switch (response.data.action) {
								case 'add':
									$('.give-grid-row', $allAddress).append(response.data.address_html);

									if (!$noAddressMessageWrapper.hasClass('give-hidden') && $('div.give-grid-col-4', $allAddress).length) {
										$noAddressMessageWrapper.addClass('give-hidden');
									}
									break;

								case 'remove':
									parent = $allAddress.find('div[data-address-id*="' + response.data.id + '"]').parent();

									if (parent.length) {
										parent.animate({ 'margin-left': '-999' }, 1000, function () {
											parent.remove();

											if ($noAddressMessageWrapper.hasClass('give-hidden') && !$('div.give-grid-col-4', $allAddress).length) {
												$noAddressMessageWrapper.removeClass('give-hidden');
											}
										});
									}

									break;

								case 'update':
									parent = $allAddress.find('div[data-address-id*="' + response.data.id + '"]').parent();
									var $prevParent = parent.prev(),
									    $nextParent = {},
									    is_address_added = false;

									if (parseInt($('.give-grid-row>div', $allAddress).length) < 2) {
										$('.give-grid-row', $allAddress).append(response.data.address_html);
									} else {
										if ($prevParent.length) {
											$prevParent.after(response.data.address_html);
											is_address_added = true;
										}

										if (!is_address_added) {
											$nextParent = parent.next();

											if ($nextParent.length) {
												$nextParent.before(response.data.address_html);
											}
										}
									}

									parent.remove();

									break;
							}

							$allAddressParent.prepend(response.data.success_msg);
						} else {
							$allAddressParent.prepend(response.data.error_msg);
						}
					},
					dataType: 'json'
				}).always(function () {
					$this.data('changed', false);

					// Reset form.
					$addressForm.find('input[type="text"]').val('');

					$addNewAddressBtn.show();
					$allAddress.removeClass('give-hidden');
					$addressForm.addClass('add-new-address-form-hidden');
				});

				return false;
			});
		},

		__set_address_form_action: function __set_address_form_action(addressAction, addressID) {
			var $addressWrapper = $('#donor-address-wrapper'),
			    $addressForm = $('.address-form', $addressWrapper),
			    $addressActionField = $('input[name="address-action"]', $addressForm),
			    $addressIDField = $('input[name="address-id"]', $addressForm);

			addressAction = addressAction || 'add';
			addressID = addressID || 'billing';

			$addressActionField.val(addressAction);
			$addressIDField.val(addressID);
		},

		__set_address_form_val: function __set_address_form_val($form) {
			var $addressWrapper = $('#donor-address-wrapper'),
			    $addressForm = $('.address-form', $addressWrapper),
			    state = $('[data-address-type="state"]', $form).text().substr(2).trim(); // State will be like ", HR".

			if ($('select[name="country"]', $addressForm).val().trim() !== $('[data-address-type="country"]', $form).text().trim()) {
				$('select[name="country"]', $addressForm).val($('[data-address-type="country"]', $form).text().trim()).trigger('chosen:updated').change();

				// Update state after some time because state load by ajax for each country.
				window.setTimeout(function () {
					$('[name="state"]', $addressForm).val(state).trigger('chosen:updated');
				}, 500);
			} else {
				$('[name="state"]', $addressForm).val(state).trigger('chosen:updated');
			}

			$('input[name="line1"]', $addressForm).val($('[data-address-type="line1"]', $form).text().trim());
			$('input[name="line2"]', $addressForm).val($('[data-address-type="line2"]', $form).text().trim());
			$('input[name="city"]', $addressForm).val($('[data-address-type="city"]', $form).text().trim());
			$('input[name="zip"]', $addressForm).val($('[data-address-type="zip"]', $form).text().trim());
		},

		bulkDeleteDonor: function bulkDeleteDonor() {
			var $body = $('body');

			// Cancel button click event for donor.
			$body.on('click', '#give-bulk-delete-cancel', function (e) {
				$(this).closest('tr').hide();
				$('.give-skip-donor').trigger('click');
				e.preventDefault();
			});

			// Select All checkbox.
			$body.on('click', '#cb-select-all-1, #cb-select-all-2', function () {

				var selectAll = $(this);

				// Loop through donor selector checkbox.
				$.each($('.donor-selector'), function () {

					var donorId = $(this).val(),
					    donorName = $(this).data('name'),
					    donorHtml = '<div id="give-donor-' + donorId + '" data-id="' + donorId + '">' + '<a class="give-skip-donor" title="' + Give.fn.getGlobalVar('remove_from_bulk_delete') + '">X</a>' + donorName + '</div>';

					if (selectAll.is(':checked') && !$(this).is(':checked')) {
						$('#give-bulk-donors').append(donorHtml);
					} else if (!selectAll.is(':checked')) {
						$('#give-bulk-donors').find('#give-donor-' + donorId).remove();
					}
				});
			});

			// On checking checkbox, add to bulk delete donor.
			$body.on('click', '.donor-selector', function () {
				var donorId = $(this).val(),
				    donorName = $(this).data('name'),
				    donorHtml = '<div id="give-donor-' + donorId + '" data-id="' + donorId + '">' + '<a class="give-skip-donor" title="' + Give.fn.getGlobalVar('remove_from_bulk_delete') + '">X</a>' + donorName + '</div>';

				if ($(this).is(':checked')) {
					$('#give-bulk-donors').prepend(donorHtml);
				} else {
					$('#give-bulk-donors').find('#give-donor-' + donorId).remove();
				}
			});

			// CheckBox click event to confirm deletion of donor.
			$body.on('click', '#give-bulk-delete .give-donor-delete-confirm', function () {
				if ($(this).is(':checked')) {
					$('#give-bulk-delete-button').removeAttr('disabled');
				} else {
					$('#give-bulk-delete-button').attr('disabled', true);
					$('#give-bulk-delete .give-donor-delete-records').removeAttr('checked');
				}
			});

			// CheckBox click event to delete records with donor.
			$body.on('click', '#give-bulk-delete .give-donor-delete-records', function () {
				if ($(this).is(':checked')) {
					$('#give-bulk-delete .give-donor-delete-confirm').attr('checked', 'checked');
					$('#give-bulk-delete-button').removeAttr('disabled');
				}
			});

			// Skip Donor from Bulk Delete List.
			$body.on('click', '.give-skip-donor', function () {
				var donorId = $(this).closest('div').data('id');
				$('#give-donor-' + donorId).remove();
				$('#donor-' + donorId).find('input[type="checkbox"]').removeAttr('checked');
			});

			// Clicking Event to Delete Single Donor.
			$body.on('click', '.give-single-donor-delete', function (e) {
				var donorId = $(this).data('id'),
				    donorSelector = $('tr#donor-' + donorId).find('.donor-selector'),
				    selectAll = $('[id^="cb-select-all-"]'),
				    bulkDeleteList = $('#give-bulk-donors'),
				    donorName = donorSelector.data('name'),
				    donorHtml = '<div id="give-donor-' + donorId + '" data-id="' + donorId + '">' + '<a class="give-skip-donor" title="' + Give.fn.getGlobalVar('remove_from_bulk_delete') + '">X</a>' + donorName + '</div>';

				// Reset Donors List.
				bulkDeleteList.html('');

				// Check whether the select all donor checkbox is already set, then unset it.
				if (selectAll.is(':checked')) {
					selectAll.removeAttr('checked');
				}

				// Select the donor checkbox for which delete is clicked and others should be de-selected.
				$('.donor-selector').removeAttr('checked');
				donorSelector.attr('checked', 'checked');

				// Add Donor to the Bulk Delete List, if donor doesn't exists in the list.
				if ($('#give-donor-' + donorId).length === 0) {
					bulkDeleteList.prepend(donorHtml);
					$('#give-bulk-delete').slideDown();
				}

				e.preventDefault();
			});
		},

		handleBulkActions: function handleBulkActions(e) {
			var currentAction = $(this).closest('.tablenav').find('select').val(),
			    donors = [],
			    paged = $('#current-page-selector').val(),
			    changedPage = GiveDonor.onLoadPageNumber !== paged,
			    selectBulkActionNotice = Give.fn.getGlobalVar('donors_bulk_action.no_action_selected'),
			    confirmActionNotice = Give.fn.getGlobalVar('donors_bulk_action.no_donor_selected');

			// Bailout.
			if (changedPage) {
				return true;
			}

			$.each($('.donor-selector:checked'), function () {
				donors.push($(this).val());
			});

			// If there is no bulk action selected then show an alert message.
			if ('-1' === currentAction) {
				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveWarningAlert"]({
					modalContent: {
						title: selectBulkActionNotice.title,
						desc: selectBulkActionNotice.desc,
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
				return false;
			}

			// If there is no donor selected then show an alert.
			if (!parseInt(donors)) {
				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveWarningAlert"]({
					modalContent: {
						title: confirmActionNotice.title,
						desc: confirmActionNotice.desc,
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();

				return false;
			}

			if ('delete' === currentAction) {
				$('#give-bulk-delete').slideDown();
			}

			e.preventDefault();
		}
	};

	/**
  * API screen JS
  */
	var API_Screen = {

		init: function init() {
			this.revoke_api_key();
			this.regenerate_api_key();
		},

		revoke_api_key: function revoke_api_key() {
			$('body').on('click', '.give-revoke-api-key', function (e) {
				return confirm(Give.fn.getGlobalVar('revoke_api_key'));
			});
		},
		regenerate_api_key: function regenerate_api_key() {
			$('body').on('click', '.give-regenerate-api-key', function (e) {
				return confirm(Give.fn.getGlobalVar('regenerate_api_key'));
			});
		}
	};

	/**
  * Edit Donation form screen Js
  */
	var Edit_Form_Screen = {
		init: function init() {
			var default_tab_id = $.query.get('give_tab').length ? $.query.get('give_tab') : 'form_field_options';

			this.handle_metabox_tab_click();
			this.setup_colorpicker_fields();
			this.setup_media_fields();
			this.setup_repeatable_fields();
			this.handle_repeater_group_events();

			// Multi level repeater field js.
			this.handle_multi_levels_repeater_group_events();

			// Set active tab on page load.
			this.activate_tab($('a[href="#' + default_tab_id + '"]'));
		},

		/**
   * Attach click event handler to tabs.
   */
		handle_metabox_tab_click: function handle_metabox_tab_click() {
			var self = this;
			var $tab_links = $('.give-metabox-tabs a');

			$tab_links.on('click', function (e) {
				e.preventDefault();
				var $this = $(this);
				self.activate_tab($this);
				self.update_query($this);
			});
		},

		/**
   * Set the active tab.
   */
		activate_tab: function activate_tab($tab_link) {
			var tab_id = $tab_link.data('tab-id'),
			    $li_parent = $tab_link.parent(),
			    $sub_field = $('ul.give-metabox-sub-tabs', $li_parent),
			    has_sub_field = $sub_field.length,
			    $tab_links = $('.give-metabox-tabs a'),
			    $all_tab_links_li = $tab_links.parents('li'),
			    $all_sub_fields = $('ul.give-metabox-sub-tabs'),
			    in_sub_fields = $tab_link.parents('ul.give-metabox-sub-tabs').length;

			// Update active tab hidden field to maintain tab after save.
			$('#give_form_active_tab').val(tab_id);

			if (has_sub_field) {
				$li_parent.toggleClass('active');
				$sub_field.removeClass('give-hidden');

				var $active_subtab_li = $('li.active', 'ul.give-metabox-sub-tabs');

				// Show hide sub fields if any and exit.
				$all_sub_fields.not($sub_field).addClass('give-hidden');
				$all_tab_links_li.not($li_parent).removeClass('active');

				$active_subtab_li.addClass('active');
			} else if (!in_sub_fields) {
				// Hide all tab and sub tabs.
				$all_tab_links_li.each(function (index, item) {
					item = $(item);
					item.removeClass('active');

					if (item.hasClass('has-sub-fields')) {
						$('ul.give-metabox-sub-tabs', item).addClass('give-hidden');
					}
				});
			} else if (in_sub_fields) {
				// Hide all sub tabs.
				$('ul.give-metabox-sub-tabs').addClass('give-hidden');
				$all_tab_links_li.removeClass('active');

				// Hide all tab inside sub tabs.
				$tab_link.parents('ul.give-metabox-sub-tabs').removeClass('give-hidden').children('li').removeClass('active');

				// Add active class to parent li.
				$tab_link.parents('li.has-sub-fields').addClass('active');
			}

			// Add active class to current tab link.
			$tab_link.parent().addClass('active');

			// Hide all tab contents.
			$('.give_options_panel').removeClass('active');

			// Show tab content.
			$($tab_link.attr('href')).addClass('active');
		},

		/**
   * Update query string with active tab ID.
   */
		update_query: function update_query($tab_link) {
			var tab_id = $tab_link.data('tab-id');
			var new_query = $.query.set('give_tab', tab_id).remove('message').toString();

			if (history.replaceState) {
				history.replaceState(null, null, new_query);
			}
		},

		/**
   * Initialize colorpicker.
   */
		setup_colorpicker_fields: function setup_colorpicker_fields() {
			$(document).ready(function () {
				var $colorpicker_fields = $('.give-colorpicker');

				if ($colorpicker_fields.length) {
					$colorpicker_fields.each(function (index, item) {
						var $item = $(item);

						// Bailout: do not automatically initialize color picker for repeater field group template.
						if ($item.parents('.give-template').length) {
							return;
						}

						$item.wpColorPicker();
					});
				}
			});
		},

		setup_media_fields: function setup_media_fields() {
			var give_media_uploader,
			    $give_upload_button,
			    $body = $('body');

			/**
    * Set media modal.
    */
			$body.on('click', '.give-upload-button', function (e) {
				e.preventDefault();
				var $media_modal_config = {};

				// Cache input field.
				$give_upload_button = $(this);

				// Set modal config.
				switch ($(this).data('field-type')) {
					case 'media':
						$media_modal_config = {
							title: Give.fn.getGlobal().metabox_fields.media.button_title,
							button: { text: Give.fn.getGlobal().metabox_fields.media.button_title },
							multiple: false, // Set to true to allow multiple files to be selected.
							library: { type: 'image' }
						};
						break;

					default:
						$media_modal_config = {
							title: Give.fn.getGlobal().metabox_fields.file.button_title,
							button: { text: Give.fn.getGlobal().metabox_fields.file.button_title },
							multiple: false
						};
				}

				var editing = jQuery(this).closest('.give-field-wrap').find('.give-input-field').attr('editing');
				if ('undefined' !== typeof editing) {
					wp.media.controller.Library.prototype.defaults.contentUserSetting = false;
				}

				var $library = jQuery(this).closest('.give-field-wrap').find('.give-input-field').attr('library');
				if ('undefined' !== typeof $library && '' !== $library) {
					$media_modal_config.library = { type: $library };
				}

				// Extend the wp.media object.
				give_media_uploader = wp.media($media_modal_config);

				// When a file is selected, grab the URL and set it as the text field's value.
				give_media_uploader.on('select', function () {
					var attachment = give_media_uploader.state().get('selection').first().toJSON(),
					    $input_field = $give_upload_button.prev(),
					    fvalue = 'id' === $give_upload_button.data('fvalue') ? attachment.id : attachment.url;

					$body.trigger('give_media_inserted', [attachment, $input_field]);

					// Set input field value.
					$input_field.val(fvalue);

					// Update attachment id field value if fvalue is not set to id.
					if ('id' !== $give_upload_button.data('fvalue')) {
						var attachment_id_field_name = 'input[name="' + $input_field.attr('name') + '_id"]',
						    id_field = $input_field.closest('tr').next('tr').find(attachment_id_field_name);

						if (id_field.length) {
							$input_field.closest('tr').next('tr').find(attachment_id_field_name).val(attachment.id);
						}
					}
				});

				// Open the uploader dialog.
				give_media_uploader.open();
			});

			/**
    * Show image preview.
    */
			$body.on('give_media_inserted', function (e, attachment) {
				var $parent = $give_upload_button.parents('.give-field-wrap'),
				    $image_container = $('.give-image-thumb', $parent);

				// Bailout.
				if (!$image_container.length) {
					return false;
				}

				// Bailout and hide preview.
				if ('image' !== attachment.type) {
					$image_container.addClass('give-hidden');
					$('img', $image_container).attr('src', '');
					return false;
				}

				// Set the attachment URL to our custom image input field.
				$image_container.find('img').attr('src', attachment.url);

				// Hide the add image link.
				$image_container.removeClass('give-hidden');
			});

			/**
    * Delete Image Link.
    */
			$('span.give-delete-image-thumb', '.give-image-thumb').on('click', function (event) {

				event.preventDefault();

				var $parent = $(this).parents('.give-field-wrap'),
				    $image_container = $(this).parent(),
				    $image_input_field = $('input[type="text"]', $parent);

				// Clear out the preview image.
				$image_container.addClass('give-hidden');

				// Remove image link from input field.
				$image_input_field.val('');

				// Hide the add image link.
				$('img', $image_container).attr('src', '');
			});
		},

		/**
   * Setup repeater field.
   */
		setup_repeatable_fields: function setup_repeatable_fields() {
			jQuery(function () {
				jQuery('.give-repeatable-field-section').each(function () {
					var $this = $(this);

					// Note: Do not change option params, it can break repeatable fields functionality.
					var options = {
						wrapper: '.give-repeatable-fields-section-wrapper',
						container: '.container',
						row: '.give-row',
						add: '.give-add-repeater-field-section-row',
						remove: '.give-remove',
						move: '.give-move',
						template: '.give-template',
						confirm_before_remove_row: true,
						confirm_before_remove_row_text: Give.fn.getGlobalVar('confirm_before_remove_row_text'),
						is_sortable: true,
						before_add: null,
						after_add: handle_metabox_repeater_field_row_count,
						//after_add:  after_add, Note: after_add is internal function in repeatable-fields.js. Uncomment this can cause of js error.
						before_remove: null,
						after_remove: handle_metabox_repeater_field_row_remove,
						sortable_options: {
							placeholder: 'give-ui-placeholder-state-highlight',
							start: function start(event, ui) {
								// Do not allow any row at position 0.
								if (ui.item.next().hasClass('give-template')) {
									ui.item.next().after(ui.item);
								}

								var $rows = $('.give-row', $this).not('.give-template');

								if ($rows.length) {
									$rows.each(function (index, item) {
										// Set name for fields.
										var $fields = $('input[type="radio"].give-field', $(item));

										// Preserve radio button values.
										if ($fields.length) {
											$fields.each(function () {
												$(this).attr('data-give-checked', $(this).is(':checked'));
											});
										}
									});
								}

								$('body').trigger('repeater_field_sorting_start', [ui.item]);
							},
							stop: function stop(event, ui) {
								// Do not allow any row at position 0.
								if (ui.item.next().hasClass('give-template')) {
									ui.item.next().after(ui.item);
								}

								$('body').trigger('repeater_field_sorting_stop', [ui.item]);
							},
							update: function update(event, ui) {
								// Do not allow any row at position 0.
								if (ui.item.next().hasClass('give-template')) {
									ui.item.next().after(ui.item);
								}

								var $rows = $('.give-row', $this).not('.give-template'),
								    $container = $(this).closest('.give-repeatable-fields-section-wrapper');

								if ($rows.length) {
									var row_count = 1;
									$rows.each(function (index, item) {
										// Set name for fields.
										var $fields = $('.give-field, label', $(item));

										if ($fields.length) {
											$fields.each(function () {
												var $parent = $(this).parents('.give-field-wrap'),
												    $currentElement = $(this);

												$.each(this.attributes, function (index, element) {
													var old_class_name_prefix = this.value.replace(/\[/g, '_').replace(/]/g, ''),
													    old_class_name = old_class_name_prefix + '_field',
													    new_class_name = '',
													    new_class_name_prefix = '';

													// Bailout.
													if (!this.value) {
														return;
													}

													// Reorder index.
													this.value = this.value.replace(/\[\d+\]/g, '[' + (row_count - 1) + ']');
													new_class_name_prefix = this.value.replace(/\[/g, '_').replace(/]/g, '');

													// Update class name.
													if ($parent.hasClass(old_class_name)) {
														new_class_name = new_class_name_prefix + '_field';
														$parent.removeClass(old_class_name).addClass(new_class_name);
													}

													// Update field id.
													if (old_class_name_prefix == $currentElement.attr('id')) {
														$currentElement.attr('id', new_class_name_prefix);
													}
												});
											});
										}

										row_count++;
									});

									window.setTimeout(function () {
										// Reset radio button values.
										$('input[data-give-checked]', $container).each(function (index, radio) {
											radio = $(radio);
											radio.prop('checked', 'true' === radio.attr('data-give-checked'));
										});
									}, 100);

									// Fire event.
									$this.trigger('repeater_field_row_reordered', [ui.item]);
								}
							}
							//row_count_placeholder: '{{row-count-placeholder}}' Note: do not modify this param otherwise it will break repeatable field functionality.
						} };

					jQuery(this).repeatable_fields(options);
				});
			});
		},

		/**
   * Handle repeater field events.
   */
		handle_repeater_group_events: function handle_repeater_group_events() {
			var $repeater_fields = $('.give-repeatable-field-section'),
			    $body = $('body');

			// Auto toggle repeater group
			$body.on('click', '.give-row-head button', function () {
				var $parent = $(this).closest('tr');
				$parent.toggleClass('closed');
				$('.give-row-body', $parent).toggle();
			});

			// Reset header title when new row added.
			$repeater_fields.on('repeater_field_new_row_added repeater_field_row_deleted repeater_field_row_reordered', function () {
				handle_repeater_group_add_number_suffix($(this));
			});

			// Disable editor when sorting start.
			$body.on('repeater_field_sorting_start', function (e, row) {
				var $textarea = $('.wp-editor-area', row);

				if ($textarea.length) {
					$textarea.each(function (index, item) {
						window.setTimeout(function () {
							tinyMCE.execCommand('mceRemoveEditor', true, $(item).attr('id'));
						}, 300);
					});
				}
			});

			// Enable editor when sorting stop.
			$body.on('repeater_field_sorting_stop', function (e, row) {
				var $textarea = $('.wp-editor-area', row);

				if ($textarea.length) {
					$textarea.each(function (index, item) {
						window.setTimeout(function () {
							var textarea_id = $(item).attr('id');
							tinyMCE.execCommand('mceAddEditor', true, textarea_id);

							// Switch editor to tmce mode to fix some glitch which appear when you reorder rows.
							window.setTimeout(function () {
								// Hack to show tmce mode.
								switchEditors.go(textarea_id, 'html');
								$('#' + textarea_id + '-tmce').trigger('click');
							}, 100);
						}, 300);
					});
				}
			});

			// Process jobs on document load for repeater fields.
			$repeater_fields.each(function (index, item) {
				// Reset title on document load for already exist groups.
				var $item = $(item);
				handle_repeater_group_add_number_suffix($item);

				// Close all tabs when page load.
				if (parseInt($item.data('close-tabs'))) {
					$('.give-row-head button', $item).trigger('click');
					$('.give-template', $item).removeClass('closed');
					$('.give-template .give-row-body', $item).show();
				}
			});

			// Setup colorpicker field when row added.
			$repeater_fields.on('repeater_field_new_row_added', function (e, container, new_row) {
				$('.give-colorpicker', $(this)).each(function (index, item) {
					var $item = $(item);

					// Bailout: skip already init colorpocker fields.
					if ($item.parents('.wp-picker-container').length || $item.parents('.give-template').length) {
						return;
					}

					$item.wpColorPicker();
				});

				// Load WordPress editor by ajax.
				var wysiwyg_editor_container = $('div[data-wp-editor]', new_row);

				if (wysiwyg_editor_container.length) {
					wysiwyg_editor_container.each(function (index, item) {
						var $item = $(item),
						    wysiwyg_editor = $('.wp-editor-wrap', $item),
						    textarea = $('textarea', $item),
						    textarea_id = 'give_wysiwyg_unique_' + Math.random().toString().replace('.', '_'),
						    wysiwyg_editor_label = wysiwyg_editor.prev();

						textarea.attr('id', textarea_id);

						$.post(ajaxurl, {
							action: 'give_load_wp_editor',
							wp_editor: $item.data('wp-editor'),
							wp_editor_id: textarea_id,
							textarea_name: $('textarea', $item).attr('name')
						}, function (res) {
							wysiwyg_editor.remove();
							wysiwyg_editor_label.after(res);

							// Setup qt data for editor.
							tinyMCEPreInit.qtInit[textarea.attr('id')] = $.extend(true, tinyMCEPreInit.qtInit['_give_agree_text'], { id: textarea_id });

							// Setup mce data for editor.
							tinyMCEPreInit.mceInit[textarea_id] = $.extend(true, tinyMCEPreInit.mceInit['_give_agree_text'], {
								body_class: textarea_id + ' post-type-give_forms post-status-publish locale-' + tinyMCEPreInit.mceInit['_give_agree_text']['wp_lang_attr'].toLowerCase(),
								selector: '#' + textarea_id
							});

							// Setup editor.
							tinymce.init(tinyMCEPreInit.mceInit[textarea_id]);
							quicktags(tinyMCEPreInit.qtInit[textarea_id]);
							QTags._buttonsInit();

							window.setTimeout(function () {
								// Hack to show tmce mode.
								switchEditors.go(textarea_id, 'html');
								$('#' + textarea_id + '-tmce').trigger('click');
							}, 100);

							if (!window.wpActiveEditor) {
								window.wpActiveEditor = textarea_id;
							}
						});
					});
				}
			});
		},

		/**
   *  Handle events for multi level repeater group.
   */
		handle_multi_levels_repeater_group_events: function handle_multi_levels_repeater_group_events() {
			var $repeater_fields = $('#_give_donation_levels_field');

			// Add level title as suffix to header title when admin add level title.
			$('body').on('keyup', '.give-multilevel-text-field', function () {
				var $parent = $(this).closest('tr'),
				    $header_title_container = $('.give-row-head h2 span', $parent),
				    donation_level_header_text_prefix = $header_title_container.data('header-title');

				// Donation level header already set.
				if ($(this).val() && $(this).val() === $header_title_container.html()) {
					return false;
				}

				if ($(this).val()) {
					// Change donaiton level header text.
					$header_title_container.html(donation_level_header_text_prefix + ': ' + $(this).val());
				} else {
					// Reset donation level header heading text.
					$header_title_container.html(donation_level_header_text_prefix);
				}
			});

			//  Add level title as suffix to header title on document load.
			$('.give-multilevel-text-field').each(function (index, item) {

				// Skip first element.
				if (!index) {
					return;
				}

				// Check if item is jquery object or not.
				var $item = $(item);

				var $parent = $item.closest('tr'),
				    $header_title_container = $('.give-row-head h2 span', $parent),
				    donation_level_header_text_prefix = $header_title_container.data('header-title');

				// Donation level header already set.
				if ($item.val() && $item.val() === $header_title_container.html()) {
					return false;
				}

				if ($item.val()) {
					// Change donaiton level header text.
					$header_title_container.html(donation_level_header_text_prefix + ': ' + $item.val());
				} else {
					// Reset donation level header heading text.
					$header_title_container.html(donation_level_header_text_prefix);
				}
			});

			// Handle row deleted event for levels repeater field.
			$repeater_fields.on('repeater_field_row_deleted', function () {
				var $this = $(this);

				window.setTimeout(function () {
					var $parent = $this,
					    $repeatable_rows = $('.give-row', $parent).not('.give-template'),
					    $default_radio = $('.give-give_default_radio_inline', $repeatable_rows),
					    number_of_level = $repeatable_rows.length;

					if (number_of_level === 1) {
						$default_radio.prop('checked', true);
					}
				}, 200);
			});

			// Handle row added event for levels repeater field.
			$repeater_fields.on('repeater_field_new_row_added', function (e, container, new_row) {
				var $this = $(this),
				    max_level_id = 0;

				// Auto set default level if no level set as default.
				window.setTimeout(function () {
					// Set first row as default if selected default row deleted.
					// When a row is removed containing the default selection then revert default to first repeatable row.
					if ($('.give-give_default_radio_inline', $this).is(':checked') === false) {
						$('.give-row', $this).not('.give-template').first().find('.give-give_default_radio_inline').prop('checked', true);
					}
				}, 200);

				// Get max level id.
				$('input[type="hidden"].give-levels_id', $this).each(function (index, item) {
					var $item = $(item),
					    current_level = parseInt($item.val());
					if (max_level_id < current_level) {
						max_level_id = current_level;
					}
				});

				// Auto set level id for new setting level setting group.
				$('input[type="hidden"].give-levels_id', new_row).val(++max_level_id);
			});
		}
	};

	/**
  * Handle row count and field count for repeatable field.
  */
	var handle_metabox_repeater_field_row_count = function handle_metabox_repeater_field_row_count(container, new_row) {
		var row_count = $(container).attr('data-rf-row-count'),
		    $container = $(container),
		    $parent = $container.parents('.give-repeatable-field-section');

		row_count++;

		// Set name for fields.
		$('*', new_row).each(function () {
			$.each(this.attributes, function (index, element) {
				this.value = this.value.replace('{{row-count-placeholder}}', row_count - 1);
			});
		});

		// Set row counter.
		$(container).attr('data-rf-row-count', row_count);

		// Fire event: Row added.
		$parent.trigger('repeater_field_new_row_added', [container, new_row]);
	};

	/**
  * Handle row remove for repeatable field.
  */
	var handle_metabox_repeater_field_row_remove = function handle_metabox_repeater_field_row_remove(container) {
		var $container = $(container),
		    $parent = $container.parents('.give-repeatable-field-section'),
		    row_count = $(container).attr('data-rf-row-count');

		// Reduce row count.
		$container.attr('data-rf-row-count', --row_count);

		// Fire event: Row deleted.
		$parent.trigger('repeater_field_row_deleted');
	};

	/**
  * Add number suffix to repeater group.
  */
	var handle_repeater_group_add_number_suffix = function handle_repeater_group_add_number_suffix($parent) {

		// Bailout: check if auto group numbering is on or not.
		if (!parseInt($parent.data('group-numbering'))) {
			return;
		}

		var $header_title_container = $('.give-row-head h2 span', $parent),
		    header_text_prefix = $header_title_container.data('header-title');

		$header_title_container.each(function (index, item) {
			var $item = $(item);

			// Bailout: do not rename header title in fields template.
			if ($item.parents('.give-template').length) {
				return;
			}

			$item.html(header_text_prefix + ': ' + index);
		});
	};

	/**
  * Payment history listing page js
  */
	var GivePaymentHistory = {

		onLoadPageNumber: '',

		init: function init() {
			GivePaymentHistory.onLoadPageNumber = $('#current-page-selector').val();
			$('body').on('click', '#give-payments-filter input[type="submit"]', this.handleBulkActions);
		},

		handleBulkActions: function handleBulkActions(e) {
			var currentAction = $(this).closest('.tablenav').find('select').val(),
			    currentActionLabel = $(this).closest('.tablenav').find('option[value="' + currentAction + '"]').text(),
			    $payments = $('input[name="payment[]"]:checked').length,
			    isStatusTypeAction = -1 !== currentAction.indexOf('set-status-'),
			    confirmActionNotice = '',
			    status = '',
			    paged = $('#current-page-selector').val(),
			    changedPage = GivePaymentHistory.onLoadPageNumber !== paged;

			// Bailout.
			if (changedPage) {
				return true;
			}

			// Set common action, if action type is status.
			currentAction = isStatusTypeAction ? 'set-to-status' : currentAction;

			if ('-1' === currentAction) {
				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveWarningAlert"]({
					modalContent: {
						title: Give.fn.getGlobal().donors_bulk_action.no_action_selected.title,
						desc: Give.fn.getGlobal().donors_bulk_action.no_action_selected.desc,
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
				return false;
			}

			if (Object.keys(Give.fn.getGlobalVar('donations_bulk_action')).length) {
				for (status in Give.fn.getGlobalVar('donations_bulk_action')) {
					if (status === currentAction) {

						// Get status text if current action types is status.
						confirmActionNotice = isStatusTypeAction ? Give.fn.getGlobal().donations_bulk_action[currentAction].zero.replace('{status}', currentActionLabel.replace('Set To ', '')) : Give.fn.getGlobal().donations_bulk_action[currentAction].zero;

						// Check if admin selected any donations or not.
						if (!parseInt($payments)) {
							new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveWarningAlert"]({
								modalContent: {
									title: Give.fn.getGlobal().donations_bulk_action.titles.zero,
									desc: confirmActionNotice,
									cancelBtnTitle: Give.fn.getGlobalVar('ok')
								}
							}).render();
							return false;
						}

						// Get message on basis of payment count.
						confirmActionNotice = 1 < $payments ? Give.fn.getGlobal().donations_bulk_action[currentAction].multiple : Give.fn.getGlobal().donations_bulk_action[currentAction].single;

						e.preventDefault();

						new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveConfirmModal"]({
							modalContent: {
								title: Give.fn.getGlobalVar('confirm_bulk_action'),
								desc: confirmActionNotice.replace('{payment_count}', $payments).replace('{status}', currentActionLabel.replace('Set To ', ''))
							},
							successConfirm: function successConfirm(args) {
								$('#give-payments-filter').submit();
							}
						}).render();
					}
				}
			}

			return true;
		}
	};

	// On DOM Ready.
	$(function () {

		give_dismiss_notice();
		enable_admin_datepicker();
		handle_status_change();
		setup_chosen_give_selects();
		$.giveAjaxifyFields({ type: 'country_state', debug: true });
		GiveListDonation.init();
		Give_Edit_Donation.init();
		Give_Settings.init();
		Give_Reports.init();
		GiveDonor.init();
		API_Screen.init();
		Give_Export.init();
		Give_Updates.init();
		Give_Upgrades.init();
		Edit_Form_Screen.init();
		GivePaymentHistory.init();

		// Footer.
		$('a.give-rating-link').click(function () {
			jQuery(this).parent().text(jQuery(this).data('rated'));
		});

		// Ajax user search.
		$('.give-ajax-user-search').on('keyup', function () {
			var user_search = $(this).val();
			var exclude = '';

			if ($(this).data('exclude')) {
				exclude = $(this).data('exclude');
			}

			$('.give-ajax').show();
			data = {
				action: 'give_search_users',
				user_name: user_search,
				exclude: exclude
			};

			document.body.style.cursor = 'wait';

			$.ajax({
				type: 'POST',
				data: data,
				dataType: 'json',
				url: ajaxurl,
				success: function success(search_response) {
					$('.give-ajax').hide();
					$('.give_user_search_results').removeClass('hidden');
					$('.give_user_search_results span').html('');
					$(search_response.results).appendTo('.give_user_search_results span');
					document.body.style.cursor = 'default';
				}
			});
		});

		$('body').on('click.giveSelectUser', '.give_user_search_results span a', function (e) {
			e.preventDefault();
			var login = $(this).data('login');
			$('.give-ajax-user-search').val(login);
			$('.give_user_search_results').addClass('hidden');
			$('.give_user_search_results span').html('');
		});

		$('body').on('click.giveCancelUserSearch', '.give_user_search_results a.give-ajax-user-cancel', function (e) {
			e.preventDefault();
			$('.give-ajax-user-search').val('');
			$('.give_user_search_results').addClass('hidden');
			$('.give_user_search_results span').html('');
		});

		var $poststuff = $('#poststuff'),
		    thousand_separator = Give.fn.getGlobalVar('thousands_separator'),
		    decimal_separator = Give.fn.getGlobalVar('decimal_separator'),
		    thousand_separator_count = '',
		    alphabet_count = '',
		    price_string = '',


		// Thousand separation limit in price depends upon decimal separator symbol.
		// If thousand separator is equal to decimal separator then price does not have more then 1 thousand separator otherwise limit is zero.
		thousand_separator_limit = decimal_separator === thousand_separator ? 1 : 0;

		// Check & show message on keyup event.
		$poststuff.on('keyup', 'input.give-money-field, input.give-price-field', function () {
			var tootltip_setting = {
				label: Give.fn.getGlobalVar('price_format_guide').trim()
			};

			// Count thousand separator in price string.
			thousand_separator_count = ($(this).val().match(new RegExp(thousand_separator, 'g')) || []).length;
			alphabet_count = ($(this).val().match(new RegExp('[a-z]', 'g')) || []).length;

			// Show qtip conditionally if thousand separator detected on price string.
			if (-1 !== $(this).val().indexOf(thousand_separator) && thousand_separator_limit < thousand_separator_count) {
				$(this).giveHintCss('show', tootltip_setting);
			} else if (alphabet_count) {
				$(this).giveHintCss('show', tootltip_setting);
			} else {
				$(this).giveHintCss('hide', tootltip_setting);
			}

			// Reset thousand separator count.
			thousand_separator_count = alphabet_count = '';
		});

		// Format price sting of input field on focusout.
		$poststuff.on('focusout', 'input.give-money-field, input.give-price-field', function () {
			price_string = give_unformat_currency($(this).val(), false);

			$(this).giveHintCss('hide', { label: Give.fn.getGlobalVar('price_format_guide').trim() });

			// Back out.
			if (give_unformat_currency('0', false) === give_unformat_currency($(this).val(), false)) {
				var default_amount = $(this).attr('placeholder');
				default_amount = !default_amount ? '0' : default_amount;

				$(this).val(default_amount);

				return false;
			}

			// Replace dot decimal separator with user defined decimal separator.
			price_string = price_string.replace('.', decimal_separator);

			// Check if current number is negative or not.
			if (-1 !== price_string.indexOf('-')) {
				price_string = price_string.replace('-', '');
			}

			// Update format price string in input field.
			$(this).val(price_string);
		});

		// Set default value to 1 even if user inputs empty or negative number of donations.
		$poststuff.on('focusout', '#_give_number_of_donation_goal', function () {
			if (1 > $(this).val()) {
				$(this).val(1);
			}
		});

		/**
   * Responsive setting tab features.
   */

		// Show/Hide sub tab nav.
		$('.give-settings-page').on('click', '#give-show-sub-nav', function (e) {
			e.preventDefault();

			var $sub_tab_nav = $(this).next();

			if (!$sub_tab_nav.is(':hover')) {
				$sub_tab_nav.toggleClass('give-hidden');
			}

			return false;
		}).on('blur', '#give-show-sub-nav', function () {
			var $sub_tab_nav = $(this).next();

			if (!$sub_tab_nav.is(':hover')) {
				$sub_tab_nav.addClass('give-hidden');
			}
		});

		/**
   * Automatically show/hide email setting fields.
   */
		$('.give_email_api_notification_status_setting input').change(function () {
			// Bailout.
			var value = $(this).val(),
			    is_enabled = 'enabled' === value,
			    $setting_fields = {};

			// Get setting fields.
			if ($(this).closest('.give_options_panel').length) {
				$setting_fields = $(this).closest('.give_options_panel').children('.give-field-wrap:not(.give_email_api_notification_status_setting), .give-repeatable-field-section');
			} else if ($(this).closest('table').length) {
				$setting_fields = $(this).closest('table').find('tr:not(.give_email_api_notification_status_setting)');
			}

			if (-1 === jQuery.inArray(value, ['enabled', 'disabled', 'global'])) {
				return false;
			}

			// Bailout.
			if (!$setting_fields.length) {
				return false;
			}

			// Show hide setting fields.
			is_enabled ? $setting_fields.show() : $setting_fields.hide();
		});

		$('.give_email_api_notification_status_setting input:checked').change();

		// Render setting tab.
		give_render_responsive_tabs();
	});
})(jQuery);

/**
 * Responsive js.
 */
jQuery(window).resize(function () {
	give_render_responsive_tabs();
});

/**
 * Render responsive tabs
 */
function give_render_responsive_tabs() {
	var $setting_page_form = jQuery('.give-settings-page'),
	    $main_tab_nav = jQuery('h2.give-nav-tab-wrapper'),
	    setting_page_form_width = $setting_page_form.width(),
	    $sub_tab_nav_wrapper = jQuery('.give-sub-nav-tab-wrapper'),
	    $sub_tab_nav = jQuery('nav', $sub_tab_nav_wrapper),
	    $setting_tab_links = jQuery('div.give-nav-tab-wrapper > a:not(give-not-tab)'),
	    $show_tabs = [],
	    $hide_tabs = [],
	    tab_width = 0;

	if (600 < jQuery(window).outerWidth()) {
		tab_width = 200;
	}

	// Bailout.
	if (!$setting_page_form.length) {
		return false;
	}

	// Update tab wrapper css.
	$main_tab_nav.css({
		height: 'auto',
		overflow: 'visible'
	});

	// Show all tab if anyone hidden to calculate correct tab width.
	$setting_tab_links.removeClass('give-hidden');

	var refactor_tabs = new Promise(function (resolve, reject) {

		// Collect tabs to show or hide.
		jQuery.each($setting_tab_links, function (index, $tab_link) {
			$tab_link = jQuery($tab_link);
			tab_width = tab_width + parseInt($tab_link.outerWidth());

			if (tab_width < setting_page_form_width) {
				$show_tabs.push($tab_link);
			} else {
				$hide_tabs.push($tab_link);
			}
		});

		resolve(true);
	});

	refactor_tabs.then(function (is_refactor_tabs) {

		// Remove current tab from sub menu and add this to main menu if exist and get last tab from main menu and add this to sub menu.
		if ($hide_tabs.length && -1 !== window.location.search.indexOf('&tab=')) {
			var $current_tab_nav = {},
			    query_params = get_url_params();

			$hide_tabs = $hide_tabs.filter(function ($tab_link) {
				var is_current_nav_item = -1 !== parseInt($tab_link.attr('href').indexOf('&tab=' + query_params['tab']));

				if (is_current_nav_item) {
					$current_tab_nav = $tab_link;
				}

				return !is_current_nav_item;
			});

			if ($current_tab_nav.length) {
				$hide_tabs.unshift($show_tabs.pop());
				$show_tabs.push($current_tab_nav);
			}
		}

		var show_tabs = new Promise(function (resolve, reject) {

			// Show main menu tabs.
			if ($show_tabs.length) {
				jQuery.each($show_tabs, function (index, $tab_link) {
					$tab_link = jQuery($tab_link);

					if ($tab_link.hasClass('give-hidden')) {
						$tab_link.removeClass('give-hidden');
					}
				});
			}

			resolve(true);
		});

		show_tabs.then(function (is_show_tabs) {

			// Hide sub menu tabs.
			if ($hide_tabs.length) {
				$sub_tab_nav.html('');

				jQuery.each($hide_tabs, function (index, $tab_link) {
					$tab_link = jQuery($tab_link);
					if (!$tab_link.hasClass('nav-tab-active')) {
						$tab_link.addClass('give-hidden');
					}
					$tab_link.clone().removeClass().appendTo($sub_tab_nav);
				});

				if (!jQuery('.give-sub-nav-tab-wrapper', $main_tab_nav).length) {
					$main_tab_nav.append($sub_tab_nav_wrapper);
				}

				$sub_tab_nav_wrapper.show();
			} else {
				$sub_tab_nav_wrapper.hide();
			}
		});
	});
}

/**
 * Get url query params.
 *
 * @returns {Array}
 */
function get_url_params() {
	var vars = [],
	    hash;
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		vars[hash[0]] = hash[1];
	}
	return vars;
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_modal__ = __webpack_require__(10);
/**
 * Give Admin JS
 *
 * @package:     Give
 * @subpackage:  Assets/JS
 * @copyright:   Copyright (c) 2016, WordImpress
 * @license:     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

/* globals Give, jQuery*/

/**
 * Do not allow user to reload the page
 *
 * @since 1.8.14
 */


var give_setting_edit = true;

(function ($) {

	// On DOM Ready.
	$(function () {
		give_import_donation_onload();
	});
})(jQuery);

/**
 * Run when user click on submit button.
 *
 * @since 1.8.17
 */
function give_on_core_settings_import_start() {
	var import_step = 'body.give_forms_page_give-tools .give-tools-import-tab #give-import-core-settings-form table.step-2';
	if (jQuery(import_step).length > 0) {

		var $form = jQuery('form.tools-setting-page-import');
		var progress = $form.find('.give-progress');

		give_setting_edit = true;

		jQuery.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: Give.fn.getGlobalVar('core_settings_import'),
				fields: $form.serialize()
			},
			dataType: 'json',
			success: function success(response) {
				give_setting_edit = false;
				if (true === response.success) {
					jQuery(progress).find('div').width(response.percentage + '%');
				} else {
					new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveErrorAlert"]({
						modalContent: {
							title: Give.fn.getGlobalVar('import_failed'),
							desc: Give.fn.getGlobalVar('error_message'),
							cancelBtnTitle: Give.fn.getGlobalVar('ok')
						}
					}).render();

					return;
				}
				window.location = response.url;
			},
			error: function error() {
				give_setting_edit = false;

				new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveErrorAlert"]({
					modalContent: {
						title: Give.fn.getGlobalVar('import_failed'),
						desc: Give.fn.getGlobalVar('error_message'),
						cancelBtnTitle: Give.fn.getGlobalVar('ok')
					}
				}).render();
			}
		});
	}
}

/**
 * Check if admin is on step 1 and file is invalid
 *
 * @since 2.1
 */
function give_import_core_settings_json_is_valid() {
	var import_step = 'body.give_forms_page_give-tools .give-tools-import-tab #give-import-core-settings-form table.step-1 .is_json_valid';
	if (jQuery(import_step).length > 0) {
		window.location = jQuery(import_step).val();
	}
}

/**
 * Check if admin is on step 3 where we start imporing Donation from CSV via AJAX
 *
 * @since 2.1
 */
function give_start_importing_donations() {
	var import_step = 'body.give_forms_page_give-tools .give-tools-import-tab #give-import-donations-form table.step-3';
	if (jQuery(import_step).length > 0) {
		give_on_donation_import_ajax();
	}
}

/**
 * Check if admin is on step 2 and CSV is invalid
 *
 * @since 2.1
 */
function give_import_donation_csv_not_valid() {
	var import_step = 'body.give_forms_page_give-tools .give-tools-import-tab #give-import-donations-form table.step-2 .csv_not_valid';
	if (jQuery(import_step).length > 0) {
		window.location = jQuery(import_step).val();
	}
}

/**
 * Check if admin is on step 1 and csv is valid
 *
 * @since 2.1
 */
function give_import_donation_valid_csv() {
	var import_step = 'body.give_forms_page_give-tools .give-tools-import-tab #give-import-donations-form table.step-1 .is_csv_valid';
	if (jQuery(import_step).length > 0) {
		window.location = jQuery(import_step).val();
	}
}

/**
 * Upload CSV ajax
 *
 * @since 1.8.13
 */
function give_on_donation_import_ajax() {
	var $form = jQuery('form.tools-setting-page-import');

	/**
  * Do not allow user to reload the page
  *
  * @since 1.8.14
  */
	give_setting_edit = true;

	var progress = $form.find('.give-progress');

	var total_ajax = jQuery(progress).data('total_ajax'),
	    current = jQuery(progress).data('current'),
	    start = jQuery(progress).data('start'),
	    end = jQuery(progress).data('end'),
	    next = jQuery(progress).data('next'),
	    total = jQuery(progress).data('total'),
	    per_page = jQuery(progress).data('per_page');

	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: {
			action: Give.fn.getGlobalVar('give_donation_import'),
			total_ajax: total_ajax,
			current: current,
			start: start,
			end: end,
			next: next,
			total: total,
			per_page: per_page,
			fields: $form.serialize()
		},
		dataType: 'json',
		success: function success(response) {
			jQuery(progress).data('current', response.current);
			jQuery(progress).find('div').width(response.percentage + '%');

			if (response.next == true) {
				jQuery(progress).data('start', response.start);
				jQuery(progress).data('end', response.end);

				if (response.last == true) {
					jQuery(progress).data('next', false);
				}
				give_on_donation_import_ajax();
			} else {
				/**
     * Now user is allow to reload the page.
     *
     * @since 1.8.14
     */
				give_setting_edit = false;
				window.location = response.url;
			}
		},
		error: function error() {
			/**
    * Now user is allow to reload the page.
    *
    * @since 1.8.14
    */
			give_setting_edit = false;

			new __WEBPACK_IMPORTED_MODULE_0__plugins_modal__["GiveErrorAlert"]({
				modalContent: {
					title: Give.fn.getGlobalVar('import_failed'),
					desc: Give.fn.getGlobalVar('error_message'),
					cancelBtnTitle: Give.fn.getGlobalVar('ok')
				}
			}).render();
		}
	});
}

/**
 * Give Import donation run on load once page is load completed.
 */
function give_import_donation_onload() {
	window.onload = function () {
		give_import_donation_required_fields_check();
		give_import_donation_on_drop_down_change();
		give_start_importing_donations();
		give_import_donation_valid_csv();
		give_import_donation_csv_not_valid();
		give_on_core_settings_import_start();
		give_import_core_settings_json_is_valid();
	};
}

/**
 * Give import donation on change of drop down and update the required fields.
 */
function give_import_donation_on_drop_down_change() {
	var fields = document.querySelector('.give-tools-setting-page-import table.step-2 tbody select');
	if (fields !== 'undefined' && fields !== null) {
		jQuery('.give-tools-setting-page-import table.step-2 tbody').on('change', 'select', function () {
			give_import_donation_required_fields_check();
		});
	}
}

/**
 * Give Import Donations check required fields
 */
function give_import_donation_required_fields_check() {
	var required_fields = document.querySelector('.give-tools-setting-page-import table.step-2 .give-import-donation-required-fields');
	if (required_fields !== 'undefined' && required_fields !== null) {
		var submit = true,
		    email = false,
		    first_name = false,
		    amount = false,
		    form = false;

		document.querySelectorAll('.give-import-donation-required-fields li').forEach(function (value) {
			value.querySelector('.dashicons').classList.remove('dashicons-yes');
			value.querySelector('.dashicons').classList.add('dashicons-no-alt');
		});

		var select_fields = Array.from(document.querySelectorAll('table.step-2 tbody select')).map(function (field) {
			return field.value;
		});

		if (select_fields.includes('email')) {
			email = true;
			document.querySelector('.give-import-donation-required-email .dashicons').classList.remove('dashicons-no-alt');
			document.querySelector('.give-import-donation-required-email .dashicons').classList.add('dashicons-yes');
		}

		if (select_fields.includes('first_name')) {
			first_name = true;
			document.querySelector('.give-import-donation-required-first .dashicons').classList.remove('dashicons-no-alt');
			document.querySelector('.give-import-donation-required-first .dashicons').classList.add('dashicons-yes');
		}

		if (select_fields.includes('amount')) {
			amount = true;
			document.querySelector('.give-import-donation-required-amount .dashicons').classList.remove('dashicons-no-alt');
			document.querySelector('.give-import-donation-required-amount .dashicons').classList.add('dashicons-yes');
		}

		if (select_fields.includes('form_id') || select_fields.includes('form_title')) {
			form = true;
			document.querySelector('.give-import-donation-required-form .dashicons').classList.remove('dashicons-no-alt');
			document.querySelector('.give-import-donation-required-form .dashicons').classList.add('dashicons-yes');
		}

		if (email && first_name && amount && form) {
			submit = false;
		}

		document.getElementById('recount-stats-submit').disabled = submit;
	}
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// js/admin.js